/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'আমার ভিডিও শর্টস',
    see_more: 'আরও দেখুন',
    no_shorts_found: 'কোনো শর্টস পাওয়া যায়নি',
    shorts: 'শর্টস',
    general_information: 'সাধারণ তথ্য',
    gamification: 'গেমিফিকেশন',
    click_to_select_files: 'ফাইল নির্বাচন করতে ক্লিক করুন',
    selected_files: 'নির্বাচিত ফাইলসমূহ',
    uploaded: 'আপলোড হয়েছে',
    failed: 'ব্যর্থ হয়েছে',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'সিস্টেম স্বয়ংক্রিয়ভাবে বিশ্লেষণ করবে এবং আপনার সংস্থার লাইব্রেরি থেকে সামগ্রীর প্রয়োজনীয়তার উপর ভিত্তি করে সবচেয়ে প্রাসঙ্গিক ডকুমেন্ট নির্বাচন করবে।',
    select_from_library: 'লাইব্রেরি থেকে নির্বাচন করুন',
    search_document: 'ডকুমেন্ট খুঁজুন...',
    selected: 'নির্বাচিত',
    loading_documents: 'ডকুমেন্ট লোড হচ্ছে...',
    review_generated_content: 'উত্পন্ন সামগ্রী পর্যালোচনা করুন',
    confirm_and_replace_content: 'সামগ্রী নিশ্চিত করুন এবং প্রতিস্থাপন করুন',
    the_generate_content_will_replace:
      'উত্পন্ন সামগ্রী নির্বাচিত পাতার বিদ্যমান টেক্সট প্রতিস্থাপন করবে। আপনি যদি এই পরিবর্তনগুলি প্রয়োগ করতে না চান, তবে আপনি পূর্ববর্তী ধাপে ফিরে যেতে পারেন।',
    pages_to_be_updated: 'আপডেট করার জন্য পৃষ্ঠা',
    generated_revisions: 'উত্পন্ন সংশোধন',
    lesson_preview: 'পাঠের প্রিভিউ',
    create_new_folder: 'নতুন ফোল্ডার তৈরি করুন',
    rename_item: 'আইটেমের নাম পরিবর্তন করুন',
    enter_folder_name: 'ফোল্ডারের নাম লিখুন:',
    enter_new_name: 'নতুন নাম লিখুন:',
    folder_name: 'ফোল্ডারের নাম:',
    new_name: 'নতুন নাম',
    move_items: 'আইটেম সরান',
    copy_items: 'আইটেম কপি করুন',
    move_here: 'এখানে সরান',
    copy_here: 'এখানে কপি করুন',
    select_destination_library_and_folder:
      'গন্তব্য লাইব্রেরি এবং ফোল্ডার নির্বাচন করুন:',
    items_selected: 'নির্বাচিত আইটেমসমূহ',
    version: 'সংস্করণ',
    modified_by: 'পরিবর্তন করেছেন',
    size: 'আকার',
    restore: 'পুনরুদ্ধার',
    are_you_sure_you_want_to_restore_this_version:
      'আপনি কি নিশ্চিত যে এই সংস্করণটি পুনরুদ্ধার করতে চান?',
    this_will_replce_the_current_version_with_the_selected_one:
      'এটি বর্তমান সংস্করণটি নির্বাচিত সংস্করণ দ্বারা প্রতিস্থাপন করবে।',
    restore_this_version: 'এই সংস্করণটি পুনরুদ্ধার করুন',
    restore_not_available: 'পুনরুদ্ধার উপলব্ধ নয়',
    version_history: 'সংস্করণ ইতিহাস:',
    by_making_items_public:
      'আইটেমগুলোকে পাবলিক করলে, সেগুলো সকলের জন্য দৃশ্যমান হবে। অনুগ্রহ করে শর্তাবলী পড়ুন।',
    the_selected_items_will_be_copied:
      'নির্বাচিত আইটেমগুলো আপনার পাবলিক লাইব্রেরিতে কপি করা হবে এবং সকলের জন্য দৃশ্যমান হবে।',
    the_selected_items_will_be_copied_to_org:
      'নির্বাচিত আইটেমগুলো আপনার সংস্থার লাইব্রেরিতে কপি করা হবে এবং সকল সংস্থার সদস্যের জন্য দৃশ্যমান হবে।',
    the_selected_items_will_be_copied_to_your_private:
      'নির্বাচিত আইটেমগুলো আপনার প্রাইভেট লাইব্রেরিতে কপি করা হবে এবং কেবল আপনিই তা দেখতে পারবেন।',
    loading_organization: 'সংস্থার ব্যবহারকারীদের লোড করা হচ্ছে...',
    click_download_to_view: 'দেখার জন্য ডাউনলোড ক্লিক করুন',
    archive_file: 'আর্কাইভ ফাইল',
    no_preview_available: 'প্রিভিউ উপলব্ধ নয়',
    audit_report: 'অডিট রিপোর্ট',
    audit_type: 'ক্রিয়ার ধরন',
    i_agree_to_the_terms_and_conditions: 'আমি শর্তাবলীর সাথে একমত',
    this_file_is_indexed_for_ai: 'এই ফাইলটি AI-এর জন্য সূচীকৃত',
    file_is_not_indexed_for_ai: 'ফাইলটি AI-এর জন্য সূচীকৃত নয়',
    no_users_found: 'কোনো ব্যবহারকারী পাওয়া যায়নি',
    no_users_available: 'কোনো ব্যবহারকারী উপলব্ধ নেই',
    add_people: 'ব্যক্তি যোগ করুন',
    people: 'ব্যক্তি',
    access_type: 'অ্যাক্সেস টাইপ',
    no_group_found: 'কোনো গ্রুপ পাওয়া যায়নি',
    add_group: 'গ্রুপ যোগ করুন',
    groups: 'গ্রুপসমূহ',
    users_top: 'ব্যবহারকারী',
    confirm_delete: 'মুছে ফেলার নিশ্চয়তা',
    do_you_want_remove: 'আপনি কি নিশ্চিত যে মুছতে চান',
    form_this_documents_permissions: 'এই ডকুমেন্টের অনুমতিগুলি থেকে?',
    no_users_found_in_this_group: 'এই গ্রুপে কোনো ব্যবহারকারী পাওয়া যায়নি',
    add_selected_users: 'নির্বাচিত ব্যবহারকারী যোগ করুন',
    choose_users_from_the_list: 'তালিকা থেকে ব্যবহারকারী নির্বাচন করুন',
    selected_users: 'নির্বাচিত ব্যবহারকারী',
    archived: 'আর্কাইভ করা হয়েছে',
    request_approval: 'অনুমোদনের অনুরোধ',
    document_in_review: 'ডকুমেন্ট পর্যালোচনাধীন',
    approve: 'অনুমোদন',
    reject: 'বাতিল',
    comment: 'মন্তব্য:',
    enter_your_commit: 'আপনার মন্তব্য লিখুন...',
    confirm_cancel: 'বাতিল নিশ্চিত করুন',
    upload_3d_zip: '3D জিপ আপলোড করুন',
    delete_items: 'আইটেম মুছুন',
    video_upload_request: 'ভিডিও আপলোড অনুরোধ',
    reject_video: 'ভিডিও বাতিল করুন',
    enter_rejection_reason: 'বাতিলের কারণ লিখুন...',
    please_provide_a_reason_for_reejection_this_video:
      'এই ভিডিও বাতিল করার কারণ দিন:',
    generate_trivia_with_ai: 'AI দিয়ে ট্রিভিয়া তৈরি করুন',
    select_category: 'বিষয় নির্বাচন করুন:',
    number_of_question: 'প্রশ্নের সংখ্যা',
    generated_questions: 'উত্পন্ন প্রশ্নসমূহ',
    this_will_clear_all_generate_question:
      'এটি সমস্ত উত্পন্ন প্রশ্ন মুছে দেবে। চলতে চান?',
    sure_delete: 'আপনি কি নিশ্চিত যে মুছতে চান?',
    delete_this_question: 'আপনি কি নিশ্চিত যে এই প্রশ্নটি মুছতে চান?',
    loading_quiz: 'কুইজ লোড হচ্ছে...',
    creteing_file: 'ফাইল তৈরি হচ্ছে',
    opening_desktop_app: 'ডেস্কটপ অ্যাপ খুলছে',
    this_folder_is_empty: 'এই ফোল্ডারটি খালি',
    select_a_competition: 'একটি প্রতিযোগিতা নির্বাচন করুন...',
    activity_badges: 'অ্যাক্টিভিটি ব্যাজ',
    awarded_every_badges: 'প্রদত্ত প্রতি 4, 8, 16, 32, 64, 128, 256, 512 লগইন',
    learning_badges: 'লার্নিং ব্যাজ',
    awarded_every_courses:
      'প্রদত্ত প্রতি 1, 4, 8, 16, 32, 64, 128 সম্পন্ন কোর্স',
    test_badges: 'টেস্ট ব্যাজ',
    awarded_every_passes_tests:
      'প্রদত্ত প্রতি 2, 4, 8, 16, 32, 64, 128, 256 পাস করা টেস্ট',
    assignment_badges: 'অ্যাসাইনমেন্ট ব্যাজ',
    awarded_every_passed_assignments:
      'প্রদত্ত প্রতি 1, 2, 4, 8, 16, 32, 64, 128 সম্পন্ন অ্যাসাইনমেন্ট',
    perfectionism_badges: 'পারফেকশনিজম ব্যাজ',
    awarded_every_assignments_with_scrore:
      'প্রদত্ত প্রতি 1, 2, 4, 8, 16, 32, 64, 128 পরীক্ষা বা অ্যাসাইনমেন্ট 90%+ স্কোর সহ',
    communication_badges: 'কমিউনিকেশন ব্যাজ',
    awarded_every_topics_or_comments:
      'প্রদত্ত প্রতি 2, 4, 8, 16, 32, 64, 128, 256 টপিক বা কমেন্ট',
    certification_badges: 'সার্টিফিকেশন ব্যাজ',
    awarded_every_certificates:
      'প্রদত্ত প্রতি 1, 2, 4, 8, 16, 32, 64, 128 সার্টিফিকেট',
    level_name: 'লেভেল নাম',
    delete_competition: 'প্রতিযোগিতা মুছুন',
    this_week: 'এই সপ্তাহ',
    this_year: 'এই বছর',
    make_organization: 'সংস্থা তৈরি করুন',
    no_results_found: 'কোনো ফলাফল পাওয়া যায়নি',
    no_items_available: 'কোনো আইটেম নেই',
    help_video: 'হেল্প ভিডিও',
    select_a_video_from_the_list:
      'শেখা শুরু করতে তালিকা থেকে একটি ভিডিও নির্বাচন করুন'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'ফাইল আপলোড করতে ড্রপ করুন এবং গন্তব্য নির্বাচন করুন।',
    duplicate_lessoon: 'এই লেসনটি ইতিমধ্যেই কোর্সে আছে',
    skill_rule_title: 'দয়া করে স্কিল জার্নির শিরোনাম লিখুন',
    imageCreatorTitle: 'ছবি নির্মাতা',
    isTranslated: 'অনূদিত হয়েছে',
    translationCourseDesc:
      'এই কোর্সের অনুবাদ হতে কিছু সময় লাগতে পারে। ধৈর্যের জন্য ধন্যবাদ!',
    translateCourseTip:
      'মুল কোর্স থেকে স্বাধীন সম্পাদনার জন্য অনুবাদ কোর্স তৈরি করা হবে। সব লেসন এবং পেজ অন্তর্ভুক্ত থাকবে।',
    translateModalBtn: 'অনুবাদ করুন',
    translationSuccess: '“<0/>” কোর্স সফলভাবে অনূদিত হয়েছে!',
    translatingCourse: 'কোর্স অনুবাদ করা হচ্ছে...',
    translateModalTitle: 'কোর্স অনুবাদ করুন',
    translateSelectLang: 'ভাষা নির্বাচন করুন',
    fileDeleteconfirm:
      'আপনি কি নিশ্চিত যে আপনি এই ফাইলটি মুছে ফেলতে চান? এই কাজ অপরিবর্তনীয়।',
    fileDeleteMessage: 'ফাইল সফলভাবে মুছে ফেলা হয়েছে।',
    fileDeleteFailedMessage: 'ফাইল মুছে ফেলতে ব্যর্থ হয়েছে!',
    fileDelete: 'এই ফাইলটি মুছে ফেলুন।',
    certificate_save_btn: 'সার্টিফিকেট যোগ করুন',
    maze_path_info: 'গ্রাফে কোন পথ পাওয়া যায়নি!',
    file_size_mb: 'ফাইল সাইজ ২৫ এমবির নিচে হতে হবে!',
    reports: {
      products: 'পণ্যসমূহ',
      users: 'ব্যবহারকারীরা',
      ph_username: 'ব্যবহারকারীর নাম অনুসন্ধান করুন',
      ph_id: 'ব্যবহারকারীর আইডি নম্বর অনুসন্ধান করুন',
      ph_email: 'ব্যবহারকারীর ইমেইল অনুসন্ধান করুন'
    },
    select_upload_section_id: 'ফাইলের সেকশন বাধ্যতামূলক',
    tags_all: 'সব',
    delete_file_confirm: 'আপনি কি নিশ্চিত যে আপনি এই ফাইলটি মুছে ফেলতে চান?',
    delete_file_title: 'ফাইল মুছুন',
    tooltip_publish: 'নির্বাচিত অপশন দিয়ে কোর্স প্রকাশ করুন',
    tooltip_save: 'বর্তমান আপডেটগুলি দিয়ে কোর্স সংরক্ষণ করুন',
    tooltip_next: 'পরবর্তী কোর্স সেটিংসে যান',
    tooltip_finish: 'বর্তমান আপডেট সম্পন্ন করুন এবং সংরক্ষণ করুন',
    stories_modal: {
      title_upload: 'স্টোরি আপলোড করুন',
      title_update: 'স্টোরি আপডেট করুন',
      title_audio: 'স্টোরি অডিও ফাইল',
      btn_upload: 'আপলোড',
      btn_update: 'আপডেট',
      btn_close: 'বন্ধ করুন',
      btn_cancel: 'বাতিল করুন',
      lbl_cover: 'স্টোরি কভার ইমেজ',
      rule_cover: 'স্টোরির অডিও কভার আপলোড করুন!',
      lbl_title: 'স্টোরি অডিও শিরোনাম',
      rule_title: 'স্টোরি অডিও শিরোনাম লিখুন!',
      lbl_description: 'স্টোরি অডিও বর্ণনা',
      rule_description: 'স্টোরি অডিও বর্ণনা লিখুন!',
      lbl_file: 'স্টোরি অডিও ফাইল আপলোড করুন',
      rule_file: 'স্টোরি অডিও ফাইল আপলোড করুন!',
      rule_file_type: 'বৈধ স্টোরি অডিও ফাইল আপলোড করুন!',
      lbl_select_file: 'স্টোরি অডিও ফাইল নির্বাচন করুন',
      msg_valid_file: 'বৈধ স্টোরি অডিও ফাইল নির্বাচন করুন!',
      msg_success: 'স্টোরি অডিও ফাইল সফলভাবে আপলোড হয়েছে',
      msg_failed: 'মিডিয়া ডেটা বরাদ্দ ব্যর্থ হয়েছে!',
      msg_error: 'ফাইল আপলোড করার সময় ত্রুটি ঘটেছে!'
    },
    audio_modal: {
      title_upload: 'আপলোড',
      title_update: 'আপডেট',
      title_audio: 'অডিও ফাইল',
      btn_upload: 'আপলোড',
      btn_update: 'আপডেট',
      btn_close: 'বন্ধ করুন',
      btn_cancel: 'বাতিল করুন',
      lbl_cover: 'অডিও কভার',
      rule_cover: 'অডিও কভার আপলোড করুন!',
      lbl_title: 'অডিও শিরোনাম',
      rule_title: 'অডিও শিরোনাম লিখুন!',
      lbl_description: 'অডিও বর্ণনা',
      rule_description: 'অডিও বর্ণনা লিখুন!',
      lbl_file: 'অডিও ফাইল আপলোড করুন',
      rule_file: 'অডিও ফাইল আপলোড করুন!',
      rule_file_type: 'বৈধ অডিও ফাইল আপলোড করুন!',
      lbl_select_file: 'অডিও ফাইল নির্বাচন করুন',
      msg_valid_file: 'বৈধ অডিও ফাইল নির্বাচন করুন!',
      msg_success: 'অডিও ফাইল সফলভাবে আপলোড হয়েছে',
      msg_failed: 'মিডিয়া ডেটা বরাদ্দ ব্যর্থ হয়েছে!',
      msg_error: 'ফাইল আপলোড করার সময় ত্রুটি ঘটেছে!'
    },
    info_episode: 'এপিসোডের কভার ছবি।',
    btn_delete_episode: 'এই পডকাস্ট এপিসোড মুছুন।',
    btn_edit_marketplace: 'মার্কেটপ্লেস বিস্তারিত সম্পাদনা করুন।',
    btn_save_marketplace: 'বর্তমান পরিবর্তন সংরক্ষণ করুন।',
    btn_ai_podcast: 'এআই চালিত পডকাস্ট এপিসোড তৈরি করুন।',
    btn_upload_podcast: 'নিজের পডকাস্ট অডিও এপিসোড আপলোড করুন।',
    attach_file: 'ফাইল আপলোড করে আরো কন্টেন্ট আপনার দর্শকদের সাথে শেয়ার করুন',
    fileDownload: 'এই ফাইলটি ডাউনলোড করুন।',
    singleEpishode: 'এপিসোড',
    podcast_music: 'পডকাস্ট, মিউজিক & স্টোরিজ',
    publishHeader: 'পডকাস্ট, মিউজিক & স্টোরিজ প্রকাশ করুন',
    editHeader: 'পডকাস্ট, মিউজিক & স্টোরিজ সম্পাদনা করুন',
    createHeader: 'পডকাস্ট, মিউজিক & স্টোরিজ তৈরি করুন',
    marketplaceHeader: 'পডকাস্ট, মিউজিক & স্টোরি মার্কেটপ্লেস বিস্তারিত',
    message_marketplace: 'মার্কেটপ্লেস ফর্ম পূরণ করুন!',
    create_podcast_live: 'লাইভ পডকাস্ট ও মিউজিক',
    create_podcast_custom: 'কাস্টম পডকাস্ট ও মিউজিক',
    create_podcast_stories: 'স্টোরিজ',
    ai_Assisted_podcast_reation: 'এআই সহায়ক পডকাস্ট ও মিউজিক',
    publishTitle:
      'পডকাস্ট, মিউজিক & স্টোরিজ প্রকাশ করুন ও বিশ্বব্যাপী শেয়ার করুন।',
    customButton: 'কাস্টম তৈরি',
    customTitle: 'পডকাস্টে করা পরিবর্তনগুলি সংরক্ষণ করুন।',
    updateButton: 'আপডেট',
    createButton: 'তৈরি করুন',
    createNewButton: 'নতুন তৈরি',
    updateTitle: 'বর্তমান পডকাস্ট, মিউজিক & স্টোরিজের বিস্তারিত আপডেট করুন।',
    createTitle: 'নতুন পডকাস্ট, মিউজিক & স্টোরিজ তৈরি করুন।',
    createNewTitle:
      'বর্তমান পডকাস্ট, মিউজিক & স্টোরিজের নতুন ইনপুট দিয়ে নতুন পডকাস্ট, মিউজিক & স্টোরিজ তৈরি হবে।',
    podcastTitle: 'এপিসোড তালিকা',
    podcastStoryTitle: 'স্টোরি এপিসোড তালিকা',
    podcastToolTipTitle: 'পডকাস্ট এপিসোড তালিকা',
    uploadAudio: 'আপলোড',
    aiAudio: 'এআই অডিও',
    emptyPodcast: 'এখনও কোন পডকাস্ট, মিউজিক & স্টোরি রেকর্ডিং নেই।',
    emptyStoriesPodcast: 'এখনও কোন স্টোরি যোগ করা হয়নি।',
    emptyCreatePodcast: 'অডিও যোগ করতে পডকাস্ট তৈরি করুন।',
    playPodcast: 'নির্বাচিত পডকাস্ট, মিউজিক & স্টোরি প্লে করুন।',
    pausePodcast: 'নির্বাচিত পডকাস্ট, মিউজিক & স্টোরি বিরতি দিন।',
    selectPodcast: 'এই পডকাস্ট, মিউজিক & স্টোরি নির্বাচন করুন।',
    downloadPodcast: 'এই অডিওটি ডাউনলোড করুন।',
    uploadAudioFile: 'নতুন অডিও আপলোড করে বর্তমান অডিও পরিবর্তন করুন।',
    deleteConfirm: 'আপনি কি এই অডিও মুছে ফেলতে চান?',
    roomName: 'পডকাস্ট নাম',
    addGuestTitle: 'গেস্ট স্পীকার যোগ করুন',
    showTime: 'দেখানোর সময়',
    startTime: 'শুরু সময়',
    endTime: 'শেষ সময়',
    erorMsgImg: 'বৈধ ছবি নির্বাচন করুন।',
    failedMsgImg: 'ছবি লোড করতে ব্যর্থ হয়েছে, দয়া করে আবার চেষ্টা করুন!',
    failedMsgUpload: 'কভার ইমেজ আপলোড করতে ব্যর্থ হয়েছে!',
    btnCoverUpload: 'কভার আপলোড করুন',
    is_private: 'বেসরকারি',
    to_attach: 'ফাইল সংযুক্ত করুন',
    file_attached: 'সংযুক্ত ফাইল(গুলি)',
    main_event: 'প্রধান ইভেন্ট',
    event: 'ইভেন্টস',
    upload_pdf: 'পিডিএফ আপলোড করুন',
    portrait: 'পোর্ট্রেট',
    landscape: 'ল্যান্ডস্কেপ',
    import_from_library: 'মিডিয়া লাইব্রেরি থেকে টেক্সট আমদানি করুন',
    question_answer_ai: 'প্রশ্ন/উত্তর AI',
    take_maze: 'মেটামেজ নিন',
    training: 'প্রশিক্ষণ',
    select_transcribe_locale: 'ট্রান্সক্রাইব করার ভাষা নির্বাচন করুন',
    transcribe_limit: 'দয়া করে ট্রান্সক্রাইব মিনিট ইনপুট করুন',
    not_complete: 'মার্কেটপ্লেস তথ্য সম্পূর্ণ নয়',
    complete: 'মার্কেটপ্লেস তথ্য সম্পূর্ণ',
    not_admin: 'মার্কেটপ্লেসে প্রকাশ করতে প্রশাসক বিশেষাধিকার প্রয়োজন',
    no_course: 'মার্কেটপ্লেস সক্ষম করতে শিরোনাম এবং একটি ছবি নির্বাচন করুন',
    scorm_not_complete:
      'SCORM ফাইল আপলোড করতে শিরোনাম এবং একটি ছবি নির্বাচন করুন',
    not_found_maze: 'মেটামেজ পাওয়া যায়নি',
    email_require: 'ইমেইল প্রয়োজন',
    poll_required: 'পোল ডেটা প্রয়োজন',
    alert: 'সতর্কতা!',
    warning: 'সতর্কবাণী!',
    ok: 'ঠিক আছে',
    cancel: 'বাতিল করুন',
    done: 'সম্পন্ন',
    insert: 'সন্নিবেশ করুন',
    private: 'বেসরকারি',
    public: 'সর্বজনীন',
    no_connection: 'ইন্টারনেট সংযোগ হারানো হয়েছে',
    switch: 'সুইচ',
    share_screen: 'স্ক্রিন শেয়ার করুন',
    stop_share_screen: 'স্ক্রিন শেয়ার বন্ধ করুন',
    share_screen_with_camera: 'ক্যামেরা সহ স্ক্রিন শেয়ার করুন',
    stop_share_screen_with_camera: 'ক্যামেরা সহ স্ক্রিন শেয়ার বন্ধ করুন',
    camera_on: 'ক্যামেরা চালু',
    camera_off: 'ক্যামেরা বন্ধ',
    mic_on: 'আনমিউট',
    mic_off: 'মিউট',
    fullscreen: 'পূর্ণ পর্দা',
    live_now: 'লাইভ এখন',
    schedule_on: 'অনুসূচি করুন',
    organisations: 'সংস্থা',
    org_groups: 'সংস্থা গ্রুপ',
    specific_user: 'নির্দিষ্ট ব্যবহারকারী',
    gif: 'GIF',
    unavailable: 'অনুপলব্ধ',
    yes: 'হ্যাঁ',
    no: 'না',
    event_duration_message: 'সর্বোচ্চ ৩০০ মিনিট (৫ ঘন্টা)',
    send_email: 'ই-মেইল নোটিফিকেশন পাঠান',
    admin_only: 'শুধুমাত্র প্রশাসক',
    join: 'যোগদান করুন',
    leave: 'ছাড়ুন',
    share: 'শেয়ার করুন',
    share_text:
      'আপনি যাদের সাথে এই ফাইল শেয়ার করতে চান তাদের ইমেইল ঠিকানা টাইপ করুন।',
    share_text_title: 'PDF শেয়ার করুন',
    share_text_title_txt: 'টেক্সট শেয়ার করুন',
    select_users: 'ব্যবহারকারী নির্বাচন করুন',
    delete: 'মুছুন',
    attachment_event: 'ইভেন্টের জন্য সংযুক্তি:',
    transcribe_limit: 'ট্রান্সক্রাইব মিনিট',
    monthly_transcribe: 'মাসিক ট্রান্সক্রাইব সীমা:',
    enable_ai: 'AI সক্ষম করুন:',
    enable_maze: 'মেটামেজ সক্ষম করুন:',
    media_service: 'মিডিয়া সার্ভিস',
    allow_others: 'অন্যদের সম্পাদনার অনুমতি দিন',
    join_breakout_room: 'ব্রেকআউট রুমে যোগ দিন',
    bio: 'জীবনী',
    linkedin: 'লিঙ্কডইন',
    select_org_report: 'রিপোর্ট তৈরি করতে একটি প্রতিষ্ঠান নির্বাচন করুন।',
    org_image_not_found: 'ছবি পাওয়া যায়নি',
    insert_text: 'টেক্সট সন্নিবেশ করুন',
    insert_question_answer: 'প্রশ্ন/উত্তর AI',
    modal_title2: 'টেক্সট গ্যালারি',
    my_text_library: 'আমার টেক্সট লাইব্রেরি',
    ai: 'AI',
    public_text_library: 'সর্বজনীন টেক্সট লাইব্রেরি',
    organization_text_library: 'সংস্থা টেক্সট লাইব্রেরি',
    no_transcribed_text: 'কোনো ট্রান্সক্রাইব করা টেক্সট পাওয়া যায়নি',
    public_text_not_found: 'সর্বজনীন ট্রান্সক্রাইব টেক্সট পাওয়া যায়নি',
    org_text_not_found: 'সংস্থা ট্রান্সক্রাইব টেক্সট পাওয়া যায়নি',
    org_video_not_found: 'ভিডিও পাওয়া যায়নি',
    canva: 'Canva থেকে করুন',
    canva_open: 'Canva এডিটর খুলতে এখানে ক্লিক করুন।',
    pdf: 'পিডিএফ',
    txt: 'টেক্সট',
    human: 'প্রিমিয়াম',
    shared_file: 'আপনার ফাইল সফলভাবে শেয়ার হয়েছে।',
    error_shared_file:
      'ফাইল শেয়ার করতে সমস্যা হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।',
    publish: 'প্রকাশ করুন',
    maze_scenes: 'মেটামেজ দৃশ্য',
    pexel_images: 'পেক্সেল ছবি',
    group: 'গ্রুপ',
    group_name: 'গ্রুপের নাম',
    select_group: 'গ্রুপ নির্বাচন করুন',
    search_maze: 'মেটামেইজ খুঁজুন',
    hosts: 'হোস্টস',
    avg_score: 'গড় স্কোর (%)',
    maze_report: 'মেটামেইজ প্রতিবেদন',
    maze_view: 'মেটামেইজ ভিউ',
    title_maze: 'মেটামেইজ',
    author: 'লেখক',
    match: 'পাথ মিল',
    preview_mazeTitle: 'শিরোনাম: ',
    other: 'অন্যান্য',
    total: 'মোট',
    report_course: 'কোর্স',
    report_courses: 'কোর্সসমূহ',
    report_event: 'ইভেন্ট',
    report_events: 'ইভেন্টসমূহ',
    report_maze: 'মেটামেইজ',
    report_personalize_learning: 'ব্যক্তিগতকৃত শেখা',
    report_live_assessment: 'লাইভ মূল্যায়ন',
    report_live_assessments: 'লাইভ মূল্যায়নসমূহ',
    report_skill_journey: 'দক্ষতা যাত্রা',
    skill_journey: 'দক্ষতা যাত্রা',
    skill_journeys: 'দক্ষতা যাত্রাসমূহ',
    date: 'তারিখ: ',
    search_people: 'মানুষ খুঁজুন',
    passed: 'উত্তীর্ণ',
    failed: 'ব্যর্থ',
    item: 'আইটেম',
    type: 'ধরন',
    minimum_pass_score: 'ন্যূনতম পাশ নম্বর',
    resources_count: 'রিসোর্সের সংখ্যা',
    back: 'ফিরে যান',
    resources: 'রিসোর্সসমূহ',
    time_spent: 'সময় ব্যয় (মিনিট)',
    detail: 'বিস্তারিত',
    watched_time_mins: 'দেখার সময় (মিনিট)',
    personalize_learning: 'ব্যক্তিগতকৃত শেখা',
    result: 'ফলাফল',
    assessment_title: 'শিরোনাম',
    marketPlace_graph: 'মার্কেটপ্লেস গ্রাফ',
    attachments: 'অতিরিক্ত সংযুক্তি',
    new_scorm_course: 'নতুন SCORM কোর্স আপলোড করুন',
    upload_scorm_course: 'SCORM কোর্স আপলোড করুন',
    new_maze: 'নতুন মেটামেইজ তৈরি করুন',
    new_skill_journey: 'নতুন দক্ষতা যাত্রা তৈরি করুন',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'দক্ষতা যাত্রা',
    new_discussion_room: 'নতুন পডকাস্ট তৈরি করুন',
    title: 'আজ আপনি কী করতে চান?',
    build_course: 'আমার কোর্স তৈরি করুন',
    live_broadcast: 'লাইভ সম্প্রচার',
    invite_users: 'আমার সংগঠনে ব্যবহারকারীদের আমন্ত্রণ জানান',
    build_voice_over: 'আমার ভয়েসওভার তৈরি করুন',
    view_reports: 'প্রতিবেদন দেখুন',
    upload_media: 'আমার মিডিয়া বা কাজ আপলোড করুন এবং ভাগ করুন',
    main_menu: 'প্রধান মেনু',
    get_started: 'শুরু করুন',
    search_group: 'সংগঠন গ্রুপ খুঁজুন',
    ai_course: 'এআই কোর্স',
    search_user: 'কোম্পানির নাম খুঁজুন',
    no_maze: 'বর্তমানে কোনো মেটামেইজ নেই।',
    conference_event_title: 'কনফারেন্স ইভেন্টসমূহ',
    conference_event_subTitle: 'সমাপ্ত কনফারেন্স ইভেন্টসমূহ',
    conference_event: 'বর্তমানে কোনো কনফারেন্স ইভেন্ট নেই।',
    no_skill: 'বর্তমানে কোনো দক্ষতা যাত্রা নেই।',
    no_podcast: 'বর্তমানে কোনো পডকাস্ট নেই।',
    maze_channel: 'মেটামেইজ',
    past_live_assessment: 'পূর্ববর্তী লাইভ মূল্যায়নসমূহ',
    no_live_assessment: 'বর্তমানে কোনো লাইভ মূল্যায়ন নেই।',
    enrolled_courses: 'কোর্সসমূহ',
    my_video_channel: 'আমার ভিডিও চ্যানেলসমূহ',
    enrolled_liveEvents: 'লাইভ ইভেন্টসমূহ',
    sharebot: 'শেয়ারবট',
    selected_language: 'নির্বাচিত ভাষা',
    shareSphere_game: 'শেয়ারস্ফিয়ার গেম',
    maze: 'মেটামেইজ',
    skill: 'দক্ষতা যাত্রা',
    channel: 'চ্যানেল',
    order: 'ক্রম',
    is_record: 'রেকর্ড',
    no_maze_found: 'কোনো মেটামেইজ পাওয়া যায়নি।',
    maze_self_limit_reached: 'মেটামেইজ সেলফ অ্যাসেসমেন্ট সীমা অতিক্রম করেছে।',
    metamaze_two_times: 'আপনি ইতিমধ্যে এই মেটামেইজ ২ বার সম্পন্ন করেছেন।',
    metamaze_two_times_no_result:
      'আপনি ইতিমধ্যে এই মেটামেইজ ২ বার সম্পন্ন করেছেন। দ্বিতীয়বারের পর এই সেলফ অ্যাসেসমেন্টের ফলাফল সংরক্ষিত হবে না।',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'পাস করার জন্য সর্বনিম্ন নম্বর',
    organization: 'একটি সংগঠন নির্বাচন করুন',
    pass_score_mark: 'অনুগ্রহ করে ১ থেকে ১০০ এর মধ্যে নম্বর লিখুন',
    maze_cloning_success: 'মেটামেইজ "<0/>" সফলভাবে ক্লোন করা হয়েছে!',
    create_certificate: 'সার্টিফিকেট তৈরি করুন',
    create_badge: 'ব্যাজ তৈরি করুন',
    certificate_added: 'সার্টিফিকেট যুক্ত হয়েছে।',
    badge_added: 'ব্যাজ যুক্ত হয়েছে।',
    certificate_warning:
      'সার্টিফিকেট/ব্যাজ একবার প্রকাশিত হলে আর সম্পাদনা করা যাবে না!',
    created_course_plan:
      'আপনার তৈরি করা কোর্স সম্পাদনা করুন এবং লাইভ ইভেন্ট নির্ধারণ করুন',
    market_place_space: 'মার্কেটপ্লেস',
    select_course_language: 'ভাষা নির্বাচন করুন (ঐচ্ছিক)',
    select_language: 'ভাষা নির্বাচন করুন',
    file_upload: 'ফাইল আপলোড',
    text: 'এখানে লিখুন…',
    attempts_count: 'ব্যবহারকারী কতবার পুনরায় চেষ্টা করতে পারবে',
    no_of_people_placeholder: 'ব্যক্তির সংখ্যা',
    back_to_maze: 'মেটামেইজ দৃশ্যে ফিরে যান',
    edit_maze: 'মেটামেইজ সম্পাদনা করুন',
    wait: 'অপেক্ষা করুন...',
    retry: 'পুনরায় চেষ্টা করুন',
    publish_scorm_course: 'আপনার SCORM কোর্স প্রকাশ করুন',
    publish_maze: 'আপনার মেটামেইজ প্রকাশ করুন',
    import: 'উপাদান আমদানি করুন',
    answer_correct: 'সঠিক উত্তর নির্বাচন করুন',
    author_name: `দয়া করে লেখকের নাম লিখুন`,
    select_category: 'দয়া করে একটি বিভাগ নির্বাচন করুন',
    course_outline: 'দয়া করে কোর্সের রূপরেখা লিখুন',
    course_obj: 'দয়া করে কোর্সের উদ্দেশ্য লিখুন',
    course_description: 'দয়া করে কোর্সের বিবরণ লিখুন',
    maze_outline: 'দয়া করে মেজের রূপরেখা লিখুন',
    maze_obj: 'দয়া করে মেজের উদ্দেশ্য লিখুন',
    maze_description: 'দয়া করে মেজের বিবরণ লিখুন',
    lessons: 'দয়া করে পাঠের সংখ্যা লিখুন',
    user_email_require: `ব্যবহারকারীর ইমেইল আবশ্যক`,
    team_size: `টিমের আকার আবশ্যক`,
    enter_price: 'দয়া করে একটি মূল্য লিখুন (৫ বা তার বেশি)',
    input_title_maze: 'দয়া করে মেজের শিরোনাম লিখুন',
    trainer_bio: 'দয়া করে প্রশিক্ষকের জীবনবৃত্তান্ত লিখুন',
    trainer_linkedin: 'দয়া করে প্রশিক্ষকের LinkedIn লিখুন',
    error_video: 'দয়া করে ভিডিওর সংখ্যা লিখুন',
    input_video_link: 'দয়া করে ভিডিও লিঙ্ক লিখুন',
    number_of_video: 'ভিডিওর সংখ্যা',
    number_of_lessions: 'পাঠের সংখ্যা',
    no_of_people_in_conference: 'সন্মেলনে কতজন মানুষ আছে?',
    transcribe_settings: 'ট্রান্সক্রাইব সেটিংস',
    transcribe: 'ট্রান্সক্রাইব',
    cloning_maze: 'মেটামেজ ক্লোন করা হচ্ছে...',
    id_number: 'আইডি নম্বর',
    timezone: 'টাইম জোন',
    edit_maze: 'সম্পাদনা',
    delete_maze: 'মুছুন',
    view_maze: 'দেখুন',
    create_metamaze: 'মেটামেজ তৈরি করুন',
    metamaze_scenario: 'মেটামেজ পরিস্থিতি',
    publish_metamaze: 'প্রকাশের সেটিং',
    search_result: 'অনুসন্ধানের ফলাফল:',
    search_for: 'অনুসন্ধান করুন',
    search_no_result: '- কোন ফলাফল পাওয়া যায়নি !',
    channel_no_available: 'কোন চ্যানেল উপলব্ধ নেই !',
    this_card: 'এটি একটি কার্ড',
    course_no_available: 'কোন কোর্স উপলব্ধ নেই !',
    exit_fullscreen: 'ফুল স্ক্রিন থেকে বের হন',
    bg_image: 'ব্যাকগ্রাউন্ড ছবি',
    introduction: 'পরিচিতি',
    summary: 'সারাংশ',
    generate_introduction: 'পরিচিতি তৈরি করুন',
    generate_summary: 'সারাংশ তৈরি করুন',
    bullet_points: 'বুলেট পয়েন্ট',
    title_simulation: 'দয়া করে সিমুলেশন নাম লিখুন',
    view_generated_images: 'তৈরি করা ছবি দেখুন',
    image_transparency: 'ছবির স্বচ্ছতা',
    template_bg_color: 'টেমপ্লেট ব্যাকগ্রাউন্ড রঙ',
    select_template_layout: 'টেমপ্লেট লেআউট নির্বাচন করুন',
    reload_template: '(টেমপ্লেটগুলি পুনরায় লোড করুন)',
    are_you_sure_want_close: 'আপনি কি নিশ্চিত যে আপনি বন্ধ করতে চান?',
    all_your_changes_will_be_lost: 'আপনার সমস্ত পরিবর্তন হারিয়ে যাবে।',
    please_checked_before_generated_video:
      'ভিডিও তৈরি করার আগে অনুগ্রহ করে সমস্ত শর্ত পরীক্ষা করুন।',
    voice_must_be_selected: 'একটি ভয়েস নির্বাচন করা আবশ্যক',
    avatar_must_be_selected: 'একটি অবতার ছবি নির্বাচন করা আবশ্যক।',
    maximum_five_slides_try_again:
      'আপনার ফাইল থেকে ছবি বের করার সময় ত্রুটি ঘটেছে। নিশ্চিত করুন আপনার ফাইলে সর্বোচ্চ ৫টি স্লাইড আছে এবং প্রতিটি স্লাইডে নোট রয়েছে। আবার চেষ্টা করুন !',
    back_to_upload: 'আপলোডে ফিরে যান',
    uploading_file_to_server: 'আপনার ফাইল সার্ভারে আপলোড করা হচ্ছে',
    extracting_images_from_your_file: 'আপনার ফাইল থেকে ছবি বের করা হচ্ছে',
    upload_your_ppt_or_drag:
      'আপনার প্রেজেন্টেশন ফাইল (.PPTX) আপলোড করুন অথবা এখানে টেনে আনুন।',
    maximum_five_slides_error:
      'আপনার পাওয়ারপয়েন্ট ফাইলে সর্বোচ্চ ৫টি স্লাইড এবং প্রতিটি স্লাইডে নোট থাকতে হবে। অন্যথায় ত্রুটি হবে।',
    number_of_questions_generated: 'তৈরি করার জন্য প্রশ্নের সংখ্যা',
    quiz_page_this_cannot_be_done:
      'আপনি কি নিশ্চিত যে এই পৃষ্ঠায় কুইজ যোগ করতে চান? এটি পূর্বাবস্থায় ফেরানো যাবে না।',
    confirm_selection: 'নির্বাচন নিশ্চিত করুন',
    select_quiz_page: 'কুইজ পৃষ্ঠা নির্বাচন করুন',
    lesson_do_you_want_add_this_quiz: 'আপনি কোন অংশে এই কুইজটি যোগ করতে চান?',
    beginning_of_lesson: 'পাঠের শুরুতে',
    end_of_lesson: 'পাঠের শেষে',
    currently_active_page: 'বর্তমানে সক্রিয় পৃষ্ঠা',
    finish: 'সমাপ্ত',
    upload_selection_file: 'সেকশন ফাইল আপলোড করুন',
    general_quiz: 'সাধারণ কুইজ',
    manage_sequence: 'ক্রম পরিচালনা করুন',
    save_sequence: 'ক্রম সংরক্ষণ করুন',
    new: 'নতুন',
    in_progress: 'চলমান',
    recommended_course: 'প্রস্তাবিত কোর্স',
    up_coming: 'আসন্ন',
    past_live: 'পূর্ববর্তী সরাসরি',
    input_your_channel_name: 'অনুগ্রহ করে আপনার চ্যানেলের নাম লিখুন!',
    organization_place: 'অর্গানাইজেশন মার্কেটপ্লেস',
    marketplace_report: 'মার্কেটপ্লেস রিপোর্ট',
    story_writing: 'গল্প লেখা',
    Ai_quiz: 'এআই কুইজ',
    generate_quiz: 'কুইজ তৈরি করুন',
    create_story: 'গল্প তৈরি করুন',
    change_layout_page: 'আপনি এই পৃষ্ঠার লেআউট পরিবর্তন করতে যাচ্ছেন।',
    change_layout_message:
      'মনে রাখবেন শুধুমাত্র টেক্সট, ছবি, ব্যাকগ্রাউন্ড এবং লোগো রাখা হবে। অন্যান্য সব উপাদান পৃষ্ঠার থেকে মুছে যাবে।',
    reviews: 'পর্যালোচনা',
    tab_attachments: 'সংযুক্তি',
    zoom_in: 'জুম ইন',
    zoom_out: 'জুম আউট',
    zoom_reset: 'জুম রিসেট',
    no_attachment: 'কোন সংযুক্তি নেই।',
    select_upload_simulation: 'দয়া করে সিমুলেশন নির্বাচন/আপলোড করুন।',
    quiz_updated_successfully: 'কুইজ সফলভাবে আপডেট হয়েছে !',
    quizes: 'কুইজ',
    trivia: 'ট্রিভিয়া',
    closing: 'বন্ধ করা হচ্ছে...',
    products: 'পণ্য',
    ask_questions: 'এখানে একটি প্রশ্ন জিজ্ঞাসা করুন...',
    course_information: 'কোর্স তথ্য',
    course_assistance: 'কোর্স নির্মাতা সহায়তা',
    go_back: 'ফিরে যান',
    ai_generate_content_progress: 'বিষয়বস্তু তৈরি চলছে',
    view_generate_content: 'তৈরি করা বিষয়বস্তু দেখুন',
    generate_error: 'তৈরি করার ত্রুটি !',
    confirm_creating_course:
      'আপনি কি এই বিষয়বস্তু ব্যবহার করে কোর্স তৈরি করতে চান?',
    generate_content_automatically:
      'এটি স্বয়ংক্রিয়ভাবে সমস্ত তৈরি বিষয়বস্তু পাঠ এবং পৃষ্ঠায় আপনার কোর্সে যোগ করবে।',
    quiz_created_successfully: 'কুইজ সফলভাবে তৈরি হয়েছে !',
    create_quiz: 'কুইজ তৈরি করুন',
    quiz_setting: 'কুইজ সেটিং',
    please_fill_quiz_setting: '* দয়া করে কুইজ সেটিং এর সব ফিল্ড পূরণ করুন',
    question_list: 'প্রশ্ন তালিকা',
    add_quiz_to_page: 'কুইজ পৃষ্ঠায় যোগ করুন',
    form_create_question: 'প্রশ্ন তৈরির ফর্ম',
    user_information_updated: 'ব্যবহারকারীর তথ্য আপডেট হয়েছে !',
    your_stripe_activete_to_continue:
      'আপনার স্ট্রাইপ অ্যাকাউন্ট নিষ্ক্রিয়। চালিয়ে যাওয়ার জন্য এটি সংযুক্ত বা সক্রিয় করুন।',
    connect_tripe: 'স্ট্রাইপ সংযুক্ত করুন',
    certificate_sent_sucessfully:
      'সার্টিফিকেট আপনার ইমেইলে সফলভাবে পাঠানো হয়েছে।',
    error_try_again: 'ত্রুটি হয়েছে। আবার চেষ্টা করুন !',
    error_delete_channel: 'চ্যানেল মুছে ফেলা ত্রুটি।',
    error_update_sub: 'সাবস্ক্রিপশন আপডেট ত্রুটি।',
    end_time_cannot_start: 'সমাপ্তির সময় শুরু সময়ের আগে হতে পারে না।',
    start_date_time_interval: 'শুরু তারিখ এবং সময়ের ইন্টারভ্যাল আবশ্যক!',
    podcast_updated_successful: 'পডকাস্ট সফলভাবে আপডেট হয়েছে।',
    podcast_created_successful: 'পডকাস্ট সফলভাবে তৈরি হয়েছে।',
    podcast_published_successful: 'পডকাস্ট সফলভাবে প্রকাশিত হয়েছে',
    podcast_cover_updated: 'পডকাস্ট কভার আপডেট হয়েছে',
    new_podcast_details:
      'নতুন পডকাস্ট বর্তমান পডকাস্টে নতুন ইনপুট তথ্য সহ তৈরি হবে।',
    current_update_podcast:
      'বর্তমান পডকাস্ট, মিউজিক ও স্টোরিজের তথ্য আপডেট করুন।',
    create_new_podcast: 'নতুন পডকাস্ট তৈরি করুন',
    publish_podcast_public_view: 'সাধারণ দর্শকদের জন্য পডকাস্ট প্রকাশ করুন।',
    only_allowed_twenty_five_email: 'শুধুমাত্র ২৫টি ইমেইল অনুমোদিত',
    only_allowed_five_email: 'শুধুমাত্র ৫টি ইমেইল অনুমোদিত।',
    cover_is_required: 'কভার আবশ্যক।',
    topic_is_required: 'টপিক আবশ্যক।',
    delete_schedule: 'শিডিউল মুছুন',
    make_as_coaching: 'কোচিং উপলব্ধতা হিসেবে চিহ্নিত করুন',
    manage_category: 'বিভাগ পরিচালনা করুন',
    threshold: 'থ্রেশহোল্ড',
    threshold_popup: 'শ্রেণির জন্য সুপারিশ সক্রিয় করার জন্য শতকরা (%) মান।',
    list_of_catagory: 'বিভাগের তালিকা',
    category_name: 'বিভাগের নাম',
    category_threshold: 'বিভাগের থ্রেশহোল্ড',
    play_game: 'গেম খেলুন',
    switching_organization: 'সংস্থা পরিবর্তন করা হচ্ছে...',
    coaching_session: 'কোচিং সেশন',
    required_channel_id: 'চ্যানেল আইডি প্রয়োজন!',
    error_occured_try_again: 'ত্রুটি ঘটেছে। পুনরায় চেষ্টা করুন!',
    please_complete_marketplace_form: 'মার্কেটপ্লেস ফর্ম সম্পূর্ণ করুন!',
    upload_file_corrupt: 'আপলোডকৃত ফাইলটি ক্ষতিগ্রস্ত হয়েছে।',
    course_not_published: 'কোর্সটি এখনও প্রকাশিত হয়নি!',
    error_request: 'অনুরোধে ত্রুটি। অনুগ্রহ করে আবার চেষ্টা করুন!',
    skill_request: 'অনুগ্রহ করে অনুপস্থিত ফিল্ড পূরণ করুন!',
    error_occured: 'ত্রুটি ঘটেছে। পুনরায় চেষ্টা করুন!',
    show_time: 'সময় দেখান',
    start_time: 'শুরু সময়',
    end_time: 'সমাপ্ত সময়',
    room_name: 'পডকাস্টের নাম',
    add_guest_speaker: 'অতিথি বক্তা যোগ করুন',
    cover_picture: 'কভার ছবি',
    guest_speaker: 'অতিথি বক্তারা',
    see_more: 'আরও দেখুন',
    see_less: 'কম দেখুন',
    background: 'পটভূমি',
    icon: 'আইকন',
    icon_size: 'আইকনের আকার',
    icon_color: 'আইকনের রং',
    only_text: 'টেক্সট',
    change_bg: 'পটভূমির রং পরিবর্তন করুন',
    bg_color: 'পটভূমির রং',
    font_size: 'ফন্টের আকার',
    normal: 'সাধারণ',
    change_color: 'টেক্সটের রং পরিবর্তন করুন',
    slant_text: 'ঝোঁকানো টেক্সট',
    text_radius: 'টেক্সটের ব্যাসার্ধ',
    vertical_align: 'উল্লম্ব সারিবদ্ধ',
    horizontal_align: 'আড়াআড়ি সারিবদ্ধ',
    change_icon_color: 'আইকনের রং পরিবর্তন করুন',
    upload_icon: 'আইকন আপলোড করুন',
    upload_signature: 'সাক্ষর আপলোড করুন',
    add_another_sign: 'আরেকটি সাক্ষর যোগ করুন',
    name_badges: 'ব্যাজের নাম',
    should_less_150: '১৫০ অক্ষর বা তার কম হওয়া উচিত',
    your_badge: 'আপনার ব্যাজ',
    do_you_want_delete_badge: 'আপনি কি সত্যিই এই ব্যাজটি মুছে ফেলতে চান?',
    do_you_want_delete_cert: 'আপনি কি সত্যিই এই সনদপত্রটি মুছে ফেলতে চান?',
    upload_logo: 'লোগো আপলোড করুন',
    name_of_cert: 'সনদপত্রের নাম',
    upload_cert: 'সনদপত্র আপডেট করুন',
    your_cert: 'আপনার সনদপত্র',
    translate_to: 'অনুবাদ করুন',
    select_file_attach: 'সংযুক্ত করার জন্য ফাইল নির্বাচন করুন',
    certificate: 'সনদপত্র',
    badge: 'ব্যাজ',
    publish_options: 'প্রকাশ বিকল্পসমূহ',
    publish_skills_journey: 'দক্ষতা যাত্রা প্রকাশ করুন',
    videos: 'ভিডিও',
    generate_ai_video:
      'ভিডিও তৈরির প্রক্রিয়াটি কিছু সময় নিতে পারে। সম্পন্ন হলে আপনাকে ইমেইলে জানানো হবে।',
    trainer_information: 'প্রশিক্ষকের তথ্য',
    promotional_video_link: 'প্রচারমূলক ভিডিও লিঙ্ক',
    please_select: 'অনুগ্রহ করে নির্বাচন করুন',
    image_name: 'ছবির নাম:',
    image_size: 'ছবির আকার:',
    charecters_fifteen_less: '১৫ অক্ষর বা তার কম',
    leadership: 'নেতৃত্ব',
    text_arc: 'টেক্সট বক্ররেখা',
    vertical: 'উলম্ব',
    horizontal: 'আড়াআড়ি',
    badge_history: 'ব্যাজের ইতিহাস',
    templates: 'টেমপ্লেট',
    sign: 'সাক্ষর',
    logo: 'লোগো',
    certificate_history: 'সনদপত্রের ইতিহাস',
    please_wait: 'দয়া করে অপেক্ষা করুন...',
    information: 'তথ্য',
    support_five_thousand_live_event:
      'ইভেন্টে ৫০০০ জন পর্যন্ত অংশগ্রহণকারীদের সমর্থন করে',
    support_ten_live_event:
      '১০ জন পর্যন্ত সরাসরি ভিডিও অংশগ্রহণকারীদের সমর্থন করে',
    we_will_back_participant:
      'আমরা প্রচুর অংশগ্রহণকারীর সঙ্গে ইভেন্টে ফিরে আসব।',
    course_objectives: 'কোর্সের উদ্দেশ্যসমূহ',
    course_outlines: 'কোর্সের খসড়া',
    price_dollor: 'মূল্য (ইউএসডি)',
    not_completed: 'সম্পূর্ণ হয়নি',
    enable_marketplace: 'মার্কেটপ্লেস সক্ষম করুন',
    enable_course_ai: 'কোর্স সৃষ্টি AI দিয়ে সক্ষম করুন',
    enable_report_to_admin: 'অ্যাডমিনকে রিপোর্ট দেখানো সক্ষম করুন',
    enable_white_label: 'হোয়াইট লেবেল সক্ষম করুন',
    enable_eleven_labs_for_maze_play: 'মেজ প্লের জন্য এলেভেনল্যাবস সক্ষম করুন',
    enable_eleven_labs_for_maze_play_cloned:
      'এলেভেনল্যাবস ক্লোনড ভয়েস সক্ষম করুন',
    not_completed: 'সম্পূর্ণ হয়নি',
    simulation_quiz: 'সিমুলেশন কুইজ',
    bg_color_setting: 'ব্যাকগ্রাউন্ড রঙ সেটিংস',
    color_preview: 'রঙের পূর্বরূপ',
    choose_new_color: 'নতুন রঙ নির্বাচন করুন',
    remove_color: 'রঙ সরান',
    apply_color: 'রঙ প্রয়োগ করুন',
    elemeent_in_a_sceenario_page:
      'আপনি একটি সিনারিও পেজে অন্য উপাদান যোগ করতে পারবেন না। অনুগ্রহ করে অন্য পেজ চেষ্টা করুন অথবা আগে সিনারিও পেজ থেকে সরান।',
    no_data_found: 'কোন তথ্য পাওয়া যায়নি।',
    references: 'তথ্যসূত্র',
    open_file: 'ফাইল খুলুন',
    showing_result: 'ফলাফল দেখানো হচ্ছে:',
    fiften_day_free_trail: '১৫ দিনের বিনামূল্যে ট্রায়াল',
    your_browser_does_not_support: 'আপনার ব্রাউজার অডিও উপাদান সমর্থন করে না।',
    podcast_desc: 'পডকাস্ট বর্ণনা',
    input_podcast_desc: 'অনুগ্রহ করে পডকাস্ট বর্ণনা লিখুন',
    podcast_obj: 'পডকাস্ট উদ্দেশ্য',
    input_podcast_obj: 'অনুগ্রহ করে পডকাস্ট উদ্দেশ্য লিখুন',
    podcast_outline: 'পডকাস্ট রূপরেখা',
    input_podcast_outline: 'অনুগ্রহ করে পডকাস্ট রূপরেখা লিখুন',
    add_file: 'ফাইল যোগ করুন',
    generate_podcast_audio: 'পডকাস্ট অডিও তৈরি করুন',
    generate_uploaded_file_input_parameter:
      'ব্যবহারকারীর আপলোড করা ফাইলের তথ্য দিয়ে কন্টেন্ট তৈরি করা হয়।',
    go_backe_generation_state: 'কন্টেন্ট তৈরির অবস্থায় ফিরে যান।',
    create_ai_powered_podcast:
      'জেনারেটেড অডিও সহ AI-চালিত পডকাস্ট এপিসোড তৈরি করুন।',
    generate_voice_for_all_podcast: 'সব পডকাস্ট এপিসোডের জন্য ভয়েস তৈরি করুন',
    create_podcast_episode: 'পডকাস্ট এপিসোড তৈরি করুন',
    voice_name: 'ভয়েস নাম',
    input_custom_name: 'অনুগ্রহ করে কাস্টম নাম লিখুন!',
    enter_custom_name: 'কাস্টম ভয়েস নাম লিখুন',
    upload_complete: 'আপলোড সম্পন্ন',
    uploading_in_progress: 'আপলোড চলছে...',
    podcast_stream_content: 'পডকাস্ট কন্টেন্ট স্ট্রিম',
    upload_podcast_cover: 'অনুগ্রহ করে পডকাস্ট কভার আপলোড করুন!',
    enter_podcast_name: 'অনুগ্রহ করে পডকাস্ট নাম লিখুন!',
    podcast_topic: 'পডকাস্ট বিষয়',
    enter_podcast_topic: 'অনুগ্রহ করে পডকাস্ট বিষয় লিখুন!',
    enter_podcast_desc: 'অনুগ্রহ করে পডকাস্ট বর্ণনা লিখুন!',
    number_of_speaker: 'স্পিকার সংখ্যা',
    select_the_number_of_speaker: 'অনুগ্রহ করে স্পিকার সংখ্যা নির্বাচন করুন!',
    number_of_episode: 'এপিসোড সংখ্যা',
    input_number_of_episode: 'অনুগ্রহ করে এপিসোড সংখ্যা লিখুন!',
    podcast_length: 'পডকাস্ট দৈর্ঘ্য',
    select_the_podcast_length: 'অনুগ্রহ করে পডকাস্ট দৈর্ঘ্য নির্বাচন করুন!',
    short_podcast: 'সংক্ষিপ্ত (৫-১০ মিনিট)',
    medium_podcast: 'মাঝারি (১৫-১৮ মিনিট)',
    long_podcast: 'দীর্ঘ (১৮+ মিনিট)',
    name_of_host: 'হোস্টের নাম',
    enter_host_name: 'অনুগ্রহ করে হোস্টের নাম লিখুন!',
    guest_name: 'অতিথিদের নাম',
    enter_guest_name: 'অনুগ্রহ করে অতিথির নাম লিখুন!',
    choose_speaker_tone: 'স্পিকার টোন নির্বাচন করুন',
    enter_speaker_tone: 'অনুগ্রহ করে পডকাস্ট টোন নির্বাচন করুন!',
    informal: 'আনুষ্ঠানিক নয়',
    formal: 'আনুষ্ঠানিক',
    serious: 'গম্ভীর',
    light_humor: 'হালকা রসিকতা',
    casual: 'সাধারণ',
    select_content_source: 'কন্টেন্ট উৎস নির্বাচন করুন',
    from_internet: 'ইন্টারনেট থেকে',
    upload_pdf_internet: 'একটি PDF অথবা অভ্যন্তরীণ ডকুমেন্ট আপলোড করুন',
    note: 'নোট:',
    podcast_content_will_be_automatically_generated:
      'পডকাস্ট কন্টেন্ট বিশ্বাসযোগ্য ইন্টারনেট উৎস থেকে স্বয়ংক্রিয়ভাবে তৈরি হবে।',
    upload_or_select_file: 'অনুগ্রহ করে ফাইল আপলোড বা নির্বাচন করুন!',
    podcast_eposode_title: 'পডকাস্ট এপিসোড শিরোনাম',
    enter_podcast_title: 'অনুগ্রহ করে এপিসোডের শিরোনাম লিখুন!',
    podcast_episode_des: 'পডকাস্ট এপিসোড বর্ণনা',
    enter_podcast_episode_des: 'অনুগ্রহ করে এপিসোডের বর্ণনা লিখুন!',
    voice: 'ভয়েস',
    music: 'সঙ্গীত',
    select_music: 'সঙ্গীত নির্বাচন করুন',
    play_the_music: 'সঙ্গীত চালান',
    stop_the_music: 'সঙ্গীত বন্ধ করুন',
    context: 'প্রসঙ্গ',
    generate_audio_content_selected_voice:
      'নির্বাচিত ভয়েস অনুযায়ী অডিও কন্টেন্ট তৈরি হবে।',
    required_field_before_submitting:
      'জমা দেওয়ার আগে সমস্ত প্রয়োজনীয় তথ্য পূরণ করুন।',
    regenerate_voice: 'ভয়েস পুনরায় তৈরি করুন',
    generate_voice: 'ভয়েস তৈরি করুন',
    your_browser_does_not_suppot: 'আপনার ব্রাউজার অডিও উপাদান সমর্থন করে না।',
    are_sure_leave_podcast: 'আপনি কি পডকাস্ট থেকে বের হতে চান?',
    broadcast_ongoing: 'ব্রডকাস্ট চলছে। আপনি কি সত্যিই এই পেজ থেকে যেতে চান?',
    brodcaster_unavailable: 'বর্তমানে ব্রডকাস্টার অনুপলব্ধ।',
    setting_calender_for_booking: 'বুকিংয়ের জন্য ক্যালেন্ডার সেটিং',
    add_calender: 'ক্যালেন্ডার যোগ করুন',
    waiting_join_host: 'হোস্টের যোগ দেওয়ার অপেক্ষা...',
    no_reviews_found: 'কোন রিভিউ পাওয়া যায়নি।',
    rated_already: 'আপনি ইতিমধ্যে এই লাইভ ইভেন্টে রেট দিয়েছেন।',
    downlink_png: 'PNG ডাউনলোড',
    downlink_jpg: 'JPG ডাউনলোড',
    donwload_file_format: 'অনুগ্রহ করে ডাউনলোডের ফাইল ফরম্যাট নির্বাচন করুন।',
    crashed_event:
      'এই ইভেন্টটি ক্র্যাশ হয়েছে। আপনাকে নতুন ইভেন্ট তৈরি করতে হবে। অসুবিধার জন্য দুঃখিত।',
    prompt: 'প্রম্পট:',
    generated_image: '🚀 আপনার ছবি তৈরি হচ্ছে... অনুগ্রহ করে অপেক্ষা করুন।',
    download_add: 'সব ডাউনলোড করুন',
    setting_generator: 'জেনারেটর সেটিংস',
    enter_image_prompt: 'অনুগ্রহ করে একটি ছবি প্রম্পট লিখুন',
    image_prompt: 'ছবি প্রম্পট লিখুন',
    negative_prompt: 'নেগেটিভ প্রম্পট',
    negative_image_prompt: 'নেগেটিভ ছবি প্রম্পট লিখুন',
    number_output: 'আউটপুট সংখ্যা',
    enter_number_output: 'অনুগ্রহ করে আউটপুট সংখ্যা লিখুন',
    image_style: 'ছবির জন্য স্টাইল নির্বাচন করুন',
    output_format: 'আউটপুট ফরম্যাট',
    seeds: 'সিডস',
    enter_seeds: 'অনুগ্রহ করে সিড সংখ্যা লিখুন',
    performance_mode: 'পারফরম্যান্স মোড',
    quality: 'গুণমান',
    speed: 'গতি',
    balanced: 'সামঞ্জস্যপূর্ণ',
    guidance_scale: 'গাইডেন্স স্কেল',
    enter_guidance: 'অনুগ্রহ করে গাইডেন্স স্কেল লিখুন',
    select_image: 'অনুগ্রহ করে ছবি নির্বাচন করুন।',
    image_prmt: 'ছবি প্রম্পট',
    generate_image_list_empty: 'তৈরি হওয়া ছবির তালিকা খালি।',
    knowledge_center_tooltrip_des:
      'বিস্তৃত তথ্যসূত্র থেকে প্রাপ্ত নির্ভুল ও প্রাসঙ্গিক উত্তর পান। এআই মডেলটি বিভিন্ন ইন্টারনেট টেক্সট থেকে প্রশিক্ষিত।',
    contexts: 'প্রসঙ্গসমূহ',
    ai_processing_video_sharebot:
      'শেয়ারবট ভিডিও প্রক্রিয়াকরণে প্রায় ২৪ ঘণ্টা সময় লাগবে।',
    remove_sharebot_video: `যদি আপনি ভিডিওর শেয়ারবট রেফারেন্স মুছে ফেলতে চান, অনুগ্রহ করে সংশ্লিষ্ট ট্রান্সক্রিপ্ট ও ভিডিও মুছে দিন।`,
    remove_sharebot_video_audio:
      'ট্রান্সক্রিপ্ট মুছে ফেললে শেয়ারবটের ভিডিও/অডিও রেফারেন্স মুছে যাবে, কিন্তু ভিডিও মিডিয়া লাইব্রেরি/চ্যানেলে থাকবে।',
    monthly_live_stream: 'মাসিক লাইভ-স্ট্রিম সীমা পরিবর্তনের জন্য যোগাযোগ করুন',
    monthly_transcribe_limit:
      'মাসিক ট্রান্সক্রাইব সীমা পরিবর্তনের জন্য যোগাযোগ করুন',
    must_be_one_to_three_hundred: '১ থেকে ৩০০ মিনিটের মধ্যে হতে হবে।',
    all_field_required: 'সকল ক্ষেত্র পূরণ করতে হবে।',
    duration_minute: 'দৈর্ঘ্য (সর্বোচ্চ ৩০০ মিনিট)',
    gender: 'লিঙ্গ',
    select_gender: 'লিঙ্গ নির্বাচন করুন',
    accent: 'উচ্চারণ',
    select_accent: 'উচ্চারণ নির্বাচন করুন',
    create_voice: 'ভয়েস তৈরি করুন',
    enter_voice_name: 'ভয়েসের নাম লিখুন',
    select_voice_gender: 'ভয়েসের লিঙ্গ নির্বাচন করুন',
    upload_voice: 'আপনার ভয়েস আপলোড করুন',
    upload_voice_mp_three: 'আপনার ভয়েস আপলোড করুন (.mp3)',
    cloned_voice: 'ক্লোন করা ভয়েস',
    voice_type: 'ভয়েস টাইপ',
    select_voice_type: 'ভয়েস টাইপ নির্বাচন করুন',
    sharelook_stand: 'স্ট্যান্ডার্ড',
    sharelook_premium: 'প্রিমিয়াম',
    sharelook_custum_voice: 'কাস্টম (ভয়েস ক্লোনিং)',
    create_auto_flow: 'স্বয়ংক্রিয় ফ্লো তৈরি করুন',
    how_many_layers: 'কতটি স্তর',
    verify_selection: 'নির্বাচন যাচাই করুন',
    uploaded_successful: 'সফলভাবে আপলোড হয়েছে',
    upload_failed: 'আপলোড ব্যর্থ হয়েছে',
    upload_only_five_mb: 'বিষয়বস্তু আপলোড করুন (PDF ফাইল, সর্বাধিক ৫টি)',
    docs_from_org_library: 'সংস্থার লাইব্রেরি থেকে ডকুমেন্ট ব্যবহার করুন',
    failed_maze_generate: 'মেজ তৈরি করতে ব্যর্থ হয়েছে। আবার চেষ্টা করুন।',
    generate_metamaze: 'মেটামেজ তৈরি করা হচ্ছে...',
    metamaze_being_generated:
      'আপনার মেটামেজ তৈরি হচ্ছে। প্রক্রিয়া শেষ হলে ইমেইলের মাধ্যমে জানানো হবে।',
    metamaze_generate_successfully: 'মেটামেজ সফলভাবে তৈরি হয়েছে!',
    metamaze_with_proceed: 'আপনি এখন মেটামেজের সাথে এগিয়ে যেতে পারেন।',
    ai_metamaze_generate: 'এআই মেটামেজ তৈরি',
    what_kind_maze_create: 'আপনি কোন ধরনের মেজ তৈরি করতে চান?',
    manual_metamaze_creation: 'ম্যানুয়াল মেটামেজ তৈরি',
    manually_maze_customizing_scnario:
      'সিনারিও এবং অপশন ট্রি কাস্টমাইজ করে ম্যানুয়ালি মেজ তৈরি করুন',
    maze_ai_generated: 'AI দ্বারা স্বয়ংক্রিয়ভাবে মেজ তৈরি করুন',
    unmark_deadend: 'ডেডএন্ড অপসারণ করুন',
    mark_deadend: 'ডেডএন্ড চিহ্নিত করুন',
    select_multiple_image_for_scenario:
      'আপনি একাধিক ছবি নির্বাচন করতে পারেন এই সিনারিওর জন্য।',
    select_your_image: 'আপনার নির্বাচিত ছবি',
    click_to_preview: 'প্রিভিউ দেখার জন্য ক্লিক করুন',
    are_you_sure_delete_image: 'আপনি কি নিশ্চিত এই ছবি মুছে ফেলতে চান?',
    select_image_from_library: 'মিডিয়া লাইব্রেরি থেকে ছবি নির্বাচন করুন',
    uploading_video: 'ভিডিও আপলোড হচ্ছে...',
    tree_node_type: 'ট্রি নোড টাইপ',
    correct_option_scenario: 'সঠিক অপশন বা সিনারিও',
    incorrect_option: 'ভুল অপশন',
    option_scenario_without_text: 'লেখা ছাড়াই অপশন বা সিনারিও',
    dead_end: 'ডেডএন্ড (লাল সীমানা)',
    correct_path: 'সঠিক পথ',
    incorrect_path_not_selected_correct_option_path:
      'ভুল পথ / যেখানে সঠিক অপশন নির্বাচন করা হয়নি এমন পথ।',
    double_click_on_tree_node:
      'আপনি যখন একটি ট্রি নোডে ডাবল-ক্লিক করবেন, তখন টেক্সট এডিটর সেই নির্দিষ্ট নোডের বিষয়বস্তু প্রদর্শনের জন্য স্বয়ংক্রিয়ভাবে স্ক্রল করবে।',
    add_scenario: 'সিনারিও যোগ করুন',
    add_option: 'অপশন যোগ করুন',
    an_error_occured: 'একটি ত্রুটি ঘটেছে:',
    download_summary: 'সারাংশ ডাউনলোড করুন',
    step_wise_analysis: 'ধাপভিত্তিক বিশ্লেষণ',
    step: 'ধাপ',
    upload_csv_file: 'CSV ফাইল আপলোড করুন',
    download_template_to_import: 'আমদানি করতে স্যাম্পল টেমপ্লেট ডাউনলোড করুন',
    please_input_email: 'অনুগ্রহ করে ইমেইল লিখুন।',
    email_at_least_three_characters: 'ইমেইল কমপক্ষে ৩ অক্ষরের হতে হবে।',
    email_cannot_be_empty: 'ইমেইল ফাঁকা রাখা যাবে না।',
    input_email_in_new_line: 'অনুগ্রহ করে প্রতিটি ইমেইল একটি নতুন লাইনে লিখুন',
    role: 'ভূমিকা',
    select_role: 'একটি ভূমিকা নির্বাচন করুন',
    select_group: 'একটি গ্রুপ নির্বাচন করুন',
    identification_number: 'পরিচয় নম্বর (ঐচ্ছিক)',
    add_identification_number: 'অনুগ্রহ করে একটি পরিচয় নম্বর যোগ করুন',
    pie_chart_of_all_categories:
      'শেয়ারলুকে ব্যবহৃত সমস্ত ক্যাটাগরির উপর ভিত্তি করে পাই চার্ট।',
    total_sharesphere_question_answered_by_users:
      'বর্তমান সংস্থার ব্যবহারকারীদের দ্বারা উত্তর দেওয়া সমস্ত ShareSphere প্রশ্নের মোট পরিমাণ, সেই ক্যাটাগরি এবং তাদের সফলতা ও ব্যর্থতার ফলাফলসহ।',
    voice_style_over_the_text: `যেখানে আপনি টাইপ করা লেখার উপর বিভিন্ন ভয়েস স্টাইল ব্যবহার করতে পারেন। Lorem Ipsum একটি ছাপাখানা এবং টাইপসেটিং ইন্ডাস্ট্রির ডামি টেক্সট, যা ১৫০০ সাল থেকে প্রচলিত।`,
    input_your_question: 'অনুগ্রহ করে আপনার প্রশ্ন লিখুন!',
    make_me_sales_manager: 'যেমন: কিভাবে আমি সেলস ম্যানেজার হতে পারি',
    enter_the_number_relevant_document: 'প্রাসঙ্গিক ডকুমেন্টের সংখ্যা লিখুন',
    please_wait_loading_result: 'অনুগ্রহ করে অপেক্ষা করুন, ফলাফল লোড হচ্ছে...',
    no_result_found:
      'কোন ফলাফল পাওয়া যায়নি, অনুগ্রহ করে অন্যভাবে প্রশ্ন করুন',
    browser_doesnot_support_iframes: 'আপনার ব্রাউজার আইফ্রেম সমর্থন করে না',
    total_duration: 'মোট সময়কাল',
    number_of_messages: 'বার্তার সংখ্যা',
    search_result: 'সার্চ ফলাফল',
    count_result: '(১২৪৪টি ফলাফল)',
    your_other_interests: 'আপনার অন্যান্য আগ্রহ',
    your_total_score: 'আপনার মোট স্কোর',
    add_a_question: '+একটি প্রশ্ন যোগ করুন',
    travia_question_empty: 'ট্রিভিয়া প্রশ্নের তালিকা খালি।',
    video_generation_is_on_queue: 'আপনার ভিডিও তৈরির অনুরোধ কিউতে আছে!',
    checking_video_status: 'ভিডিও স্ট্যাটাস পরীক্ষা করা হচ্ছে...',
    total_quizzes: 'মোট কুইজ',
    number_of_votes: 'ভোটের সংখ্যা',
    total_events: 'মোট ইভেন্ট',
    number_of_rates: 'রেটের সংখ্যা',
    number_of_likes: 'লাইক সংখ্যা',
    all_courses: 'সমস্ত কোর্স',
    total_questions: 'মোট প্রশ্ন',
    no_skill_journey: 'কোন স্কিল জার্নি উপলব্ধ নয়!',
    search_no_results: '- কোন ফলাফল পাওয়া যায়নি!',
    no_image_generated: 'কোনো ছবি তৈরি করা হয়নি!',
    all_topic_in_this_lesson:
      'এই পাঠের সমস্ত বিষয়বস্তু মুছে ফেলা হবে। এটি আর ফিরে পাওয়া যাবে না।',
    content_has_been_generated: 'এই বিষয়ের জন্য বিষয়বস্তু তৈরি করা হয়েছে।',
    update_course_template: 'কোর্স টেমপ্লেট আপডেট করুন',
    add_course_template: 'কোর্স টেমপ্লেট যোগ করুন',
    create_course_now: 'এখন কোর্স তৈরি করুন',
    preview_course: 'কোর্স প্রিভিউ করুন',
    layout: 'লেআউট',
    import_from_youtube: 'ইউটিউব থেকে ইম্পোর্ট করুন',
    my_media_library: 'আমার মিডিয়া লাইব্রেরি',
    bg_added: 'পেছনের ছবি যুক্ত হয়েছে',
    add_bg: 'পেছনের ছবি যুক্ত করুন',
    booked_schedule: 'বুককৃত সময়সূচি',
    add_schedule: 'সময়সূচি যুক্ত করুন',
    are_you_delete_schedule: 'আপনি কি নিশ্চিতভাবে এই সময়সূচি মুছে ফেলতে চান?',
    add_task: 'কাজ যুক্ত করুন',
    update_calender: 'ক্যালেন্ডার আপডেট করুন',
    manage_cookies: 'কুকি পরিচালনা করুন',
    cookie_banner_text:
      'আমরা আপনার ব্রাউজিং অভিজ্ঞতা উন্নত করতে, ওয়েবসাইটের ট্রাফিক বিশ্লেষণ করতে এবং কনটেন্ট ব্যক্তিগতকরণ করতে কুকি ব্যবহার করি। আপনার গোপনীয়তা আমাদের কাছে গুরুত্বপূর্ণ।',
    accept_all_cookies: 'সব কুকি গ্রহণ করুন',
    reject_all: 'সব প্রত্যাখ্যান করুন',
    customize: 'নিজে পছন্দ করুন',
    cookie_preferences_title: 'কুকি পছন্দ ও গোপনীয়তা সেটিংস',
    privacy_subtitle:
      'আপনার গোপনীয়তা আমাদের কাছে গুরুত্বপূর্ণ। আপনি কোন কুকি অনুমতি দেবেন তা নির্বাচন করুন। আপনি যেকোনো সময় এই সেটিংস পরিবর্তন করতে পারেন।',
    save_choices: 'আমার পছন্দ সংরক্ষণ করুন',
    strictly_necessary: 'অত্যাবশ্যক',
    strictly_necessary_desc:
      'এই কুকিগুলি ওয়েবসাইটের সঠিকভাবে কাজ করার জন্য প্রয়োজনীয়। এগুলি মূল ফাংশন যেমন পৃষ্ঠার নেভিগেশন, ফর্ম জমা দেওয়া এবং নিরাপদ এলাকায় প্রবেশ সক্ষম করে। এই কুকিগুলি ছাড়া ওয়েবসাইট সঠিকভাবে কাজ করতে পারবে না।',
    analytics_performance: 'বিশ্লেষণ ও কার্যকারিতা',
    analytics_performance_desc:
      'এই কুকিগুলি আমাদের সাহায্য করে বুঝতে যে ব্যবহারকারীরা কীভাবে আমাদের ওয়েবসাইট ব্যবহার করেন। এগুলি বেনামিভাবে তথ্য সংগ্রহ ও প্রতিবেদন করে, যা আমাদের পারফরম্যান্স এবং ব্যবহারকারীর অভিজ্ঞতা উন্নত করতে সাহায্য করে।',
    advertising_marketing: 'বিজ্ঞাপন ও বিপণন',
    advertising_marketing_desc:
      'এই কুকিগুলি বিজ্ঞাপন বার্তাগুলি আপনার জন্য আরও প্রাসঙ্গিক করতে ব্যবহৃত হয়। এগুলি একই বিজ্ঞাপন পুনরায় প্রদর্শিত হতে বাধা দেয় এবং বিজ্ঞাপনগুলি সঠিকভাবে প্রদর্শিত হচ্ছে তা নিশ্চিত করে।',
    tracking_social: 'ট্র্যাকিং ও সামাজিক যোগাযোগমাধ্যম',
    tracking_social_desc:
      'এই কুকিগুলি উন্নত কার্যকারিতা ও ব্যক্তিগতকরণ সক্ষম করে, যেমন সামাজিক যোগাযোগমাধ্যম ফিচার এবং ব্যক্তিগতকৃত কনটেন্ট। এগুলি আমাদের দ্বারা বা তৃতীয় পক্ষের দ্বারা সেট করা হতে পারে।',
    functional: 'কার্যকরী',
    functional_desc:
      'এই কুকিগুলি চ্যাট সাপোর্ট, লাইভ হেল্প এবং অন্যান্য ইন্টারঅ্যাকটিভ ফিচারের মতো উন্নত ফাংশনালিটি সক্ষম করে যা আপনার অভিজ্ঞতা উন্নত করে।',
    your_rights: 'আপনার অধিকার:',
    rights_description:
      'আপনি যেকোনো সময় আপনার সম্মতি প্রত্যাহার করতে পারেন, আপনার ডেটা অ্যাক্সেস করতে পারেন, বা তা মুছে ফেলার অনুরোধ করতে পারেন।',
    withdraw_consent: 'সব সম্মতি প্রত্যাহার করুন',

    how_many_options: 'কতগুলি বিকল্প',
    add_content: 'কনটেন্ট যোগ করুন',
    downloads_center: 'ডাউনলোড কেন্দ্র',
    sharelook_help_center: 'Sharelook সাহায্য কেন্দ্র',
    channel_outline: 'চ্যানেল সংক্ষিপ্ত বিবরণ',
    channel_objectives: 'চ্যানেলের উদ্দেশ্য',
    no_sop_available: 'কোনও SOP তালিকা উপলব্ধ নেই।',
    generate_world_summary: 'সিনারিও তৈরি করুন',
    world_scenario: 'বাস্তব জগতের সিনারিও',
    drag_icon_hint: 'পরামর্শ: আইকনটি ক্যানভাসে টেনে তার অবস্থান নির্ধারণ করুন',
    drag_text_hint:
      'পরামর্শ: টেক্সটটি ক্যানভাসে টেনে তার অবস্থান নির্ধারণ করুন',
    edit_badge: 'ব্যাজ সম্পাদনা করুন',
    create_new_badge: 'নতুন ব্যাজ তৈরি করুন',
    select_video_preview: 'প্রিভিউ করার জন্য একটি ভিডিও নির্বাচন করুন',
    certificate_title_required: 'সার্টিফিকেটের শিরোনাম প্রয়োজন',
    discard_changes: 'পরিবর্তন বাতিল করুন',
    edit_certificate: 'সার্টিফিকেট সম্পাদনা করুন',
    add_another_logo: 'আরও একটি লোগো যোগ করুন',
    optional: 'ঐচ্ছিক',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'নতুন কোয়েস্ট তৈরি করুন',
    quest_filter_title: 'কোয়েস্ট',
    sharelook_assistance: 'Sharelook সহায়তা',
    upload_scorm_zip: 'SCORM ZIP আপলোড করুন',
    only_letters_numbers_space_dot_allowed:
      'শুধুমাত্র অক্ষর, সংখ্যা, ফাঁকা স্থান এবং ডট অনুমোদিত!',
    video_playing: 'চলছে',
    course_price_message:
      '*কোর্সটি শুধুমাত্র প্রতিষ্ঠানের ব্যবহারকারীদের জন্য প্রকাশিত হবে এবং মার্কেটপ্লেসে বিক্রি করা যাবে না।',
    lesson_must_be_positive: 'পাঠের সংখ্যা ১ এর চেয়ে বেশি হতে হবে',
    btn_proceed: 'চালিয়ে যান',
    rule_select_music: 'অনুগ্রহ করে সঙ্গীত নির্বাচন করুন',
    course_info: 'কোর্স তথ্য',
    content_selection: 'কনটেন্ট নির্বাচন',
    course_content_source: 'কোর্স কনটেন্ট উৎস',
    choose_how_to_source:
      'এই কোর্সের কনটেন্ট কোথা থেকে আনবেন তা নির্বাচন করুন:',
    automatic_selection: 'স্বয়ংক্রিয় নির্বাচন',
    system_will_automatically_select_relavant_documents:
      'সিস্টেম স্বয়ংক্রিয়ভাবে আপনার লাইব্রেরি থেকে প্রাসঙ্গিক নথি নির্বাচন করবে',
    manual_selection: 'ম্যানুয়াল নির্বাচন',
    choose_specific_documents_from_your_library:
      'আপনার লাইব্রেরি থেকে নির্দিষ্ট নথি নির্বাচন করুন',
    upload_files: 'ফাইল আপলোড করুন',
    upload_new_documents:
      'নতুন নথি আপলোড করুন (PDF, DOC, DOCX, PPT, PPTX, TXT) - সর্বাধিক ৫টি ফাইল',
    file: 'ফাইল',
    ready_to_upload: 'আপলোডের জন্য প্রস্তুত',
    clear_all: 'সব মুছুন',
    confirm_course_wide_premiew: 'কোর্স প্রিভিউ নিশ্চিত করুন',
    generate_course_preview: 'কোর্স প্রিভিউ তৈরি করুন',
    instructions_across_the_course_to_generate:
      'আমরা আপনার নির্দেশনাগুলি পুরো কোর্সে প্রয়োগ করব প্রিভিউ তৈরি করতে। প্রথমে সবকিছু পর্যালোচনা করুন, তারপর পরিবর্তন রাখবেন বা বাতিল করবেন তা নির্ধারণ করুন।',
    instruction_to_preview_course_wide: 'কোর্স প্রিভিউ করার নির্দেশনা:',
    edit_content: 'কনটেন্ট সম্পাদনা করুন',
    manage_course_template: 'কোর্স টেমপ্লেট পরিচালনা করুন',
    undo: 'বাতিল করুন',
    apply_changes: 'পরিবর্তন প্রয়োগ করুন',
    characters: 'অক্ষর',
    apply_all: 'সব প্রয়োগ করুন',
    apply_to_all: 'সবের উপর প্রয়োগ করুন',
    use_this_content: 'এই কনটেন্ট ব্যবহার করুন',
    original: 'মূল',
    edited: 'সম্পাদিত',
    edited_content_preview: 'সম্পাদিত কনটেন্ট প্রিভিউ',
    apply_edits_to_all_topices: 'সব বিষয়ের উপর সম্পাদনা প্রয়োগ করবেন?',
    current_editing_instructions_across_the_whole_course:
      'এটি পুরো কোর্সে আপনার বর্তমান সম্পাদনার নির্দেশনা প্রয়োগ করবে। সংরক্ষণের আগে আপনি সম্মিলিত প্রিভিউ পর্যালোচনা করতে পারেন।',
    edit_content_instructions: 'কনটেন্ট সম্পাদনার নির্দেশনা',
    generate_content_for_this_topic_instruction:
      'এই বিষয়ে আপনার নির্দেশনা ব্যবহার করে কনটেন্ট তৈরি করুন',
    descrip_edit_content:
      'এই কনটেন্ট কীভাবে সম্পাদনা করবেন তা বর্ণনা করুন (যেমন: সংক্ষিপ্ত করুন, সহজ করুন, পুনর্লিখন করুন)',
    try_short_clear_direcctives:
      'ছোট ও স্পষ্ট নির্দেশনা দিন। উদাহরণ: “১০০ শব্দে সংক্ষিপ্ত করুন, মূল পয়েন্ট রাখুন”, “ভাষা সহজ করুন”, “সংক্ষিপ্ত করুন এবং অপ্রয়োজনীয় অংশ সরান।”',
    we_preserve_the_core_meaning:
      'আমরা আপনার নির্দেশনা প্রয়োগ করার সময় মূল অর্থ বজায় রাখি।',
    feedback_optional: 'প্রতিক্রিয়া (ঐচ্ছিক)',
    write_your_feedback_here: 'এখানে আপনার প্রতিক্রিয়া লিখুন',
    from_web: 'ওয়েব থেকে',
    from_desktop: 'ডেস্কটপ থেকে',
    pleae_wait_processing: 'অনুগ্রহ করে অপেক্ষা করুন, প্রক্রিয়াকরণ চলছে...',
    create_simulation_from_screen_capture:
      'স্ক্রিন ক্যাপচার থেকে সিমুলেশন তৈরি করুন',
    sharelook_not_found: 'ShareLook পাওয়া যায়নি',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook স্ক্রিন ক্যাপচার অ্যাপ্লিকেশনটি খোলা যায়নি। এটি আপনার কম্পিউটারে ইনস্টল করা নাও থাকতে পারে।',
    download_sharelook: 'ShareLook ডাউনলোড করুন',
    launch_sharelook_application: 'ShareLook অ্যাপ চালু করুন',
    this_will_open_the_sharelook_application_for_screen_capture:
      'এটি স্ক্রিন ক্যাপচারের জন্য ShareLook অ্যাপ খুলবে।',
    sharelook_dosenot_open:
      'যদি ShareLook না খোলে, তবে এটি আপনার কম্পিউটারে ইনস্টল করা নাও থাকতে পারে।',
    open_sharelook: 'ShareLook খুলুন',
    download_app: 'অ্যাপ ডাউনলোড করুন',
    background_image_setting: 'পটভূমি ছবির সেটিংস',
    current_image: 'বর্তমান ছবি',
    change_image: 'ছবি পরিবর্তন করুন',
    remove_image: 'ছবি মুছে ফেলুন',
    no_background_image_selected: 'কোনও ব্যাকগ্রাউন্ড ছবি নির্বাচিত হয়নি',
    add_image: 'ছবি যোগ করুন',
    this_will_open_for_screen_recording:
      'এটি স্ক্রিন রেকর্ডিংয়ের জন্য ShareLook অ্যাপ খুলবে।',
    ai_image_generation: 'AI চিত্র তৈরি',
    image_edit: 'ছবি সম্পাদনা',
    text_to_image: 'টেক্সট থেকে ছবি',
    output_gallary: 'আউটপুট গ্যালারি',
    instant_generation: 'তাৎক্ষণিকভাবে তৈরি করতে প্রস্তুত',
    prompt_and_unleash_the_power:
      'আপনার নির্দেশনা লিখুন এবং সম্ভাবনা উন্মোচন করুন',
    use_this_image: 'এই ছবি ব্যবহার করুন',
    error_generating: 'তৈরির সময় ত্রুটি ঘটেছে।',
    generation_tips: 'তৈরির টিপস',
    detailed_descriptions_for_more_accurate_results:
      'আরও সঠিক ফলাফলের জন্য বিস্তারিত বিবরণ ব্যবহার করুন',
    reference_image: 'রেফারেন্স ছবি',
    select_pixel_image: 'পিক্সেল ছবি নির্বাচন করুন',
    max_mb: 'সর্বাধিক ৫০ এমবি',
    please_enter_text_to_appear_image: 'ছবিতে প্রদর্শিত হবে এমন টেক্সট লিখুন',
    enter_text_to_apear_in_the_image: 'ছবিতে প্রদর্শনের জন্য টেক্সট লিখুন',
    generate_image: 'ছবি তৈরি করুন',
    prompt_assistant: 'প্রম্পট সহকারী',
    generate_image_using_suggested_prompt:
      'প্রস্তাবিত প্রম্পট ব্যবহার করে ছবি তৈরি করুন',
    talk_to_ai_about_the_image_generate:
      'আপনি যে ছবি তৈরি করতে চান তা নিয়ে AI-এর সাথে কথা বলুন',
    ask_for_prompt_suggestions: 'প্রম্পট প্রস্তাবনা চাইুন...',
    enter_a_search_term_to_find_stock_images:
      'স্টক ইমেজ খুঁজতে একটি অনুসন্ধান শব্দ লিখুন',
    choose_your_content_source: 'আপনার কনটেন্ট উৎস নির্বাচন করুন:',
    upload_new_document_from_your_device:
      'আপনার ডিভাইস থেকে নতুন নথি আপলোড করুন',
    automatic_library_selection: 'স্বয়ংক্রিয় লাইব্রেরি নির্বাচন',
    system_automatically_selects_relevant_document:
      'সিস্টেম স্বয়ংক্রিয়ভাবে প্রাসঙ্গিক নথি নির্বাচন করে',
    manual_library_selection: 'ম্যানুয়াল লাইব্রেরি নির্বাচন',
    generate_content: 'কনটেন্ট তৈরি করুন',
    add_to_current_page: 'বর্তমান পৃষ্ঠায় যোগ করুন',
    generate_bullet_points: 'বুলেট পয়েন্ট তৈরি করুন',
    generating: 'তৈরি হচ্ছে',
    this_may_take_a_few_moments: 'এটি কয়েক মুহূর্ত সময় নিতে পারে',
    apply_to_page: 'পৃষ্ঠায় প্রয়োগ করুন',
    scenario_escription: 'সিনারিও বর্ণনা:',
    feedback: 'প্রতিক্রিয়া',
    form_mode: 'ফর্ম মোড',
    chat_mode: 'চ্যাট মোড',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'এটি নির্বাচিত গল্পের ধারাবাহিকতা তৈরি করবে AI ব্যবহার করে।',
    continue_this_story_question: 'এই গল্পটি চালিয়ে যাবেন?',
    continue_this_story: 'গল্পটি চালিয়ে যান',
    what_will_happen: 'কি হবে:',
    the_ai_will_analyze_the_existing_story_content:
      'AI বিদ্যমান গল্পের বিষয়বস্তু বিশ্লেষণ করবে',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'একই সুর ও শৈলী বজায় রেখে একটি স্বাভাবিক ধারাবাহিকতা তৈরি করুন',
    create_new_content_that_build_upon_the_current_narrative:
      'বর্তমান বর্ণনার উপর ভিত্তি করে নতুন কনটেন্ট তৈরি করুন',
    this_process_may_take_a_few_moments_to_complete:
      'এই প্রক্রিয়াটি সম্পূর্ণ হতে কয়েক মুহূর্ত সময় লাগতে পারে।',
    no_existing_stories_found_for_this_course:
      'এই কোর্সের জন্য কোনও বিদ্যমান গল্প পাওয়া যায়নি।',
    create_your_first_story: 'আপনার প্রথম গল্প তৈরি করুন',
    existing_stories: 'বিদ্যমান গল্পগুলি',
    create_new_story: 'নতুন গল্প তৈরি করুন',
    tone: 'সুর',
    style: 'শৈলী',
    genre: 'ধরন',
    loading_your_stories: 'আপনার গল্প লোড হচ্ছে...',
    edit_story: 'গল্প সম্পাদনা করুন',
    story_preferences: 'গল্পের পছন্দসমূহ',
    please_input_your: 'অনুগ্রহ করে লিখুন আপনার',
    add_character_names_and_press_enter:
      'চরিত্রের নাম যোগ করুন এবং Enter চাপুন',
    select_or_type_your: 'নির্বাচন করুন বা লিখুন আপনার',
    enter_your: 'লিখুন আপনার',
    position_of_the_story_in_the_lesson:
      'গল্পের অবস্থান পাঠে। গল্পটি নির্দিষ্ট অবস্থানে একটি ব্লক হিসাবে যোগ করা হবে।',
    save_previous_content_on_the_pages:
      'পৃষ্ঠার পূর্ববর্তী কনটেন্ট সংরক্ষণ করুন',
    the_existing_content_in_the_selected_pages:
      'নির্বাচিত পৃষ্ঠাগুলির বিদ্যমান কনটেন্ট নতুন তৈরি গল্প দ্বারা প্রতিস্থাপিত হবে।',
    real_world_scenario: 'বাস্তব জগতের সিনারিও',
    add_optional_instructions:
      'ঐচ্ছিক নির্দেশনা যোগ করুন (সুর, দৈর্ঘ্য, শ্রোতা ইত্যাদি)',
    ready_to_enerate_your_real_world_scenario:
      'আপনার বাস্তব জগতের সিনারিও তৈরি করতে প্রস্তুত',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      '“বাস্তব জগতের সিনারিও তৈরি করুন” ক্লিক করে আপনার পাঠের কনটেন্ট অনুযায়ী একটি বাস্তবসম্মত সিনারিও তৈরি করুন।',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI আপনার পাঠের বিষয় ও কনটেন্ট বিশ্লেষণ করবে',
    generate_a_practical_real_world_scenario:
      'একটি বাস্তবসম্মত ও প্রায়োগিক সিনারিও তৈরি করুন',
    you_can_then_edit_and_customize_the_result:
      'এরপর আপনি ফলাফলটি সম্পাদনা ও কাস্টমাইজ করতে পারবেন',
    add_it_as_a_new_page_to_your_lesson:
      'এটি আপনার পাঠের নতুন পৃষ্ঠা হিসেবে যোগ করুন',
    regenerate_with_instructions: 'নির্দেশনা সহ পুনরায় তৈরি করুন',
    add_real_world_scenario: 'বাস্তব বিশ্বের দৃশ্যপট যোগ করুন',
    generate_real_world_scenario: 'বাস্তব বিশ্বের দৃশ্যপট তৈরি করুন',
    simulation_has_been_stopped: 'সিমুলেশন বন্ধ করা হয়েছে!',
    loading_simulation: 'সিমুলেশন লোড হচ্ছে...',
    you_have_exhausted_all_the_attempts: 'আপনি সমস্ত প্রচেষ্টা ব্যবহার করেছেন',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'এই পাতার দৃশ্যপটটি অধ্যয়ন করুন এবং নীচের বিকল্পগুলি থেকে সঠিক উত্তর নির্বাচন করুন।',
    attempts_limit_reached:
      'চেষ্টা সীমা পৌঁছেছে। আপনি আবার খেলতে পারবেন কিন্তু আপনার স্কোর সংরক্ষিত হবে না।',
    play_again: 'আবার খেলুন',
    import_music_from_computer: 'কম্পিউটার থেকে সঙ্গীত ইম্পোর্ট করুন।',
    more: 'আরও',
    no_badge_yet: 'এখনও কোনো ব্যাজ নেই',
    competition_filter: 'প্রতিযোগিতা ফিল্টার',
    global_leaderboard: 'গ্লোবাল লিডারবোর্ড',
    placeholder_for_the_global_leaderboard:
      'গ্লোবাল লিডারবোর্ডের জন্য এটি একটি প্লেসহোল্ডার।',
    badge_editor: 'ব্যাজ এডিটর',
    adjust_the_appearance_of_this_badge_icon:
      'এই ব্যাজ আইকনের চেহারা সামঞ্জস্য করুন। পরিবর্তনগুলি কেবল এই ব্যাজের জন্য প্রযোজ্য।',
    badge_style: 'ব্যাজ স্টাইল',
    the_image_must_be_pixels: 'ছবিটি 200x200 পিক্সেল হতে হবে।',
    badge_name: 'ব্যাজের নাম',
    badge_descrription: 'ব্যাজের বর্ণনা',
    enter_badge_criteria: 'ব্যাজের মানদণ্ড লিখুন',
    discard: 'বাতিল করুন',
    badge_enable: 'ব্যাজ সক্রিয়',
    award_users_with_badges_to_highlight_the_milestones:
      'ব্যবহারকারীদের শেখার যাত্রায় মাইলফলক হাইলাইট করতে ব্যাজ দিন।',
    badge_types: 'ব্যাজের ধরন',
    enable_or_disable_specific_badge_types_for_your_users:
      'ব্যবহারকারীদের জন্য নির্দিষ্ট ব্যাজের ধরন সক্রিয় বা নিষ্ক্রিয় করুন।',
    levels_enabled: 'লেভেল সক্রিয়',
    level_rules: 'লেভেলের নিয়ম',
    points: 'পয়েন্ট',
    add_new_level: 'নতুন লেভেল যোগ করুন',
    add_level: 'লেভেল যোগ করুন',
    points_enabled: 'পয়েন্ট সক্রিয়',
    learning_activities_and_encourage_healthy_competition:
      'বিভিন্ন শেখার কার্যক্রমের জন্য ব্যবহারকারীদের পয়েন্ট দিন এবং স্বাস্থ্যকর প্রতিযোগিতা উৎসাহিত করুন।',
    award_points: 'পয়েন্ট দিন',
    the_following_equates_the_value_of_one_item_completion:
      'নিম্নলিখিত একটি আইটেম সম্পূর্ণ করার সমতুল্য',
    general: 'সাধারণ',
    others: 'অন্যান্য',
    certificate: 'সার্টিফিকেট',
    quiz_passed: 'কুইজ পাস হয়েছে',
    tip_approved: 'টিপ অনুমোদিত',
    tip_liked: 'টিপ পছন্দ হয়েছে',
    rewards: 'পুরস্কার',
    offer_discounts_when_learners_achieve:
      'শিক্ষার্থীরা নির্দিষ্ট পয়েন্ট, ব্যাজ বা লেভেল অর্জন করলে ডিসকাউন্ট অফার করুন।',
    give_rewards: 'পুরস্কার দিন',
    discount_course_purchases_by: 'কোর্স ক্রয়ে ডিসকাউন্ট দিন',
    with_points_more_than: 'যদি পয়েন্ট বেশি হয়',
    with_badges_more_than: 'যদি ব্যাজ বেশি হয়',
    with_level_upwards_more_than: 'যদি লেভেল বেশি হয়',
    leaderboard: 'লিডারবোর্ড',
    leaderboard_enabled: 'লিডারবোর্ড সক্রিয়',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'লিডারবোর্ড ব্যবহারকারীদের তাদের শেখার অগ্রগতির সংক্ষিপ্ত চিত্র প্রদান করে।',
    show_levels: 'লেভেল দেখান',
    show_points: 'পয়েন্ট দেখান',
    show_badges: 'ব্যাজ দেখান',
    show_courses: 'কোর্স দেখান',
    show_certificates: 'সার্টিফিকেট দেখান',
    leaderboard_settings: 'লিডারবোর্ড সেটিংস',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'শিক্ষার্থীদের প্রেরণা বাড়ানোর জন্য আকর্ষণীয় লিডারবোর্ড অভিজ্ঞতা তৈরি করুন।',
    award_users_with_points_for_different_learning_activities:
      'বিভিন্ন শেখার কার্যক্রমের জন্য ব্যবহারকারীদের পয়েন্ট দিন।',
    badge_set: 'ব্যাজ সেট',
    choose_the_type_of_badges_your_users:
      'ব্যবহারকারীরা শেখার সময় কোন ধরনের ব্যাজ অর্জন করবে তা নির্বাচন করুন।',
    levels: 'লেভেল',
    Levels_represent_the_stages:
      'লেভেল ব্যবহারকারীর শেখার যাত্রার ধাপগুলো প্রতিনিধিত্ব করে।',
    enabled: 'সক্রিয়',
    disabled: 'নিষ্ক্রিয়',
    quick_select: 'দ্রুত নির্বাচন',
    yesterday: 'গতকাল',
    last_week: 'গত সপ্তাহ',
    Last_month: 'গত মাস',
    last_quarter: 'গত ত্রৈমাসিক',
    historical_leaderboard: 'ঐতিহাসিক লিডারবোর্ড',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'আপনার কর্মক্ষমতা ট্র্যাক করুন এবং দেখুন আপনি সহকর্মীদের মধ্যে কোথায় অবস্থান করছেন।',
    time_period: 'সময়ের পরিধি',
    page_of: 'পৃষ্ঠা 1 এর 1',
    edit_competition: 'প্রতিযোগিতা সম্পাদনা করুন',
    create_competition: 'প্রতিযোগিতা তৈরি করুন',
    arrow_right: 'ডান তীর',
    update_competition: 'প্রতিযোগিতা আপডেট করুন',
    competition_title: 'প্রতিযোগিতার শিরোনাম',
    enter_competition_title: 'প্রতিযোগিতার শিরোনাম লিখুন',
    enter_competition_description: 'প্রতিযোগিতার বিবরণ লিখুন',
    leaderboard_skill: 'দক্ষতা',
    select_a_skill: 'একটি দক্ষতা নির্বাচন করুন',
    no_skills_found: 'কোনও দক্ষতা পাওয়া যায়নি',
    competition_period: 'প্রতিযোগিতার সময়কাল',
    add_badge_rule: 'ব্যাজ নিয়ম যোগ করুন',
    create_badge: 'ব্যাজ তৈরি করুন',
    add_level_rule: 'লেভেল নিয়ম যোগ করুন',
    selected_participants: 'নির্বাচিত অংশগ্রহণকারীরা',
    no_participants: 'কোনও অংশগ্রহণকারী নেই',
    start_end_date: 'শুরু–শেষ তারিখ',
    created_date: 'দ্বারা তৈরি',
    new_competition: 'নতুন প্রতিযোগিতা',
    competitions_list: 'প্রতিযোগিতা তালিকা',
    search_competitions: 'প্রতিযোগিতা অনুসন্ধান করুন...',
    are_you_sure_you_want_to_delete_the_competition:
      'আপনি কি নিশ্চিত যে আপনি প্রতিযোগিতা মুছে ফেলতে চান?',
    history: 'ইতিহাস',
    export: 'রপ্তানি করুন',
    search_by_name: 'নাম দ্বারা অনুসন্ধান করুন...',
    no_historical_data_available_for_the_selected_period:
      'নির্বাচিত সময়ের জন্য কোনও ইতিহাস তথ্য নেই।',
    no_leaderboard_data_available: 'লিডারবোর্ড তথ্য নেই।',
    competitions: 'প্রতিযোগিতা',
    leaderboards: 'লিডারবোর্ড',
    welcome_back: 'ফিরে আসার জন্য স্বাগতম',
    track_your_performance_and_see: 'আপনার কর্মক্ষমতা ট্র্যাক করুন এবং দেখুন:',
    team_leaderboard: 'টিম লিডারবোর্ড',
    try_again: 'আবার চেষ্টা করুন',
    no_competitions_for_search: 'অনুসন্ধানের জন্য কোনও প্রতিযোগিতা নেই',
    no_competitions_available: 'কোনও প্রতিযোগিতা উপলব্ধ নেই',
    no_competitions_matching_search:
      'আপনার অনুসন্ধানের সাথে মিলিত কোনও প্রতিযোগিতা পাওয়া যায়নি। শব্দগুলি পরিবর্তন করে আবার চেষ্টা করুন বা পরে পরীক্ষা করুন।',
    no_competitions_general:
      'বর্তমানে কোনো প্রতিযোগিতা তৈরি হয়নি। পরে পরীক্ষা করুন বা নতুন প্রতিযোগিতা তৈরি করতে প্রশাসকের সাথে যোগাযোগ করুন।',
    media_management: 'মিডিয়া ব্যবস্থাপনা',
    badgess_set: 'ব্যাজ সেট',
    choose_the_default_visual_style_for_badge:
      'প্ল্যাটফর্ম জুড়ে ব্যবহৃত ব্যাজ আইকনের জন্য ডিফল্ট ভিজ্যুয়াল স্টাইল নির্বাচন করুন।',
    enable_badges: 'ব্যাজ সক্রিয় করুন',
    add_badge: 'ব্যাজ যোগ করুন',
    min: 'ন্যূনতম',
    max: 'সর্বাধিক',
    your_rank: 'আপনার র‍্যাঙ্ক',
    your_points: 'আপনার পয়েন্ট',
    your_level: 'আপনার লেভেল',
    rank: 'র‍্যাঙ্ক #',
    level: 'লেভেল',
    progress: 'অগ্রগতি',
    new_folder: 'নতুন ফোল্ডার',
    file_upload: 'ফাইল আপলোড',
    writer: 'লেখক',
    text_documents: 'টেক্সট ডকুমেন্ট',
    spreadsheets: 'স্প্রেডশীট',
    impress: 'ইমপ্রেস',
    presentations: 'প্রেজেন্টেশন',
    capture_desktop_screen: 'ডেস্কটপ স্ক্রীন ক্যাপচার',
    capture_desktop_screens: 'ডেস্কটপ স্ক্রীন ক্যাপচার',
    your_documents: 'আপনার ডকুমেন্ট',
    manage_your_videos_images_audio_files:
      'আপনার ভিডিও, ছবি, অডিও ফাইল এবং অন্যান্য কনটেন্ট অ্যাসেট পরিচালনা করুন।',
    your_organization_documents: 'আপনার প্রতিষ্ঠানের ডকুমেন্ট',
    keep_your_organization_creative_assets_organized:
      'আপনার প্রতিষ্ঠানের সৃজনশীল অ্যাসেটগুলি সঠিকভাবে সংরক্ষণ করুন ও পরিচালনা করুন।',
    your_public_documents: 'আপনার পাবলিক ডকুমেন্ট',
    curated_collection_of_media_assets_available:
      'সবার জন্য নির্বাচিত মিডিয়া অ্যাসেটের সংগ্রহ—এক্সপ্লোর করুন, পুনঃব্যবহার করুন এবং তৈরি করুন।',
    your_download_center_documents: 'আপনার ডাউনলোড সেন্টারের ডকুমেন্ট',
    repository_of_approved_media_assets_for_download:
      'ডাউনলোডের জন্য অনুমোদিত মিডিয়া অ্যাসেটের সংগ্রহ।',
    search_files_and_folders: 'ফাইল এবং ফোল্ডার অনুসন্ধান করুন...',
    home: 'হোম',
    folders: 'ফোল্ডার',
    folder_name: 'ফোল্ডারের নাম',
    owner: 'মালিক',
    last_updated: 'শেষ আপডেট',
    action: 'কর্ম',
    no_folders_found: 'কোনও ফোল্ডার পাওয়া যায়নি',
    files: 'ফাইল',
    enabling_ai: 'AI সক্রিয় করা হচ্ছে...',
    rename: 'পুনঃনামকরণ',
    copy: 'কপি করুন',
    move: 'সরান',
    verson_history: 'ভার্সন ইতিহাস',
    manage_permission: 'অনুমতি পরিচালনা করুন',
    generate_audit_report: 'অডিট রিপোর্ট তৈরি করুন',
    last_edited: 'শেষ সম্পাদনা',
    no_files_found: 'কোনও ফাইল পাওয়া যায়নি',
    are_you_sure_you_want_to_make_this_item_public:
      'আপনি কি নিশ্চিত যে আপনি এই আইটেমটি পাবলিক করতে চান? এটি আপনার পাবলিক লাইব্রেরিতে কপি হবে।',
    move_to_organization: 'প্রতিষ্ঠানে স্থানান্তর করুন',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'আপনি কি নিশ্চিত যে আপনি এই আইটেমটি আপনার প্রতিষ্ঠানের লাইব্রেরিতে কপি করতে চান?',
    are_you_sure_you_want_to_make_this_item_private:
      'আপনি কি নিশ্চিত যে আপনি এই আইটেমটি প্রাইভেট করতে চান? এটি আপনার নিজস্ব লাইব্রেরিতে কপি হবে।',
    date_modified: 'পরিবর্তনের তারিখ',
    workflow_management: 'ওয়ার্কফ্লো ম্যানেজমেন্ট',
    configure_editors_approvers_and_viewers_for_this_document:
      'এই ডকুমেন্টের জন্য সম্পাদক, অনুমোদক এবং দর্শক কনফিগার করুন।',
    error_Loading_editor: 'এডিটর লোড করতে ত্রুটি',
    debug_info: 'ডিবাগ তথ্য',
    loading_editor: 'এডিটর লোড হচ্ছে...',
    submitted_for_review: 'রিভিউয়ের জন্য জমা দেওয়া হয়েছে',
    editors: 'সম্পাদক',
    no_editors_added_yet:
      'কোনও সম্পাদক যোগ করা হয়নি। একটি যোগ করতে "সম্পাদক যোগ করুন" ক্লিক করুন।',
    add_editor: 'সম্পাদক যোগ করুন',
    approvers: 'অনুমোদক',
    no_approvers_added_yet:
      'কোনও অনুমোদক যোগ করা হয়নি। একটি যোগ করতে "অনুমোদক যোগ করুন" ক্লিক করুন।',
    add_approvers: 'অনুমোদক যোগ করুন',
    viewer: 'দর্শক',
    no_viewers_added_yet:
      'কোনও দর্শক যোগ করা হয়নি। একটি যোগ করতে "দর্শক যোগ করুন" ক্লিক করুন।',
    add_viewer: 'দর্শক যোগ করুন',
    are_you_sure_you_want_to_delete_the_selected_items:
      'আপনি কি নিশ্চিত যে আপনি নির্বাচিত আইটেমগুলি মুছে ফেলতে চান?'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'শ্রেণীর ওভারভিউ',
    triviaReport: 'ShareSphere শ্রেণী',
    overviewGraph: 'শ্রেণীর ওভারভিউ গ্রাফ',
    category: 'শ্রেণী',
    phCategory: 'শ্রেণী নির্বাচন করুন',
    podcast: 'পডকাস্ট, সঙ্গীত এবং গল্প',
    pastPodcast: 'অতীতের পডকাস্ট',
    upcomingPodcast: 'আসন্ন পডকাস্ট',
    podcastLanguageTitle: 'পডকাস্ট, সঙ্গীত ও গল্পের ভাষা',
    podcastLanguageCheckbox: 'আমার পডকাস্টের জন্য AI দ্বারা ভাষা তৈরি করুন',
    howRate: 'আপনি এই পডকাস্টকে কত রেট দিবেন?',
    podcastSubmit: 'জমা দিন',
    podcastGuest: 'অতিথি বক্তা:',
    podcastReview: 'পর্যালোচনা',
    podcastEpishode: 'এপিসোড',
    podcastEnd: 'পডকাস্ট শেষ হয়েছে',
    date_podcast: 'পডকাস্ট তারিখ',
    skill_not_found: 'দুঃখিত! কোনো দক্ষতা যাত্রা পাওয়া যায়নি।',
    coaching: 'কোচিং',
    webinar: 'ওয়েবিনার',
    public_conference: 'পাবলিক কনফারেন্স',
    skill_journey_subtitle:
      'আপনার দক্ষতা যাত্রার সেটিংস যোগ করুন এবং নির্বাচন করুন কে আপনার দক্ষতা যাত্রা দেখতে ও ইন্টারঅ্যাক্ট করতে পারবে।',
    enable_white_label: 'হোয়াইট লেবেল সক্ষম করুন',
    create_new_event_org: 'আপনার প্রতিষ্ঠানের জন্য একটি নতুন ইভেন্ট তৈরি করুন।',
    create_new_event_marketplace:
      'মার্কেটপ্লেসের জন্য একটি নতুন ইভেন্ট তৈরি করুন।',
    create_new_event_both:
      'আপনার প্রতিষ্ঠান ও মার্কেটপ্লেস উভয়ের জন্য নতুন ইভেন্ট তৈরি করুন।',
    event_outline: 'অনুগ্রহ করে ইভেন্টের রূপরেখা লিখুন',
    event_obj: 'অনুগ্রহ করে ইভেন্টের উদ্দেশ্য লিখুন',
    event_description: 'অনুগ্রহ করে ইভেন্টের বিবরণ লিখুন',
    create_new_metamaze_org:
      'আপনার প্রতিষ্ঠানের জন্য একটি নতুন MetaMaze তৈরি করুন।',
    create_new_metamaze_marketplace:
      'মার্কেটপ্লেসের জন্য একটি নতুন MetaMaze তৈরি করুন।',
    create_new_metamaze_both:
      'আপনার প্রতিষ্ঠান ও মার্কেটপ্লেস উভয়ের জন্য নতুন MetaMaze তৈরি করুন।',
    add_key_words: 'কীওয়ার্ড যোগ করুন',
    press_enter_make_keyword: 'কীওয়ার্ড তৈরির জন্য এন্টার চাপুন',
    disable_skip_quiz: 'কুইজ স্কিপ নিষ্ক্রিয় করুন',
    warning_complete_quiz: 'অগ্রসর হওয়ার জন্য দয়া করে কুইজ সম্পূর্ণ করুন।',
    signup_email_verification:
      'আমরা আপনার প্রদত্ত ঠিকানায় একটি যাচাইকরণ লিঙ্ক পাঠিয়েছি। অনুগ্রহ করে ওই লিঙ্কে গিয়ে আপনার নিবন্ধন নিশ্চিত করুন।',
    verifying_registration: 'অ্যাকাউন্ট নিবন্ধন যাচাই করা হচ্ছে...',
    reset_password_linK:
      'আমরা আপনার প্রদত্ত ঠিকানায় একটি লিঙ্ক পাঠিয়েছি। অনুগ্রহ করে ওই লিঙ্কে গিয়ে নতুন পাসওয়ার্ড সেট করুন।',
    reset_email_error:
      'এই ইমেইল দিয়ে কোনো ব্যবহারকারী পাওয়া যায়নি, দয়া করে ব্যবহারকারীর নাম ব্যবহার করে আবার চেষ্টা করুন!',
    first_name: 'প্রথম নাম',
    last_name: 'শেষ নাম',
    error_firstName: 'দয়া করে আপনার প্রথম নাম লিখুন',
    error_sharebot_organization: 'দয়া করে আপনার প্রতিষ্ঠান লিখুন',
    error_lastName: 'দয়া করে আপনার শেষ নাম লিখুন',
    private_conference: 'বেসরকারি সম্মেলন',
    public_conference: 'পাবলিক কনফারেন্স',
    discussion_room: 'আলোচনা কক্ষ',
    training_no_courses: 'আপনি বর্তমানে কোনো কোর্সে নাম লেখাননি।',
    training_no_events: 'আপনি বর্তমানে কোনো ইভেন্টে নাম লেখাননি।',
    allow_sharing_trainer_info:
      'মার্কেটপ্লেসে ইমেইল ঠিকানা শেয়ার করার অনুমতি দিন',
    error_username_space: 'ব্যবহারকারীর নামের মধ্যে স্পেস থাকতে পারবে না।',
    error_sharebot_organization_space:
      'প্রতিষ্ঠানের নামের মধ্যে স্পেস থাকতে পারবে না।',
    edit_permission: 'সম্পাদনার অনুমতি',
    valid_price: 'মূল্য ০ এর চেয়ে বেশি হতে হবে',
    course_price_message: `*কোর্সটি শুধুমাত্র সেই সংখ্যক ব্যবহারকারীর কাছে প্রকাশিত হবে যা প্রতিষ্ঠান কিনেছে এবং এটি মার্কেটপ্লেসে পুনর্বিক্রি করা যাবে না`,
    valid_edit_price: 'সম্পাদনার মূল্য ক্রয়ের মূল্যের চেয়ে কম হতে হবে।',
    my_calendar: 'আমার ক্যালেন্ডার',
    error_valid_firstName: 'দয়া করে একটি বৈধ প্রথম নাম লিখুন।',
    error_valid_organization: 'দয়া করে একটি বৈধ প্রতিষ্ঠান নাম লিখুন।',
    error_valid_lastName: 'দয়া করে একটি বৈধ শেষ নাম লিখুন।',
    error_name_spaces: 'নামে স্পেস থাকতে পারবে না',
    items: 'আইটেম',
    publish_to_channel: 'আমার চ্যানেল কালেকশনে প্রকাশ করুন',
    create_a_channel: 'আমার চ্যানেল তৈরি করুন',
    create_a_trivia: 'ট্রিভিয়া গেম তৈরি করুন',
    create_a_new_channel: 'নতুন একটি চ্যানেল তৈরি করুন',
    add_videos: 'ভিডিও যোগ করুন',
    save_and_continue: 'সংরক্ষণ ও চালিয়ে যান',
    channel: 'চ্যানেল',
    channels: 'চ্যানেলসমূহ',
    view_channel: 'চ্যানেল দেখুন',
    edit_channel: 'চ্যানেল সম্পাদনা করুন',
    delete_channel: 'চ্যানেল মুছে ফেলুন',
    my_video_channels: 'আমার ভিডিও চ্যানেলসমূহ',
    training_no_channel: 'আপনি বর্তমানে কোনো চ্যানেলে নাম লেখাননি।',
    monthly_price_required: 'মাসিক মূল্য আবশ্যক',
    yearly_price_required: 'বার্ষিক মূল্য আবশ্যক',
    one_time_price_required: 'এককালীন মূল্য আবশ্যক',
    marketplace_quantity: 'USD',
    report_webinar: 'ওয়েবিনার',
    report_coaching: 'কোচিং',
    report_channel: 'চ্যানেল',
    report_public_conference: 'পাবলিক কনফারেন্স',
    report_maze: 'মেজ',
    channel: 'চ্যানেল',
    edit_price: 'মূল্য সম্পাদনা করুন ($)',
    quantity: 'পরিমাণ',
    payment_type: 'পেমেন্ট টাইপ',
    total_amount: 'মোট পরিমাণ ($)',
    net_amount: 'নিট পরিমাণ ($)',
    edit_option: 'সম্পাদনা অপশন',
    marketplace_price: 'মূল্য ($)',
    market_name: 'নাম',
    duration_min: 'সময়কাল (মিনিট)',
    users_total: 'ব্যবহারকারী (মোট)',
    sales_total: 'বিক্রয় মোট (USD)',
    search_coaching: 'কোচিং অনুসন্ধান করুন',
    search_channel: 'চ্যানেল অনুসন্ধান করুন',
    search_webinar: 'ওয়েবিনার অনুসন্ধান করুন',
    search_maze: 'মেজ অনুসন্ধান করুন',
    search_public_conference: 'পাবলিক কনফারেন্স অনুসন্ধান করুন',
    buyer_type: 'ক্রেতার ধরন',
    quanity: 'পরিমাণ',
    channel_unit_amount: 'নিট পরিমাণ ($)',
    channel_updated_at: 'আপডেটের তারিখ',
    month_price: 'মূল্য (মাস)',
    year_price: 'মূল্য (বছর)',
    one_time_price: 'মূল্য (এককালীন)',
    sharebot_organization: 'নতুন প্রতিষ্ঠান নাম যোগ করুন',
    share_sphere: 'ShareSphere',
    ai_course_title: 'কোর্স শিরোনাম',
    ai_input_course_title: 'দয়া করে কোর্স শিরোনাম লিখুন!',
    learning_objective_label: 'শিক্ষার উদ্দেশ্য',
    learning_objective_message: 'দয়া করে শিক্ষার উদ্দেশ্য লিখুন!',
    standard_question: 'শিক্ষার্থীকে কি কোনো মান অনুসরণ করতে হবে?',
    standard_details_label: 'মানের বিবরণ',
    standard_details_message: 'দয়া করে মানের বিবরণ লিখুন!',
    estimated_duration_label: 'কোর্সের আনুমানিক সময়কাল (মিনিটে)',
    estimated_duration_message: 'দয়া করে আনুমানিক সময়কাল লিখুন!',
    min_duration_message: 'ন্যূনতম সময়কাল ৫ মিনিট।',
    ai_mins: '২৫ মিনিট',
    industry_specific_question: 'এটি কি শিল্প নির্দিষ্ট?',
    industry_label: 'শিল্প নির্ধারণ করুন',
    industry_message: 'দয়া করে শিল্প লিখুন!',
    ai_course_creation: 'এআই কোর্স নির্মাণ',
    course_generated: 'শেয়ারলুক দ্বারা কোর্স তৈরি হয়েছে',
    ai: 'এআই',
    ai_you: 'আপনি',
    ai_prompt_ready:
      'আপনার প্রম্পট প্রস্তুত। এখন আপনি বিষয়সূচি তৈরি করতে প্রস্তুত।',
    ai_unable_respond:
      'দুঃখিত! এআই আপনার প্রম্পটে সাড়া দিতে পারছে না। অনুগ্রহ করে পুনরায় চেষ্টা করুন।',
    ai_hide_toc: 'বিষয়সূচি লুকান',
    ai_preview_toc: 'বিষয়সূচি পূর্বদর্শন',
    ai_generate_toc_now: 'এখনই বিষয়সূচি তৈরি করুন',
    ai_creation_course_title: 'কোর্স শিরোনাম:',
    ai_creation_industry_specific: 'এটি কি শিল্প নির্দিষ্ট:',
    ai_creation_industry: 'শিল্প:',
    ai_creation_standard_needed: 'শিক্ষার্থীরা কি কোনো মান অনুসরণ করতে হবে?:',
    ai_creation_standard_details: 'মানের বিবরণ:',
    ai_creation_estimated_duration: 'কোর্সের আনুমানিক সময়কাল (মিনিটে):',
    minutes: 'মিনিট',
    ai_creation_learning_objective: 'শিক্ষার উদ্দেশ্য:',
    setup_again: 'আবার সেটআপ করুন',
    ai_creation_confirm_title:
      'আপনি কি নিশ্চিত যে আপনি আবার ফর্ম সেটআপ করতে চান?',
    ai_creation_confirm_content:
      'চ্যাট ও আপনি যা কিছু তৈরি করেছেন সব রিসেট হয়ে যাবে।',
    ai_toc: 'বিষয়সূচি',
    ai_note_topic:
      'দ্রষ্টব্য: আপনি পাঠের বিষয়গুলি পুনর্বিন্যাস করার জন্য ড্র্যাগ এবং ড্রপ করতে পারেন।',
    ai_add_topic: '+ বিষয় যোগ করুন',
    add_topic: 'বিষয় যোগ করুন',
    add_lesson: 'পাঠ যোগ করুন',
    add_new_lesson: 'নতুন পাঠ যোগ করুন',
    ai_add_lesson: '+ পাঠ যোগ করুন',
    attention: 'সতর্কতা',
    before_varifying: 'যাচাই করার আগে',
    ai_save_later: 'পরবর্তীতে সংরক্ষণ করুন',
    ai_download_word_doc: 'ওয়ার্ড ডকুমেন্ট হিসেবে ডাউনলোড করুন',
    ai_download_course_word_doc: 'কোর্সটি ওয়ার্ড ডকুমেন্ট হিসেবে ডাউনলোড করুন',
    ai_create_course_button: 'কোর্স তৈরি করুন',
    ai_generate_course_content: 'কোর্সের বিষয়বস্তু তৈরি করুন',
    ai_out_of: 'এর মধ্যে',
    ai_subtopic_failed_content:
      'সাবটপিকের বিষয়বস্তু তৈরি করতে ব্যর্থ হয়েছে। শুধুমাত্র সেগুলো জন্য পুনরায় "কোর্স বিষয়বস্তু তৈরি করুন" ক্লিক করুন।',
    ai_edit_topic: 'বিষয় সম্পাদনা করুন',
    ai_edit_lesson_title: 'পাঠ শিরোনাম সম্পাদনা করুন',
    ai_save_topic: 'বিষয় সংরক্ষণ করুন',
    ai_save: 'সংরক্ষণ করুন',
    ai_save_lesson_title: 'পাঠ শিরোনাম সংরক্ষণ করুন',
    ai_add_new_topic: 'নতুন বিষয় যোগ করুন',
    ai_download_ref: 'তথ্যসূত্রসহ ডাউনলোড করুন',
    ai_download_ref_content:
      'তথ্যসূত্রসহ ওয়ার্ড ডকুমেন্ট হিসেবে কোর্স ডাউনলোড হবে।',
    ai_download_without_ref: 'তথ্যসূত্র ছাড়া ডাউনলোড করুন',
    ai_download_two_word: 'দুটি ওয়ার্ড ডকুমেন্ট ডাউনলোড হবে:',
    ai_download_two_word_content_one:
      '- একটি মূল বিষয়বস্তু সহ তথ্যসূত্র ছাড়া,',
    ai_download_two_word_content_two:
      'এবং অন্যটি শুধুমাত্র তথ্যসূত্রের তালিকা নিয়ে, কোনো বিষয়বস্তু ছাড়া।',
    ai_manage_content: 'বিষয়বস্তু পরিচালনা করুন',
    ai_add_content_from_internet: '+ ইন্টারনেট থেকে বিষয়বস্তু যোগ করুন',
    ai_confirm_start: 'শুরু নিশ্চিত করুন',
    ai_Verify: 'যাচাই করুন',
    ai_undo_warning:
      'এই প্রক্রিয়াটি কিছুক্ষণ সময় নিতে পারে। দয়া করে এই উইন্ডো বন্ধ করবেন না যতক্ষণ না তৈরির কাজ শেষ হয়। এটি পূর্বাবস্থায় ফিরানো যাবে না।',
    ai_verified_content:
      'আপনি বিষয়বস্তু যাচাই করেছেন। নিশ্চিতকরণের পর, আপনি বর্তমান বিষয়বস্তু নিয়ে AI চ্যাটে ফিরে আসতে পারবেন না।',
    ai_want_proceed: 'আপনি কি নিশ্চিত যে আপনি এগিয়ে যেতে চান?',
    upload_simulation: 'সিমুলেশন আপলোড করুন',
    name_simulation: 'সিমুলেশন নাম',
    selected_simulation_files: 'নির্বাচিত সিমুলেশন ফাইলগুলি',
    score_between_one_hundred: 'আপনার স্কোর ১ থেকে ১০০ এর মধ্যে হতে হবে।',
    are_sure_simulation: 'আপনি কি এই সিমুলেশন ফাইল মুছে ফেলতে চান?',
    required_simulation: 'স্কোর আবশ্যক',
    required_section_file: 'সেকশন ফাইল আবশ্যক',
    simulation: 'সিমুলেশন',
    simulation_quiz_games: 'গেমসে কুইজ যোগ করতে হবে',
    simulation_alert_des:
      'আপনি কেবলমাত্র সিঙ্গেল বা মাল্টিপল উত্তর টাইপের প্রশ্ন থাকলে গেম যোগ করতে পারবেন।',
    alert_info: 'তথ্য',
    ai_number_quiz: 'কুইজ সংখ্যা',
    ai_point: 'পয়েন্ট',
    ai_points: 'পয়েন্টসমূহ',
    val_required: 'আবশ্যক',
    games: 'গেমস',
    add_simulation: 'সিমুলেশন যোগ করুন',
    text_tiewer: 'টেক্সট ভিউয়ার',
    back_to_account: 'অ্যাকাউন্টে ফিরে যান',
    delete_account: 'অ্যাকাউন্ট মুছুন',
    delete_account_title: 'অ্যাকাউন্ট মুছবেন ???',
    delete_account_subtitle:
      'আপনি এখান থেকে আপনার অ্যাকাউন্ট মুছে ফেলতে পারেন।',
    delete_account_cannot_undo:
      'আপনি আপনার অ্যাকাউন্ট মুছতে যাচ্ছেন। এই কাজ পূর্বাবস্থায় ফেরানো যাবে না।',
    account_org_profile:
      'আপনি আপনার তৈরি করা সব কোর্স, আপনার প্রতিষ্ঠান প্রোফাইল এবং সব সেটিংসও হারাবেন।',
    deleting_account_database:
      'অ্যাকাউন্ট মুছে ফেলা হলে আমাদের ডাটাবেস থেকে আপনার সব তথ্য মুছে যাবে।',
    account_confirm_delete:
      'আপনি কি নিশ্চিত যে আপনি আপনার অ্যাকাউন্ট মুছে ফেলতে চান?',
    action_cannot_be_undone: 'এই কাজ পূর্বাবস্থায় ফেরানো যাবে না।',
    account_delete_message_success:
      'আপনার অ্যাকাউন্ট সফলভাবে মুছে ফেলা হয়েছে।',
    message_edit: 'সম্পাদনা করুন',
    message_delete: 'মুছুন',
    message_reply: 'প্রতিক্রিয়া দিন',
    attached_file: 'সংযুক্ত ফাইল',
    attach_file: 'ফাইল সংযুক্ত করুন',
    attach_des: '২৫ এমবি, সর্বোচ্চ ফাইল সাইজ',
    view: 'দেখুন',
    go_to_marketplace: 'মার্কেটপ্লেসে যান',
    learning_center: 'লার্নিং সেন্টার',
    knowledge_center: 'নলেজ সেন্টার',
    sharebot: 'শেয়ারবট',
    sharebot_help_message: 'আজ আমি কীভাবে আপনাকে সাহায্য করতে পারি?',
    my_organization: 'আমার প্রতিষ্ঠান',
    world_knowledge: 'বিশ্বের জ্ঞান',
    welcome_to_sharelook: 'শেয়ারলুকে স্বাগতম!',
    sharelook_you_want_go: 'আপনি আজ কোথায় যেতে চান?',
    shareLook_learning_management_system:
      'শেয়ারলুক লার্নিং ম্যানেজমেন্ট সিস্টেমে প্রবেশ করুন, যেখানে আপনি আপনার প্রতিষ্ঠানের জন্য লাইভ ইভেন্ট এবং কোর্স তৈরি বা প্রবেশ করতে পারবেন।',
    shareLook_powerful_ai_system:
      'শেয়ারলুকের শক্তিশালী এআই সিস্টেমে প্রবেশ করুন, যেখানে আপনি পিডিএফ আপলোড করে মুহূর্তে দরকারী তথ্য পেতে পারেন। প্রতিষ্ঠান ও বিশ্বজ্ঞান সেকশনে রিসোর্স থেকে দ্রুত উত্তর নিন।',
    edit_now: 'এখনই সম্পাদনা করুন',
    sharelook_log_out:
      'আপনি শেয়ারলুক থেকে লগআউট হয়েছেন। অনুগ্রহ করে লগইন করুন!',
    sorry_error: 'দুঃখিত! আমাদের কিছু সমস্যা হয়েছে।',
    login: 'লগইন',
    refresh_page: 'পেজ রিফ্রেশ করুন',
    just_a_moment: 'একটুক্ষণ অপেক্ষা করুন',
    enter_lname_fname:
      'অগ্রসর হওয়ার জন্য দয়া করে আপনার প্রথম নাম এবং শেষ নাম লিখুন।',
    procced_to_sharelook: 'শেয়ারলুক এ যান',
    option_one: 'অপশন ১',
    option_two: 'অপশন ২',
    selected_image: 'নির্বাচিত ছবি:',
    add_text: 'লেখা যোগ করুন',
    linkdin_is_required: 'লিঙ্কডইন আবশ্যক।',
    bio_is_required: 'বায়ো আবশ্যক।',
    save_user_information: 'ব্যবহারকারীর তথ্য সংরক্ষণ করুন',
    select_all: 'সব নির্বাচন করুন',
    enable_ai: 'এআই সক্রিয় করুন',
    load_more: 'আরো লোড করুন',
    channel_id: 'চ্যানেল আইডি।',
    send: 'পাঠান',
    v4: 'তথ্য',
    subscription: 'সাবস্ক্রিপশন',
    reset_user_flag: 'ব্যবহারকারীর ফ্ল্যাগ রিসেট করুন',
    delete_my_accont: 'আমার অ্যাকাউন্ট মুছুন',
    sharebot_sub_error:
      'সাবস্ক্রিপশন তথ্য আনতে সমস্যা হয়েছে। পুনরায় চেষ্টা করুন!',
    sharebot_no_sub: 'আপনার কোনো সক্রিয় সাবস্ক্রিপশন নেই।',
    sharebot_dont_sub: 'আপনার পূর্ববর্তী কোনো সাবস্ক্রিপশন নেই।',
    sharebot_prev_sub: 'পূর্ববর্তী সাবস্ক্রিপশনসমূহ',
    sharebot_sub: 'শেয়ারবট সাবস্ক্রিপশন',
    sharebot_un_sub: 'শেয়ারবট সাবস্ক্রিপশন বাতিল',
    sharebot_no_available: 'কোনো বিবরণ উপলব্ধ নেই',
    sharebot_start_date: 'শুরু তারিখ:',
    sharebot_end_date: 'শেষ তারিখ:',
    sharebot_sure: 'আপনি কি নিশ্চিত?',
    sharebot_do_you_want: 'আপনি কি করতে চান',
    unsubscribe: 'সাবস্ক্রিপশন বাতিল',
    unsubscribe_what: 'সাবস্ক্রিপশন বাতিল?',
    subscribe: 'সাবস্ক্রাইব',
    subscribe_what: 'সাবস্ক্রাইব?',
    subscribe_now: 'এখন সাবস্ক্রাইব করুন',
    confirm: 'নিশ্চিত করুন',
    sharebot_intel_knowledge_center: 'শেয়ারবটের বুদ্ধিমান জ্ঞান কেন্দ্র',
    sharebot_welcome_paragraph:
      'শেয়ারবটের জ্ঞান কেন্দ্রে স্বাগতম, যা পেশাজীবীদের তথ্য অ্যাক্সেস এবং সহযোগিতার উপায় পরিবর্তন করতে উন্নত এআই চ্যাটবট।',
    expired: 'মেয়াদ উত্তীর্ণ',
    active: 'সক্রিয়',
    Inactive: 'নিষ্ক্রিয়',
    yearly_subscription: 'বার্ষিক সাবস্ক্রিপশন',

    monthly_subscription: 'মাসিক সাবস্ক্রিপশন',
    no_sharebot_org: 'আপনার কোনো শেয়ারবট প্রতিষ্ঠান নেই',
    sharebot_start_free_trial: 'ফ্রি ট্রায়াল শুরু করুন',
    sub_month: 'মাসিক সাবস্ক্রিপশন',
    sub_year: 'বার্ষিক সাবস্ক্রিপশন',
    question_per_month: 'ডেটা স্টোরেজ (১টিবি) এবং প্রতি মাসে ১০০০টি প্রশ্ন',
    sharebot_para:
      'অগ্রসর হলে, আপনি প্রতিষ্ঠানটি অবিলম্বে মুছে ফেলার সম্মতি দিচ্ছেন। এই ক্রিয়াটি ShareBot দ্বারা প্রদত্ত সমস্ত মূল্যবান অন্তর্দৃষ্টি হারানোর কারণ হবে, এবং এটি পূর্বাবস্থায় আনা সম্ভব নয়।',
    cancelled_date: 'বাতিলের তারিখ:',
    live_straming_para:
      'আপনি যদি আপনার মাসিক লাইভ-স্ট্রিমিং সীমা পরিবর্তন করতে চান তাহলে অনুগ্রহ করে যোগাযোগ করুন',
    sharelook_agree: 'আমি Sharelook এর',
    terms_condition: 'শর্তাবলী ও নীতিমালা',
    and: 'এবং',
    privacy_policy: 'গোপনীয়তা নীতি',
    save_for_later: 'পরে সংরক্ষণ করুন',
    ai: 'কৃত্রিম বুদ্ধিমত্তা',
    no_video_yet: 'এখনও কোনো ভিডিও নির্বাচিত হয়নি!',
    are_you_sure_delete_video: 'আপনি কি নিশ্চিত এই ভিডিওটি মুছে ফেলতে চান?',
    video_des: 'বর্ণনা',
    video_now: 'এখন',
    video_playing: 'চলছে:',
    video_no: 'ভিডিও নং',
    ai_generated_course: 'এআই দ্বারা তৈরি কোর্স',
    create_course_on_our_own: 'নিজে একটি কোর্স তৈরি করুন',
    ai_Assisted_ourse_reation: 'এআই-সহায়তায় কোর্স তৈরি',
    pending: 'বিচারাধীন',
    published: 'প্রকাশিত',
    intro_course: 'আপনার কোর্সে যুক্ত করবেন?',
    clone_course: 'আপনি কি ক্লোন করতে চান',
    browser_audio_not_support: 'আপনার ব্রাউজার অডিও ট্যাগ সমর্থন করে না।',
    audio_popup_content:
      'আপনি এখানে অনেক ধরনের ভয়েস স্টাইল ব্যবহার করতে পারেন যা আপনি টাইপ করবেন ব্লা ব্লা ব্লা Lorem Ipsum হল প্রিন্টিং ও টাইপসেটিং শিল্পের একটি মানসম্পন্ন ডামি টেক্সট। Lorem Ipsum ১৫০০ সালের থেকে শিল্পের স্ট্যান্ডার্ড ডামি টেক্সট হিসেবে ব্যবহৃত হচ্ছে।',
    close: 'বন্ধ করুন',
    podcast_rec: 'রেকর্ডিং',
    create_podcast: 'পডকাস্ট তৈরি করুন',
    add_admin: 'অ্যাড অ্যাডমিন',
    delete_all: 'সব মুছুন',
    ai_podcast_audio: 'এআই পডকাস্ট অডিও',
    language: 'ভাষা',
    podcast_download_content:
      '*এআই থেকে অডিও ফাইল ডাউনলোড করুন সম্পাদনার জন্য আপনার নিজস্ব অডিও ফাইলে রূপান্তর করতে।',
    upload_audio: 'অডিও আপলোড করুন',
    browser_do_not_support_audio: 'আপনার ব্রাউজার অডিও এলিমেন্ট সমর্থন করে না।',
    upload_cover: 'কভার আপলোড করুন',
    upload_ai_creator: 'এআই ক্রিয়েটর',
    required_cover_image: 'কভার ছবি আবশ্যক!',
    room_required_name: 'পডকাস্ট নাম আবশ্যক!',
    add_guest_list: 'দয়া করে অতিথিদের তালিকা যোগ করুন!',
    podcast_add_participants: 'অংশগ্রহণকারী যোগ করুন',
    topic_required: 'অন্তত একটি বিষয় আবশ্যক',
    podcast_description: 'বর্ণনা',
    podcast_date: 'তারিখ',
    date: 'তারিখ',
    podcast_time: 'সময়',
    podcast_to: 'থেকে',
    podcast_all_day: 'সারা দিন',
    podcast_start_date_time:
      'শুরুর তারিখ ও সময়ের মধ্যবর্তী সময় অবশ্যই দিতে হবে!',
    podcast_id: 'আইডি',
    selected_user: 'নির্বাচিত ব্যবহারকারীদের আমন্ত্রণ জানান',
    see_more: 'আরও দেখুন',
    see_less: 'কম দেখুন',
    no_review_yet: 'এখনও কোনো রিভিউ নেই, প্রথম রিভিউ লেখক হোন।',
    request_to_speak: 'ব্যবহারকারীর কথা বলার অনুরোধ গ্রহণ করবেন?',
    kick_user: 'আপনি কি এই ব্যবহারকারীকে বের করে দিতে চান?',
    accept_request: 'অনুরোধ গ্রহণ করুন',
    kick: 'বের করুন',
    started: 'শুরু হয়েছে',
    end: 'শেষ',
    join_now: 'এখন যোগ দিন',
    podcast_end: 'পডকাস্ট শেষ হয়েছে',
    connecting: 'সংযুক্ত হচ্ছে...',
    knowledge_center_know_today: 'আপনি আজ কি জানতে চান?',
    knowledge_center_question: 'দয়া করে প্রথমে একটি প্রশ্ন লিখুন',
    knowledge_center_error: 'দুঃখিত! আমাদের কিছু ত্রুটি হয়েছে।',
    knowledge_center_tooltrip:
      'ShareLook-এ আপনার প্রতিষ্ঠানের সংগ্রহশালা থেকে শেখার সম্পদ থেকে দ্রুত উত্তর পান, যথাযথ রেফারেন্স সহ এবং রেফারেন্সকৃত পিডিএফ ডকুমেন্ট প্রিভিউ ও ডাউনলোড করার সুযোগ সহ।',
    my_organization: 'আমার প্রতিষ্ঠান',
    world_knowledge: 'বিশ্বের জ্ঞান',
    open_file: 'ফাইল খুলুন',
    reference: 'রেফারেন্স',
    are_you_cancel: 'আপনি কি নিশ্চিত আপনি বাতিল করতে চান?',
    are_you_remove_media: 'আপনি কি নিশ্চিত মিডিয়া মুছে ফেলতে চান?',
    terms_agree: 'আমি এই শর্তাবলীতে সম্মত',
    ready: 'প্রস্তুত',
    send_email: 'ইমেইল পাঠান',
    active_users: 'সক্রিয় ব্যবহারকারী',
    sign_up_user: 'নিবন্ধিত ব্যবহারকারী',
    non_sign_up_user: 'অ-নিবন্ধিত ব্যবহারকারী',
    organisation: 'প্রতিষ্ঠান',
    usage_report: 'ব্যবহারের রিপোর্ট',
    check_email: 'আপনার ইমেইল চেক করুন',
    delete_schedule: 'সময়সূচি মুছুন',
    are_you_sure_delete_schedule: 'আপনি কি নিশ্চিত এই সময়সূচি মুছে ফেলতে চান?',
    add_task: 'দয়া করে একটি কাজ লিখুন!',
    coaching_available: 'কোচিং উপলব্ধ হিসেবে চিহ্নিত করুন',
    message_booking_coaching:
      'এই সময়স্লটটি কোচিংয়ের জন্য একজন ব্যবহারকারী দ্বারা বুক করা হয়েছে।',
    task_day: 'কাজের দিন',
    created_task_day: 'আপনি এই দিনের জন্য একটি কাজ তৈরি করেছেন।',
    event_day: 'ইভেন্টের দিন',
    has_booked_coaching: 'এই দিনে একটি কোচিং বুক হয়েছে।',
    active_day: 'সক্রিয় দিন',
    selectable_time_slots:
      'ডানদিকে নির্বাচিত সময়স্লটগুলি এই দিনের জন্য সক্রিয়।',
    compare_last_month: 'গত মাসের সাথে তুলনা',
    uploading_file: 'আপনার ফাইল আপলোড হচ্ছে',
    attach_file_course: 'এই কোর্সের সাথে সংযুক্ত।',
    fetch_request: 'আপনার অনুরোধ আনছে',
    finilize_upload: 'আপলোড শেষ হচ্ছে',
    scorm_scanned: 'অপেক্ষা করুন... আপনার আপলোডকৃত SCORM জিপ স্ক্যান হচ্ছে।',
    scan_status: 'স্ক্যানের অবস্থা:',
    scan_completed: 'স্ক্যান সম্পন্ন হয়েছে। আপনার ফাইল হল',
    scan_progress: 'স্ক্যান চলছে...',
    check_scorm:
      'আপনার SCORM ফাইলের ফরম্যাট পরীক্ষা করা হচ্ছে... অনুগ্রহ করে অপেক্ষা করুন...',
    file_check_success: 'ফাইল চেক সফল হয়েছে',
    file_check_progress: 'ফাইল চেক চলছে...',
    scorm_not_upload:
      'আপনার আপলোডকৃত ফাইল SCORM 1.2 স্ট্যান্ডার্ড নয়, অনুগ্রহ করে আবার ফাইল আপলোড করুন।',
    select_question: 'উত্তরের অপশন (একটি সঠিক উত্তর নির্বাচন করুন)',
    select_answer: 'অনুগ্রহ করে উত্তর অপশন নির্বাচন করুন!',
    check_option_one: 'অনুগ্রহ করে অপশন এক লিখুন!',
    check_option_two: 'অনুগ্রহ করে অপশন দুই লিখুন!',
    check_option_three: 'অনুগ্রহ করে অপশন তিন লিখুন!',
    check_option_four: 'অনুগ্রহ করে অপশন চার লিখুন!',
    question_image: 'প্রশ্নের ছবি',
    select_question_image: 'অনুগ্রহ করে প্রশ্নের ছবি নির্বাচন করুন!',
    ans_image: 'উত্তরের ছবি',
    upload_image_question: 'উত্তরের ছবি আপলোড করুন',
    select_image_answer: 'অনুগ্রহ করে উত্তর ছবি নির্বাচন করুন!',
    save_question: 'প্রশ্ন সংরক্ষণ করুন',
    do_you_leave: 'আপনি কি নিশ্চিত আপনি বের হতে চান?',
    loose_all_progress: 'আপনি আপনার সকল অগ্রগতি হারাবেন।',
    welcome: 'স্বাগতম',
    team_knowledge_quest: 'দলের জ্ঞান অভিযান',
    your_score: 'আপনার স্কোর',
    start_playing: 'খেলা শুরু করুন',
    share_sphere_complete: 'শেয়ারস্ফিয়ার সম্পন্ন',
    final_score: 'চূড়ান্ত স্কোর',
    play_next: 'পরবর্তী খেলুন',
    you_donot_access_event: 'আপনার এই ইভেন্টে অ্যাক্সেস নেই।',
    ai_content_generated: 'এই বিষয়ের জন্য কন্টেন্ট তৈরি হয়েছে।',
    ai_popup_confirm_content: 'কন্টেন্ট তৈরির নিশ্চয়তা দিন',
    limit_transcribe_text:
      'ট্রান্সক্রাইব মিনিট বাকি: <0>{{ transcribe_limit }}</0> মিনিট <1/><2/> <3>. আপনার ট্রান্সক্রাইব সীমা পরিবর্তন করতে, অনুগ্রহ করে যোগাযোগ করুন </3> <4>admin@sharelook.com</4>।',
    you_donot_access_event: 'আপনার এই ইভেন্টে অ্যাক্সেস নেই।',
    ai_course_title_training: 'নেতৃত্ব প্রশিক্ষণ কোর্স',
    ai_course_object: 'ডিজিটাল নেতৃত্ব নেভিগেশন',
    create_ai_video: 'এআই ভিডিও তৈরি করুন',
    generate: 'তৈরি করুন',
    video_generate_process:
      'ভিডিও তৈরি প্রক্রিয়াটি কিছু সময় নিতে পারে। সম্পন্ন হলে আপনি একটি ইমেইল পাবেন।',
    stripe_account_connect:
      'আপনার Stripe অ্যাকাউন্ট নিষ্ক্রিয়। চালিয়ে যেতে দয়া করে এটি সংযোগ করুন বা সক্রিয় করুন।',
    ai_creator: 'এআই নির্মাতা',
    check_video_status: 'ভিডিও তৈরি অবস্থান পরীক্ষা করা হচ্ছে...',
    video_on_queue: 'ভিডিও তৈরি করার জন্য লাইন রয়েছে।',
    video_fail_generation:
      'দুঃখিত, ভিডিও তৈরি ব্যর্থ হয়েছে। দয়া করে আরেকটি চেষ্টা করুন।',
    video_currently_generated: 'এই ভিডিওটি বর্তমানে তৈরি হচ্ছে।',
    checking_status: 'অবস্থা পরীক্ষা করা হচ্ছে',
    check_status: 'অবস্থা পরীক্ষা করুন',
    browser_does_not_support_audio: 'আপনার ব্রাউজার অডিও ট্যাগ সমর্থন করে না',
    existing_edit_scenario:
      'আপনি কি বিদ্যমান দৃশ্যটি সম্পাদনা করতে চান বা নতুন দৃশ্য তৈরি করতে চান? নতুন তৈরি করলে পুরানো দৃশ্য হারিয়ে যাবে।',
    generate_scenario: 'দৃশ্য তৈরি করুন',
    layout: 'লেআউট',
    confirm_change: 'পরিবর্তন নিশ্চিত করুন',
    generated_ai_creation_message:
      'দয়া করে লক্ষ্য করুন যে শুধুমাত্র AI তৈরি করা টেক্সট উপাদানগুলি সংরক্ষিত থাকবে। অন্য সমস্ত উপাদান পৃষ্ঠাটি থেকে মুছে ফেলা হবে।',
    generate_story: 'গল্প তৈরি করুন',
    save_original_content: 'মূল বিষয়বস্তু সংরক্ষণ করুন:',
    story_added_specified_position:
      'পাঠের গল্পের অবস্থান। গল্পটি নির্দিষ্ট অবস্থানে একটি ব্লক হিসাবে যোগ করা হবে।',
    position_of_story: 'গল্পের অবস্থান',
    start_the_lesson: 'পাঠের শুরু',
    end_the_lesson: 'পাঠের শেষ',
    add_story_pages: 'গল্প পৃষ্ঠাগুলিতে যোগ করুন',
    browser_does_not_support: 'আপনার ব্রাউজার অডিও উপাদান সমর্থন করে না।',
    no_video_available: 'কোন ভিডিও উপলব্ধ নেই।',
    no_podcast_available: 'কোন পডকাস্ট উপলব্ধ নেই।',
    no_item_baskets: 'বাশাতে কোন আইটেম নেই।',
    ai_course_object: 'ডিজিটাল নেতৃত্ব নেভিগেশন'
  },
  v2: {
    n_data: 'কোনো ডেটা নেই',
    change: 'পরিবর্তন করুন',
    remove: 'সরান',
    auto_background: 'স্বয়ংক্রিয় পটভূমি',
    create_new_course_org: 'আপনার সংস্থার জন্য একটি নতুন কোর্স তৈরি করুন।',
    create_new_course_marketplace:
      'মার্কেটপ্লেসের জন্য একটি নতুন কোর্স তৈরি করুন।',
    create_new_course_both:
      'সংস্থা ও মার্কেটপ্লেস উভয়ের জন্য একটি নতুন কোর্স তৈরি করুন।',
    ok: 'ঠিক আছে',
    page_bg: 'পৃষ্ঠার পটভূমি',
    lesson_cover: 'পাঠ্যের কভার ছবি',
    create_skill_journey: 'স্কিল জার্নি তৈরি করুন',
    Metamaze: 'মেটামেজ',
    events: 'ইভেন্ট',
    scroms: 'SCORMs',
    min_score_pass: 'পাস করার জন্য ন্যূনতম স্কোর',
    no_scorms_available: 'কোনো SCORM উপলব্ধ নেই।',
    no_events_available: 'কোনো ইভেন্ট উপলব্ধ নেই।',
    no_courses_available: 'কোনো কোর্স উপলব্ধ নেই।',
    no_courses_baskets: 'ঝুঁড়িতে কোনো কোর্স নেই।',
    no_mazes_baskets: 'ঝুঁড়িতে কোনো মেজ নেই।',
    no_scroms_baskets: 'ঝুঁড়িতে কোনো SCORM নেই।',
    no_events_baskets: 'ঝুঁড়িতে কোনো ইভেন্ট নেই।',
    sorry: 'দুঃখিত!',
    option_1: 'বিকল্প ১',
    option_2: 'বিকল্প ২',
    enter_number_words: 'সর্বোচ্চ শব্দসংখ্যা লিখুন।',
    summarize: 'সারসংক্ষেপ করুন',
    answer: 'উত্তর',
    hold_tight_one_minute:
      'অপেক্ষা করুন! আমরা এখনও প্রস্তুতি নিচ্ছি। এটি এক মিনিট পর্যন্ত সময় নিতে পারে।',
    enter_question: 'আপনার প্রশ্ন লিখুন।',
    enter_relevant_documents: 'প্রাসঙ্গিক ডকুমেন্ট সংখ্যাটি লিখুন।',
    please_input_relevant_documents:
      'অনুগ্রহ করে প্রাসঙ্গিক ডকুমেন্ট সংখ্যা লিখুন!',
    please_wait_loading_results: 'ফলাফল লোড হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন...',
    proceed_to_add_voice: 'ভয়েস যোগ করার জন্য এগিয়ে যান',
    results: 'ফলাফল',
    no_result_found_try_asking_questions:
      'কোনো ফলাফল পাওয়া যায়নি। আরও প্রশ্ন করুন।',
    eg: 'যেমনঃ',
    what_make_sales_manager: 'কীভাবে আমি একজন বিক্রয় ব্যবস্থাপক হতে পারি?',
    please_select_lang: 'অনুগ্রহ করে একটি ভাষা নির্বাচন করুন!',
    search: 'অনুসন্ধান',
    please_copy_desired_content:
      'বাম দিকের বাক্স থেকে ডানদিকে আপনার পছন্দসই বিষয়বস্তু কপি করুন।',
    rating_req: 'রেটিং একটি প্রয়োজনীয় ক্ষেত্র।',
    review_req: 'রিভিউ একটি প্রয়োজনীয় ক্ষেত্র।',
    rating_review_req: 'রেটিং ও রিভিউ দুটোই দিতে হবে।',
    how_rate_this: 'আপনি এটি কীভাবে রেট করবেন?',
    amazing_above_expectations: 'দারুন! প্রত্যাশার ঊর্ধ্বে!',
    certificates: 'সার্টিফিকেট',
    you_no_certificates: 'এই মুহূর্তে আপনার কোনো সার্টিফিকেট নেই।',
    please_add_review: 'রেটিং এর সাথে একটি রিভিউ দিন, ধন্যবাদ!',
    post: 'পোস্ট করুন',
    rate: 'রেট দিন',
    avg_rating: 'গড় রেটিং',
    no_review_found: 'কোনো রিভিউ পাওয়া যায়নি',
    are_sure_to_disale_zoom_integration:
      'আপনি কি নিশ্চিত যে আপনি Zoom ইন্টিগ্রেশন বন্ধ করতে চান?',
    badges: 'ব্যাজ',
    you_no_badge_available: 'এই মুহূর্তে আপনার কোনো ব্যাজ নেই।',
    download_certificate: 'সার্টিফিকেট ডাউনলোড করুন',
    loading: 'লোড হচ্ছে...',
    no_file_attached: 'কোনো ফাইল সংযুক্ত করা হয়নি',
    you_do_not_have_any_notes: 'আপনার কোনো নোট নেই।',
    question: 'প্রশ্ন',
    score: 'স্কোর',
    alert_score_message: 'ব্যক্তি/ব্যক্তিবর্গ তাদের স্কোর জমা দিয়েছেন।',
    alert_question_message: 'এখনও পর্যন্ত কোনো প্রশ্ন যোগ করা হয়নি।',
    button_submit: 'জমা দিন',
    button_allScores: 'সব স্কোর জমা দেওয়া হয়েছে।',
    record_wait: 'রেকর্ডিং শুরু হচ্ছে। অনুগ্রহ করে অপেক্ষা করুন...',
    buttonSubmit_warning: 'জমা দেওয়ার আগে সমস্ত স্কোর ইনপুট করুন।',
    upload_ar_assets: 'AR অ্যাসেট আপলোড করুন',
    edit_ar_assets: 'AR অ্যাসেট সম্পাদনা করুন',
    edit_maze_assets: 'মেটামেজ অ্যাসেট সম্পাদনা করুন',
    upload_assets: 'অ্যাসেট আপলোড করুন',
    upload_maze_assets: 'মেটামেজ অ্যাসেট আপলোড করুন',
    trigger_title: 'ট্রিগার শিরোনাম',
    model_title: 'মডেল শিরোনাম',
    trigger_description: 'ট্রিগার বর্ণনা',
    model_description: 'মডেল বর্ণনা',
    please_type_target_description: 'লক্ষ্য বর্ণনা টাইপ করুন।',
    please_type_model_description: 'মডেল বর্ণনা টাইপ করুন।',
    trigger_image: 'ট্রিগার ইমেজ*',
    model_image: 'মডেল ইমেজ*',
    upload_trigger_image: 'ট্রিগার ইমেজ আপলোড করুন',
    upload_model_image: 'মডেল ইমেজ আপলোড করুন',
    drag_n_drop: 'টেনে এনে রাখুন',
    file_size_should_not_exceed:
      '(ইমেজ ফাইল (JPEG) সাইজ ৫১২ KB-এর বেশি হওয়া উচিত নয়)',
    zip_size_should_not_exceed: '(জিপ ফাইল সাইজ ৬০ MB-এর বেশি হওয়া উচিত নয়)',
    ar_content: 'AR কন্টেন্ট*',
    model_content: '3D মডেল*',
    upload_3d_zip: 'ZIP / ভিডিও আপলোড করুন',
    upload_3d_maze_zip: 'ZIP আপলোড করুন',
    audio_content: 'অডিও কন্টেন্ট',
    _mp3: '(.mp3)',
    content_attached: 'জিপ সংযুক্ত হয়েছে।',
    video_attached: 'ভিডিও সংযুক্ত হয়েছে।',
    audio_attached: 'অডিও সংযুক্ত হয়েছে।',
    enter_trigger_image_title: 'ট্রিগার ইমেজ শিরোনাম লিখুন।',
    enter_model_title: 'মেটামেজ মডেল শিরোনাম লিখুন।',
    ar_preview_image: 'AR প্রিভিউ ইমেজ',
    upload_preview_image: 'প্রিভিউ ইমেজ আপলোড করুন',
    upload_audio: 'অডিও আপলোড করুন',
    creating___: 'তৈরি করা হচ্ছে...',
    updating___: 'আপডেট করা হচ্ছে...',
    create: 'তৈরি করুন',
    update: 'আপডেট করুন',
    ar_assets: '3D ইমেজ',
    _3d_files_mp4: '(জিপড .obj, .fbx বা .mp4 ভিডিও)',
    _3d_files_mp4_ar: '(জিপড .obj, .fbx)',
    maze_3d_files_mp4: '(জিপড .obj, .fbx)',
    _jpg_files: 'শুধুমাত্র .jpg সাপোর্ট করে',
    persons_have_submitted_their_scores:
      'ব্যক্তি(রা) তাদের স্কোর জমা দিয়েছেন।',
    no_questions_added_till_now: 'এখন পর্যন্ত কোনো প্রশ্ন যোগ করা হয়নি।',
    submit: 'জমা দিন',
    all_scores_submitted: 'সমস্ত স্কোর জমা দেওয়া হয়েছে।',
    recording_is_starting: 'রেকর্ডিং শুরু হচ্ছে। অনুগ্রহ করে অপেক্ষা করুন...',
    please_input_scores_before_submitting:
      'জমা দেওয়ার আগে দয়া করে সমস্ত স্কোর ইনপুট করুন।',
    end_for_all: 'সবার জন্য শেষ করুন',
    full_screen: 'ফুল স্ক্রিন',
    breakout_room: 'ব্রেকআউট রুম',
    send_invitations: 'আমন্ত্রণ(সমূহ) পাঠান',
    add_participants: 'অংশগ্রহণকারী(দের) যোগ করুন',
    create_breakout_room: 'ব্রেকআউট রুম তৈরি করুন',
    connecting: 'সংযোগ করা হচ্ছে...',
    currently_broadcaster_unavailable: 'বর্তমানে ব্রডকাস্টার অনুপলব্ধ।',
    how_many_breakout_room_to_create: 'আপনি কতগুলি ব্রেকআউট রুম তৈরি করতে চান?',
    create_upto_three_breakout_rooms: '*সর্বোচ্চ ৩টি ব্রেকআউট রুম তৈরি করুন',
    allow: 'অনুমতি দিন',
    additional: 'অতিরিক্ত',
    attachment: 'সংযুক্তিসমূহ',
    no_description_available: 'কোনো বর্ণনা পাওয়া যায়নি।',
    people: 'ব্যক্তিবর্গ',
    waiting: 'অপেক্ষা করছে',
    hand_raising_users: 'হাত তোলা ব্যবহারকারীরা',
    invite: 'আমন্ত্রণ দিন',
    create_room: 'রুম তৈরি করুন',
    create_live_event: 'লাইভ ইভেন্ট তৈরি করুন',
    support_upto_fivethousand_participants:
      'ইভেন্টের জন্য সর্বোচ্চ ৫,০০০ অংশগ্রহণকারী সাপোর্ট করে',
    support_upto_ten_participants:
      'সর্বোচ্চ ১০ জন লাইভ ভিডিও অংশগ্রহণকারী সাপোর্ট করে',
    support_upto_twohundred_participants:
      'ইভেন্টের জন্য সর্বোচ্চ ২০০ অংশগ্রহণকারী সাপোর্ট করে',
    supprt_upto_five_participants:
      'সর্বোচ্চ ৫ জন লাইভ ভিডিও অংশগ্রহণকারী সাপোর্ট করে',
    support_upto_twentyfive_participants:
      'ইভেন্টের জন্য সর্বোচ্চ ২৫ জন লাইভ ভিডিও অংশগ্রহণকারী সাপোর্ট করে',
    two_live_video_participants:
      'ইভেন্টের জন্য ২ জন লাইভ ভিডিও অংশগ্রহণকারী রয়েছে (হোস্ট এবং অংশগ্রহণকারী)',
    you_can_have_upto_five_examinees:
      'আপনার সর্বোচ্চ ৫ জন পরীক্ষার্থী থাকতে পারে।',
    you_can_have_upto_twentyfive_participants:
      'আপনার সর্বোচ্চ ২৫ জন অংশগ্রহণকারী থাকতে পারে।',
    you_can_have_upto_five_participants:
      'আপনার সর্বোচ্চ ৫ জন অংশগ্রহণকারী থাকতে পারে।',
    you_can_have_upto_ten_participants:
      'আপনার সর্বোচ্চ ১০ জন অংশগ্রহণকারী থাকতে পারে।',
    select_hosts_email: 'হোস্টের ইমেইল নির্বাচন করুন',
    send_invite_email: 'আমন্ত্রণ ইমেইল পাঠান',
    do_not_send_invite_email: 'আমন্ত্রণ ইমেইল পাঠাবেন না',
    error: 'ত্রুটি',
    max_twentyfive_users_allowed:
      'সর্বোচ্চ ২৫ জন ব্যবহারকারী নির্বাচন করা যাবে',
    max_five_users_allowed: 'সর্বোচ্চ ৫ জন ব্যবহারকারী নির্বাচন করা যাবে',
    max_ten_users_allowed: 'সর্বোচ্চ ১০ জন ব্যবহারকারী নির্বাচন করা যাবে',
    no_user_found: 'কোনো ব্যবহারকারী পাওয়া যায়নি',
    transcribe_to: 'ট্রান্সক্রাইব টু',
    integrate_zoom_to_start_meeting:
      'জুম মিটিং শুরু করতে আপনার অ্যাকাউন্টে জুম ইন্টিগ্রেট করুন।',
    zoom_is_not_integrated: 'জুম ইন্টিগ্রেট করা নেই।',
    delete_poll: 'পোল ডিলিট করুন',
    add_poll: 'পোল যোগ করুন',
    live_now: 'লাইভ এখন!',
    average_rating: 'গড় রেটিং',
    review: 'রিভিউ',
    time_spent: 'ব্যয়িত সময়',
    total: 'মোট',
    mins: 'মিনিট',
    no_data: 'এই কুইজের জন্য কোনো ডেটা নেই।',
    total_score: 'মোট স্কোর',
    pass_score: 'পাস স্কোর',
    point: 'পয়েন্ট',
    wrong: 'ভুল',
    response: 'প্রতিক্রিয়া',
    submitted: 'জমা দেওয়া হয়েছে',
    average: 'গড়',
    total_play: 'মোট প্লে',
    view_graph: 'গ্রাফ দেখুন',
    time_spent_mins: 'ব্যয়িত সময় (মিনিট)',
    play: 'প্লে',
    ideal_path: 'আদর্শ পাথ',
    user_incorrect_path: 'ব্যবহারকারীর ভুল পাথ',
    ideal_path_taken: 'ব্যবহারকারীর দ্বারা নেওয়া আদর্শ পাথ',
    scenario: 'সিনারিও',
    option: 'অপশন',
    spend: 'ব্যয়',
    average_spending_time: 'গড় ব্যয়িত সময়',
    activity_overview: 'অ্যাক্টিভিটি ওভারভিউ',
    live_event: 'লাইভ ইভেন্ট',
    live_assessment: 'লাইভ অ্যাসেসমেন্ট',
    report_download: 'রিপোর্ট ডাউনলোড',
    all_workshops: 'সমস্ত ওয়ার্কশপ',
    overview_average_activity: 'ওভারভিউ গড় অ্যাক্টিভিটি',
    overview_workshop_graph: 'ওভারভিউ ওয়ার্কশপ গ্রাফ',
    mazes: 'মেজেস',
    correct_feedback: 'সঠিক ফিডব্যাক',
    incorrect_feedback: 'ভুল ফিডব্যাক',
    checkin_checkout: 'চেক-ইন - চেকআউট',
    minutes: 'মিনিট',
    incorrect_path: 'ভুল পাথ',
    answer_not_available: 'উত্তর পাওয়া যায়নি',
    views: 'ভিউ',
    item: 'আইটেম',
    questions: 'প্রশ্নসমূহ',
    total_points: 'মোট পয়েন্ট',
    total_attempts: 'মোট প্রচেষ্টা',
    created_date: 'তৈরির তারিখ',
    host_name: 'হোস্টের নাম',
    host_section: 'হোস্ট সেকশন',
    choose_products: 'পণ্য নির্বাচন করুন',
    add_to_basket: 'বাস্কেটে যোগ করুন',
    basket: 'বাস্কেট',
    times: 'বার',
    scorms: 'SCORMসমূহ',
    skill_journey_overview: 'স্কিল জার্নি ওভারভিউ',
    how_to_use: 'কীভাবে ব্যবহার করবেন',
    live_broadcast_description:
      'আমরা একটি সহজ-ব্যবহারযোগ্য কোর্স বিল্ডারে লাইভ ভিডিও ইন্টিগ্রেট করেছি',
    live_broadcast_subdescription:
      'ShareLook-এর পেটেন্টকৃত লাইভ ব্রডকাস্ট সিস্টেমের সাহায্যে, আপনি এনগেজমেন্ট তৈরি করতে, লার্নিং অটোমেট করতে এবং নলেজ শেয়ারিং সর্বাধিক করতে পারেন।',
    disclaimer: `আমি নিশ্চয়তা দিচ্ছি যে আমার স্কিল জার্নি:
      - কোনো তৃতীয় পক্ষের অধিকার লঙ্ঘন করবে না
      - কোনো অবৈধতা থাকবে না, মানহানিকর, অশ্লীল, অশালীন, কামোত্তেজক, পর্নোগ্রাফিক, হিংসাত্মক, অপমানজনক, আপত্তিকর, হুমকিপূর্ণ বা বৈষম্যমূলক কন্টেন্ট থাকবে না (এমনকি অ্যাস্টেরিস্ক দিয়ে ছদ্মবেশেও নয়)
      - অন্য ব্যক্তিদের ব্যক্তিগত আক্রমণ থাকবে না
      - অন্য পার্টিসিপ্যান্ট, পাবলিক ফিগার বা সেলিব্রিটিদের অনুকরণ থাকবে না
      - কোনো ব্যক্তির সম্মতি ছাড়া তার রেকর্ডিং বা ব্যক্তিগত তথ্য থাকবে না এবং বিশ্বের কোনো অংশে কোনো ডেটা প্রোটেকশন রেগুলেশন লঙ্ঘন করবে না
      - কোনো কমার্শিয়াল সলিসিটেশন বা কোনো ধরনের "স্প্যাম" থাকবে না`,
    price: 'দাম',
    video_link: 'ভিডিও লিংক',
    category: 'ক্যাটাগরি',
    objectives: 'উদ্দেশ্যসমূহ',
    marketplace_description: 'মার্কেটপ্লেস বর্ণনা',
    live_discussion: 'লাইভ আলোচনা',
    poll: 'পোল',
    hide_grid: 'গ্রিড লুকান',
    show_grid: 'গ্রিড দেখান',
    stop_screen_share: 'স্ক্রিন শেয়ার বন্ধ করুন',
    screen_share: 'স্ক্রিন শেয়ার',
    mute: 'মিউট',
    unmute: 'আনমিউট',
    raise_hand: 'হাত তোলেন',
    waiting__: 'অপেক্ষা করছে...',
    audio_active: 'অডিও অ্যাকটিভ'
  },
  general: {
    save: 'সংরক্ষণ',
    autosaved: 'স্বতঃ সংরক্ষিত',
    back_to: 'আবার',
    by: 'দ্বারা',
    chat: 'চ্যাট',
    completed: 'সমাপ্ত',
    canceled: 'বাতিল করা হয়েছে',
    component: 'উপাদান',
    confirm: 'নিশ্চিত করুন',
    course: 'পাঠ ',
    skill: 'দক্ষতার যাত্রা',
    maze: 'মেটা গোলকধাঁধা',
    channel: 'চ্যানেল',
    podcast: 'পডকাস্ট',
    date: ' তারিখ ',
    details: 'বিশদ ',
    empty: 'তথ্য নেই',
    enrolled: 'তালিকাভুক্ত',
    free: ' বিনামূল্যে ',
    graph: ' লেখচিত্র ',
    loading: ' লোড হচ্ছে...',
    lesson: ' পাঠ ',
    lessons: ' পাঠগুলি',
    live_assessment: 'সরাসরি মূল্যায়ন',
    live_event: 'লাইভ অনুষ্ঠান',
    no: 'না',
    of: 'এর',
    or: 'বা',
    organization: ' প্রতিষ্ঠান',
    page: ' পৃষ্ঠা ',
    pages: ' পৃষ্ঠাগুলি',
    personal: ' ব্যক্তিগত ',
    poll: ' ভোটগ্রহণ ',
    rating: ' নির্ধারণ ',
    reset: ' পুনরায় বসান ',
    signin: 'সাইন ইন করুন',
    signup: 'নিবন্ধন করুন',
    soon: 'শীঘ্রই',
    type: 'টাইপ করা',
    uploading: ' আপলোড হচ্ছে...',
    yes: ' হ্যাঁ ',
    something_went_wrong: 'কিছু ভুল হয়েছে!',
    view_all: 'সব দেখ',
    upload_successful: 'আপলোড সফল হয়েছে',
    upload_successful_message:
      'আপনার এক্সেল নথি সফলভাবে আপলোড হয়েছে এবং বর্তমানে প্রক্রিয়াজাত হচ্ছে। এটি কিছু সময় নিতে পারে।',
    check_email_upload_successful:
      'দয়া করে <0> আপনার ইমেলটি পরীক্ষা করুন আপলোড করা ব্যবহারকারী তালিকার <1> প্রতিবেদন </ 1> </0> এর জন্য ',
    is_private: ' ব্যক্তিগত'
  },

  account: {
    title: ' হিসাব',
    subtitle: 'আপনার সেটিংস এবং অ্যাকাউন্টের তথ্য পরিচালনা করুন।',
    saved: 'অ্যাকাউন্ট সফলভাবে পরিবর্তিত হয়েছে'
  },

  assessments: {
    title: ' মূল্যায়ন ',
    subtitle: 'একটি মূল্যায়ন তৈরি করুন',
    finished: 'মূল্যায়ন শেষ',
    countdown: 'সরাসরি মূল্যায়ন সম্প্রচারিত হবে ',
    create: 'মূল্যায়ন তৈরি করুন',
    list_title: 'আপনার মূল্যায়ন',
    delete_warning: 'আপনি এই আইটেমটি মুছে ফেলতে চান আপনি কি নিশ্চিত?',
    details_title: 'মূল্যায়নের বিশদ যুক্ত করুন',
    details_subtitle:
      'আপনার মূল্যায়নের নাম দিন এবং আপনার দর্শকদের বলুন তাদের এটি থেকে কী শিখার আশা করা উচিত ',
    disclaimer: `আমি আশ্বাস দিয়েছি যে আমার রেকর্ড করা মূল্যায়ন টি হবে না:
    - যে কোন তৃতীয় পক্ষের অধিকার লঙ্ঘন
    - মানহানি সহ, অশ্লীল, অশোভন, দুশ্চরিত্র, অশ্লীল রচনা চিত্র, উগ্র, গালিগালাজপূর্ণ, অপমানকর, হুমকি দেওয়া বা বৈষম্যমূলক বিষয়বস্তু সহ এমন কোনও অবৈধতা রয়েছে, এমনকি তারকাচিহ্ন দ্বারা ছদ্মবেশযুক্ত
    - অন্যান্য ব্যক্তির উপর কোনও ব্যক্তিগত আক্রমণ রয়েছে
    - অন্যান্য অংশগ্রহণকারী, জনসাধারণের ব্যক্তিত্ব বা সেলিব্রিটিদের কোনও ছদ্মবেশ ধারণ করে
    - এই জাতীয় ব্যক্তির সম্মতি ব্যতীত যে কোনও ব্যক্তির কোনও রেকর্ডিং বা ব্যক্তিগত তথ্য থাকতে পারে এবং বিশ্বের কোন অংশে কোনও তথ্য সুরক্ষা নিয়ন্ত্রণের লঙ্ঘন করছে না
    - যে কোনও বাণিজ্যিক আবেদন বা কোন রকম "স্প্যাম" ধারণ করে”`,
    assessment_details: 'মূল্যায়নের বিশদ',
    assessment_settings: 'মূল্যায়ন সেটিংস'
  },

  buildersettings: {
    title: 'সেটিংস প্রকাশিত',
    subtitle:
      'আপনার ইভেন্টে সেটিংস যুক্ত করুন, যারা আপনার ইভেন্টটি দেখতে ও তার সাথে ইন্টারঅ্যাক্ট করতে পারে'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: ' যুক্ত করা ',
    add_page: 'পৃষ্ঠা যোগ করো',
    add_lesson: 'পাঠ যোগ করুন',
    add_answer: 'নতুন উত্তর যুক্ত করুন',
    add_group: 'দল যুক্ত করুন',
    add_organization: 'সংস্থা যুক্ত করুন',
    add_question: 'প্রশ্ন যুক্ত করুন',
    add_quiz: 'কুইজ যুক্ত করুন',
    add_users: 'ব্যবহারকারী যুক্ত করুন',
    back: 'পেছনে',
    back_to_course: 'কোর্সের ওভারভিউ-এ ফিরে যান',
    back_to_lesson: 'পাঠ্য ওভারভিউ-এ ফিরে যান',
    back_to_media: 'মিডিয়া পাঠাগারে ফিরে যান',
    back_to_details: 'বিশদে ফিরে যান',
    cancel: ' বাতিল ',
    clear: ' স্পষ্ট ',
    close: 'বন্ধ',
    clone: 'ক্লোন',
    close_lesson: 'পাঠ বন্ধ করুন',
    clone_course: 'ক্লোন কোর্স',
    confirm: ' নিশ্চিত করুন ',
    create: 'সৃষ্টি',
    download: 'ডাউনলোড',
    download_mass_user_tamplate: 'টেম্পলেট ডাউনলোড করুন',
    add_mass_users: 'গণ ব্যবহারকারীদের যোগ করুন',
    upload_excel_list: 'এক্সেল তালিকা আপলোড করুন',
    delete: 'মিডিয়া মুছুন',
    edit: ' সম্পাদনা করুন ',
    edit_course: 'সম্পাদনা কোর্স',
    enroll: ' তালিকাভুক্তি ',
    finish: ' সমাপ্ত ',
    upload_image: 'ছবি আপলাড',
    upload_image_video: 'ছবি বা ভিডিও আপলোড করুন',
    select_media_library: 'মিডিয়া লাইব্রেরি নির্বাচন করুন',
    make_public: 'জনসাধারণের জন্য উন্মুক্ত করো',
    make_private: 'ব্যক্তিগত করো',
    make_org: 'সংস্থা তৈরি করুন',
    media: 'মিডিয়া গ্রন্থাগার',
    my_theme: 'আমার থিম',
    next: ' পরবর্তী ',
    next_lesson: 'পরবর্তী পাঠ',
    next_step: 'পরবর্তী ধাপ ',
    previous_step: 'পূর্ববর্তী ধাপ',
    publish: 'প্রকাশ',
    publish_assessment: 'আপনার মূল্যায়ন প্রকাশ করুন',
    publish_course: 'আপনার কোর্স প্রকাশ করুন',
    publish_event: 'আপনার অনুষ্ঠান প্রকাশ করুন',
    reset: 'পুনরায় বসান',
    reset_elements: 'উপাদানগুলি পুনরায় সেট করুন',
    save: 'সংরক্ষণ',
    creating: ' তৈরি হচ্ছে...',
    updating: ' আপডেট হচ্ছে...',
    saved: ' সংরক্ষিত ',
    save_for_later: 'পরে জন্য সংরক্ষণ করুন',
    save_settings: 'সেটিংস সংরক্ষণ করুন',
    select_files: 'ফাইলগুলি নির্বাচন করুন',
    select_theme: 'থিম নির্বাচন করুন',
    start_lesson: 'পাঠ শুরু করুন',
    update: ' আপডেট',
    upload: ' আপলোড করুন ',
    upload_audio: 'অডিও আপলোড করুন ',
    upload_photo: 'একটি প্রোফাইল ছবি আপলোড করুন',
    upload_video: 'ভিডিও আপলোড করুন',
    enrolled: 'তালিকাভুক্ত',
    unenroll: 'তালিকাভুক্তি-নয়',
    from_library: 'সংবাদমাধ্যম গ্রন্থাগার',
    remove: 'অপসারণ',
    removed: 'স্থানান্তরিত',
    start_broadcast: 'সম্প্রচার শুরু করুন',
    end_broadcast: `সম্প্রচার সমাপ্ত`,
    camera: 'ক্যামেরা',
    screen: 'পর্দা',
    screen_with_camera: 'ক্যামেরা সহ পর্দা',
    insert: 'ভিতরে স্থাপন করা',
    inserting: 'সন্নিবেশিত করা'
  },

  card: {
    quick_add: 'দ্রুত যুক্ত করা',
    add: ' যুক্ত করা',
    clone: 'ক্লোন',
    completed: 'পাঠ সম্পন্ন'
  },

  course: {
    upcoming_course: 'আসন্ন কোর্স',
    unPublishEvent: 'অপ্রকাশিত ইভেন্ট',
    unPublishAssessment: 'অপ্রকাশিত মূল্যায়ন',
    pastCourse: 'প্রশিক্ষণ কোর্স',
    upcoming: 'আসন্ন সরাসরি ইভেন্ট',
    pastEvent: 'অতীতের সরাসরি ইভেন্ট',
    pastAssessment: 'অতীতের সরাসরি মূল্যায়ন',
    upcomingAssessment: 'আসন্ন সরাসরি মূল্যায়ন',
    created: 'তারিখ নির্ধারণ করা হয়েছে:',
    assignees: 'অধিকারপ্রাপ্ত প্রতিনিধি',
    organisations:
      ' {{ সংগঠনগুলি }} সংগঠনগুলি, <2> {{ users }} ব্যবহারকারী</2>',
    event_date: 'সরাসরি ইভেন্টের তারিখ <1> {{ তারিখ }} </1>',
    delete_warning: 'আপনি কি নিশ্চিত যে আপনি এটি মুছতে চান',
    clonning_no_lesson:
      'এই কোর্সটি ক্লোন করতে দয়া করে কমপক্ষে একটি পাঠ যোগ করুন.',
    clone_warning: 'আপনি কি নিশ্চিত যে আপনি এটি ক্লোন করতে চান',
    clone_success: 'ক্লোনিং প্রক্রিয়া চলছে',
    disclaimer: ` আমি নিশ্চিত করি যে আমার কোর্সটি না:
      - যে কোন তৃতীয় পক্ষের অধিকার লঙ্ঘন
      - মানহানি সহ, অশ্লীল, অশোভন, দুশ্চরিত্র, অশ্লীল রচনা চিত্র, উগ্র, গালিগালাজপূর্ণ, অপমানকর, হুমকি দেওয়া বা বৈষম্যমূলক বিষয়বস্তু সহ এমন কোনও অবৈধতা রয়েছে, এমনকি তারকাচিহ্ন দ্বারা ছদ্মবেশযুক্ত
      - অন্যান্য ব্যক্তির উপর কোনও ব্যক্তিগত আক্রমণ রয়েছে
      - অন্যান্য অংশগ্রহণকারী, জনসাধারণের ব্যক্তিত্ব বা সেলিব্রিটিদের কোনও ছদ্মবেশ ধারণ করে
      - এই জাতীয় ব্যক্তির সম্মতি ব্যতীত যে কোনও ব্যক্তির কোনও রেকর্ডিং বা ব্যক্তিগত তথ্য থাকতে পারে এবং বিশ্বের কোন অংশে কোনও তথ্য সুরক্ষা নিয়ন্ত্রণের লঙ্ঘন করছে না
      - যে কোনও বাণিজ্যিক আবেদন বা কোন রকম "স্প্যাম" ধারণ করে”`
  },

  coursecreate: {
    dropzone_text: 'মিডিয়া প্রবেশ করান',
    sidebar_text: 'একটি থিম নির্বাচন করুন  <1/> আপনার <3/> পাঠের জন্য ',
    delete_warning: 'আপনি কি নিশ্চিত যে আপনি এই পাঠটি মুছতে চান?'
  },

  coursepage: {
    quizview_loading:
      'উত্তরগুলি পরীক্ষা করা হচ্ছে। অনুগ্রহপূর্বক অপেক্ষা করুন...',
    quizview_answer: 'তোমার উত্তর'
  },

  coursequiz: {
    title: 'সমস্ত পাঠের কুইজ '
  },

  dashboard: {
    tooltip_title: 'এই ভিডিওটি আবার দেখাবেন না',
    page_title: `'আপনার কোর্সসমূহ' পরিসংখ্যানসংক্রান্ত `,
    page_subtitle: 'আপনি তৈরি কোর্সের অবস্থা',
    profile_add_info: `আপনার প্রোফাইল সম্পূর্ণ করতে আপনার <1> {{অসম্পূর্ণ টেক্সট}} </1> যুক্ত করুন'`,
    profile_build: `আপনার প্রোফাইল তৈরি করুন <1> এখানে </ 1>, আপনার আগ্রহ এবং দক্ষতা আমাদের জানান'`,
    profile_title: 'প্রোফাইল ক্ষমতা',
    more_details: 'আরো বিস্তারিত'
  },

  errors: {
    answer: 'দয়া করে উত্তর ইনপুট করুন',
    answer_correct: 'সঠিক উত্তরটি নির্বাচন করুন',
    code: 'দয়া করে আপনার কোড ইনপুট করুন',
    criterion: 'দয়া করে মানদন্ডটি ইনপুট করুন',
    duration: 'স্থিতিকাল প্রয়োজন',
    element: 'দয়া করে উপাদান ইনপুট করুন',
    email: 'দয়া করে আপনার ইমেলটি ইনপুট করুন',
    email_invalid: 'ইনপুট করা ইমেল বৈধ নয়',
    feedback_correct: 'দয়া করে প্রতিক্রিয়া সঠিকভাবে ইনপুট করুন',
    feedback_incorrect: 'দয়া করে প্রতিক্রিয়া ভুল ইনপুট করুন',
    host: 'দয়া করে ইভেন্ট পরিচালনাকারী ইনপুট করুন',
    host_assessment: 'দয়া করে মূল্যায়ন পরিচালনাকারী ইনপুট করুন',
    image: 'দয়া করে একটি ছবি আপলোড করুন',
    location: 'দয়া করে আপনার অবস্থানটি ইনপুট করুন',
    live_location: 'দয়া করে সম্প্রচারের একটি জায়গা বেছে নিন',
    limit: 'দয়া করে সরাসরি স্ট্রিমিং মিনিট ইনপুট করুন',
    min_3char: '৩ সর্বনিম্ন অক্ষর',
    number: 'দয়া করে ধনাত্মক সংখ্যা ইনপুট করুন',
    host_email_require: ` পরিচালনাকারীর ইমেলগুলি অবশ্যক `,
    attendee_email_require: ` অংশগ্রহণকারীদের ইমেলগুলি অবশ্যক`,
    name: 'দয়া করে আপনার নাম ইনপুট করুন',
    not_found_course: 'কোর্স পাওয়া যায়নি',
    not_found_event: 'ইভেন্ট পাওয়া যায় নি',
    not_found_assessment: 'মূল্যায়ন পাওয়া যায়নি',
    password: 'দয়া করে আপনার পাসওয়ার্ড ইনপুট করুন',
    password_digit: 'কমপক্ষে একটি সংখ্যা',
    password_short: 'পাসওয়ার্ড খুব ছোট, নূন্যতম ১০ টি অক্ষর',
    password_special: 'কমপক্ষে একটি বিশেষ চিহ্ন',
    password_uppercase: 'কমপক্ষে একটি বড় হাতের অক্ষর',
    password_lowercase: 'কমপক্ষে একটি ছোট হাতের অক্ষর',
    phone: 'দয়া করে আপনার ফোনটি ইনপুট করুন',
    phone_invalid: 'অকার্যকর ফোন নম্বর',
    position: 'দয়া করে আপনার অবস্থান ইনপুট করুন',
    question: 'দয়া করে প্রশ্ন ইনপুট করুন',
    start_date: 'শুরু করার তারিখ & সময় অবশ্যক',
    tag: 'দয়া করে একটি ট্যাগ নির্বাচন করুন',
    topics: 'দয়া করে কমপক্ষে একটি বিষয় নির্বাচন করুন।',
    live_topics: 'দয়া করে বিষয় যুক্ত করুন',
    title: 'দয়া করে শিরোনাম ইনপুট করুন',
    title_assessment: 'দয়া করে মূল্যায়ন শিরোনাম ইনপুট করুন',
    title_course: 'দয়া করে পাঠ্যক্রমের শিরোনাম ইনপুট করুন',
    title_empty: 'শিরোনাম খালি থাকতে পারে না',
    title_event: 'দয়া করে ইভেন্টের শিরোনাম ইনপুট করুন',
    title_lesson: 'দয়া করে পাঠ্য শিরোনাম ইনপুট করুন',
    title_quiz: 'দয়া করে কুইজের নাম ইনপুট করুন',
    username: 'দয়া করে আপনার ব্যবহারকারীর নাম ইনপুট করুন',
    invalid_verification_code: 'এই যাচাইকরণ লিঙ্কটি মেয়াদোত্তীর্ণ হয়েছে বা আর কার্যকর নেই। সাধারণত নতুন কোনো যাচাইকরণ ইমেইল অনুরোধ করা হলে এমনটি ঘটে। আপনার ইমেইল যাচাই করতে Sharelook থেকে আসা সাম্প্রতিকতম ইমেইলটি চেক করুন।',
    upload_error: 'ভুল- ফাইল সামঞ্জস্যপূর্ণ নয়!',
    upload_more_than_10: `আপনি একবারে সর্বোচ্চ ১০ টি ফাইল আপলোড করতে পারবেন' `,
    topics_max: 'দয়া করে সর্বোচ্চ ৩ টি বিষয় যুক্ত করুন',
    upload_excel: 'দয়া করে নিশ্চিত হয়ে নিন যে আপনি সঠিক ফাইলটি আপলোড করেছেন',
    title_excel: 'টেমপ্লেট আপলোড করার সময় ত্রুটি:',
    file_size_exceed: 'ফাইলের আকার অতিক্রম',
    subtitle_excel:
      'দয়া করে নিশ্চিত করুন যে আপনি সরবরাহিত টেম্পলেটটি ব্যবহার করেছেন এবং কলামগুলি সঠিকভাবে পূরণ হয়েছে',
    select_broadcast_option:
      'দয়া করে এই ইভেন্টটি সম্প্রচারের জন্য একটি বিকল্প নির্বাচন করুন',
    multi_hosts_number_error:
      'না। উপস্থাপক এর ইভেন্টের জন্য নির্দিষ্ট চেয়ে অতিক্রম করতে পারে না। ',
    conference_people_number_error: `না। অংশগ্রহণকারীদের ইভেন্টের জন্য নির্দিষ্ট করা ছাড়িয়ে বেশি হতে পারে না’,
   select_max_host: 'ইভেন্টটির জন্য কমপক্ষে 1 টি উপস্থাপক নির্বাচন করুন' ',
   select_max_conference: 'ইভেন্টের জন্য কমপক্ষে 1 জন অংশগ্রহণকারী নির্বাচন করুন',
   stream_stop_error: 'অপ্রত্যাশিতভাবে স্ট্রিমিং বন্ধ হয়ে গেছে!',
   unsecure_context:
     'মারাত্মক ত্রুটি: অনিরাপদ প্রসঙ্গের কারণে ব্রাউজার ক্যামেরা এবং মাইকে অ্যাক্সেস করতে পারে না।দয়া করে এসএসএল ইনস্টল করুন এবং https এর মাধ্যমে অ্যাক্সেস করুন',
   ws_not_supported: 'মারাত্মক ত্রুটি: ওয়েব সকেট এই ব্রাউজারে সমর্থিত নয়'`,
    no_org: 'এগিয়ে যাওয়ার জন্য কমপক্ষে 1 টি সংস্থা নির্বাচন করুন',
    no_org_group: 'এগিয়ে যাওয়ার জন্য কমপক্ষে 1 টি সংগঠন গ্রুপ নির্বাচন করুন',
    waiting_to_join: 'কারও সাথে যোগ দেওয়ার অপেক্ষা!'
  },

  events: {
    title: 'লাইভ ইভেন্টের বিবরণ যুক্ত করুন',
    change_host: 'পরিচালনাকারী পরিবর্তন করুন',
    finished: 'ইভেন্টটি শেষ হয়েছে',
    countdown: 'সরাসরি ইভেন্টটি সম্প্রচারিত হবে ',
    subtitle:
      'আপনার সরাসরি ইভেন্টটির নাম দিন এবং আপনার দর্শকদের এটি থেকে কী শিখার আশা করা উচিত তা বলুন ',
    poll_disabled: 'এই ইভেন্টে ভোটগ্রহণ পাওয়া যায় না',
    disclaimer: ` আমি আশ্বাস দিয়েছি যে আমার রেকর্ড করা অনুষ্ঠানটি হবে না:
    - যে কোন তৃতীয় পক্ষের অধিকার লঙ্ঘন
  - মানহানি সহ, অশ্লীল, অশোভন, দুশ্চরিত্র, অশ্লীল রচনা চিত্র, উগ্র,গা লিগালাজপূর্ণ, অপমানকর, হুমকি দেওয়া বা বৈষম্যমূলক বিষয়বস্তু সহ এমন কোনও অবৈধতা রয়েছে, এমনকি তারকাচিহ্ন দ্বারা ছদ্মবেশযুক্ত
  - অন্যান্য ব্যক্তির উপর কোনও ব্যক্তিগত আক্রমণ রয়েছে
  - অন্যান্য অংশগ্রহণকারী, জনসাধারণের ব্যক্তিত্ব বা সেলিব্রিটিদের কোনও ছদ্মবেশ ধারণ করে
  - এই জাতীয় ব্যক্তির সম্মতি ব্যতীত যে কোনও ব্যক্তির কোনও রেকর্ডিং বা ব্যক্তিগত তথ্য থাকতে পারে এবং বিশ্বের কোন অংশে কোনও তথ্য সুরক্ষা নিয়ন্ত্রণের লঙ্ঘন করছে না
  - যে কোনও বাণিজ্যিক আবেদন বা কোন রকম "স্প্যাম" ধারণ করে”`,
    prompt_message:
      'এই পৃষ্ঠাটি ছেড়ে যাওয়া আপনার ইভেন্টটি শেষ করবে। আপনি কি এই পৃষ্ঠাটি ছেড়ে যাওয়ার বিষয়ে নিশ্চিত?',
    duration_exceed_message:
      'আপনার সম্প্রচারের সময় ছাড়িয়ে গেছে, অ্যাপটি সম্প্রচার বন্ধ করবে',
    before_schedule_message:
      'আপনি নির্ধারিত ইভেন্টের সময়ের আগে সম্প্রচার শুরু করতে চলেছেন। অনুগ্রহ করে নোট করুন যে সম্প্রচারটি থামানো ইভেন্টটি শেষ করবে ',
    browser_unsupportive_message:
      'আপনার ব্রাউজার স্ক্রিন ভাগ সমর্থন করে না। আপনি এই লিঙ্কটিতে সমর্থিত ব্রাউজারগুলি দেখতে পারেন ',
    cancel_switch_host_message:
      'উপস্থাপক উপলব্ধ নয়। আপনি ইভেন্টি যেখান থেকে শেষ করবেন সেখান থেকে অব্যাহত থাকবে.',
    coaching_prompt_message:
      'ইভেন্টটি শেষ না হওয়া পর্যন্ত আপনি এই পৃষ্ঠাটি ছেড়ে যেতে পারবেন না।',
    event_modal_warn: 'আপনি কি এই অনুষ্ঠানটি ছেড়ে যেতে চান?',
    confirm_message: 'আপনি ঠিক আছে ক্লিক করলে আপনার ইভেন্টটি শেষ হবে।',
    screen_share_denied: 'আপনি আপনার স্ক্রিন ভাগ করতে অস্বীকার করেছেন',
    media_not_found:
      'আপনার ডিভাইসে ক্যামেরা বা মাইক পাওয়া যায় না বা অনুমোদিত নয়।',
    media_not_access:
      'ক্যামেরা বা মাইকটি অন্য কোনও প্রক্রিয়া দ্বারা ব্যবহৃত হচ্ছে যা ডিভাইসগুলি পড়তে দেয় না',
    constraint_error:
      'এমন কোনও ডিভাইস পাওয়া যায় নি যা আপনার ভিডিও এবং অডিও সীমাবদ্ধগুলিকে ফিট করে। আপনি ভিডিও এবং অডিও সীমাবদ্ধতা পরিবর্তন করতে পারেন',
    media_access_denied: 'আপনার ক্যামেরা এবং মাইক অ্যাক্সেস করার অনুমতি নেই।'
  },

  filters: {
    days7: 'গত ৭ দিন',
    days15: 'গত ১৫ দিন',
    days30: 'গত ৩০ দিন',
    days365: 'গত ৩৬৫ দিন',
    date: 'তারিখ তৈরি',
    relevance: ' প্রাসঙ্গিকতা ',
    popularity: 'জনপ্রিয়তা',
    name: 'নাম',
    group: 'গ্রুপ',
    Newest_to_Oldest: 'সবচেয়ে নবীনতম থেকে প্রবীণতম',
    Oldest_to_Newest: 'সবচেয়ে প্রবীণতম থেকে নবীনতম ',
    A_Z: 'শুরু থেকে শেষ',
    Z_A: 'শেষ থেকে শুরু '
  },

  helpers: {
    password:
      'আপনার অ্যাকাউন্টের সুরক্ষা নিশ্চিত করতে আমাদের পাসওয়ার্ডে কমপক্ষে একটি ছোট হাতের সংখ্যা প্রয়োজন। আপনারও ন্যূনতম ১০ বর্ণ থাকতে হবে ',
    phone: 'দয়া করে আপনার ফোনে দেশের কোড অন্তর্ভুক্ত করুন: উদাহরণস্বরূপ: ৬৫',
    username:
      'আপনার ব্যবহারকারীর নামটিকে জনসাধারণের তথ্য হিসাবে বিবেচনা করা হয় এবং প্রয়োজনীয় হিসাবে অন্যান্য ব্যবহারকারীদের সাথে ভাগ করা হয়। এর মতো, আমরা আপনাকে সুপারিশ করি যে আপনি আপনার ব্যবহারকারীর নামটিতে ব্যক্তিগত তথ্য ব্যবহার করবেন না ',
    public_description_normal: `আপনার <0><0/> </0> সংরক্ষণ করা হয়েছে এবং এটি ডিফল্টরূপে ব্যক্তিগত হিসাবে বিবেচিত হয়. এর অর্থ হ'ল কেবল আপনি এই সামগ্রীটি দেখতে পারবেন। এই সামগ্রী প্রকাশ করার জন্য আপনি নীচের বিকল্পগুলির মধ্যে একটি নির্বাচন করতে পারেন।আপনার পাঠ্যক্রমটি সর্বজনীনে প্রকাশ করার অর্থ এটি প্ল্যাটফর্মের সমস্ত ব্যবহারকারীর জন্য উপলব্ধ। নির্দিষ্ট ব্যবহারকারীদের বিকল্প আপনাকে নির্দিষ্ট ব্যবহারকারীদের সাথে তাদের শেয়ারলুক অ্যাকাউন্টের সাথে সম্পর্কিত ইমেল ঠিকানা ব্যবহার করে আপনার কোর্স ভাগ করতে সক্ষম করবে।`,
    public_description_admin: `এই <0><0/> </0> সংরক্ষণ করা হয়েছে এবং এটি ডিফল্টরূপে ব্যক্তিগত হিসাবে বিবেচিত হয়। এর অর্থ হ'ল কেবলমাত্র আপনি (এবং সামগ্রী স্রষ্টা) এই সামগ্রীটি দেখতে পাচ্ছেন। এই সামগ্রী প্রকাশ করার জন্য আপনি নীচের বিকল্পগুলির মধ্যে একটি নির্বাচন করতে পারেন। আপনার পাঠ্যক্রমটি জনসমক্ষে প্রকাশ করার অর্থ এটি আপনার সংস্থার বাইরের অংশগুলি সহ - প্ল্যাটফর্মের সমস্ত ব্যবহারকারীদের কাছে উপলব্ধ। এটি সংস্থায় প্রকাশ করার অর্থ হ'ল সংস্থার মধ্যে থাকা সমস্ত ব্যবহারকারীরা এটি দেখতে সক্ষম হবেন।আপনি এটি ১ বা একাধিক গোষ্ঠীতে প্রকাশ করতে পারেন, যার অর্থ কেবলমাত্র সেই গোষ্ঠীর মধ্যে থাকা ব্যবহারকারীরা এটি দেখতে সক্ষম হবেন। 
  শেষ অবধি, আপনার প্রতিষ্ঠানের অভ্যন্তরে এবং বাইরের নির্দিষ্ট ব্যবহারকারীদের তাদের শেয়ারলুক অ্যাকাউন্ট ইমেল ঠিকানা ব্যবহার করে এটি প্রকাশ করার বিকল্প আপনার কাছে রয়েছে '`
  },

  labels: {
    add: 'যুক্ত',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'উত্তরের ধরন',
    answers: 'উত্তর',
    back_to_quiz: 'কুইজের তালিকায় ফিরে যান',
    back_to_question: 'প্রশ্নের তালিকায় ফিরে যান',
    chat: 'কথোপকথন',
    chat_available: 'এই ইভেন্টে কথোপকথন উপলভ্য নয়',
    chat_report: ' কথোপকথন রিপোর্ট ',
    choice_single: 'একক পছন্দ',
    choice_multiple: 'বহু নির্বাচনী',
    choice_free: '" বিনামূল্যে " পছন্দ ',
    choice_sorting: `" শ্রেণীবিভাজন " পছন্দ`,
    choice_matrix: 'ম্যাট্রিক্স বাছাই পছন্দ',
    clone_lesson_permission: 'ক্লোন অনুমতি',
    code: 'কোড',
    correct: 'সঠিক',
    created: 'তারিখ তৈরি',
    clone_modal: 'ক্লোন কোর্স',
    cloning_course: 'ক্লোনিং কোর্স...',
    cloning: 'ক্লোনিং...',
    cloning_course_desc:
      'এই প্রক্রিয়াটি কিছুটা সময় নেবে। দয়া করে ধৈর্য ধরুন',
    cloning_success: 'কোর্স "<0 />" সফলভাবে ক্লোন করা হয়েছে!',
    description: ' বর্ণনা ',
    disclaimer: 'অস্বীকৃতি',
    drop_file: 'ফাইলটি এখানে রেখে দিন...',
    duration: 'সময়কাল',
    edit: 'সম্পাদনা',
    email: 'ইমেল',
    event: 'ইভেন্ট',
    event_all: 'তার সমস্ত অনুষ্ঠান',
    event_date: 'সরাসরি ইভেন্ট স্থানীয় তারিখ / সময়',
    event_this: 'এই ঘটনা',
    expire: 'মেয়াদ শেষ',
    expiry_date: 'সমাপ্তির তারিখ',
    forgot: 'পাসওয়ার্ড ভুলে গেছেন?',
    group: 'দল',
    groups_list: 'দলের তালিকা',
    host: 'পরিচালক',
    id_annotation: 'টিকা আইডি',
    id_quiz: 'কুইজ আইডি',
    incorrect: 'ভুল',
    interests: 'আগ্রহ',
    invited: 'আমন্ত্রিত',
    live_chat: 'সরাসরি আলোচনা',
    live_stream_limit: 'সরাসরি -স্ট্রিমিং মিনিট',
    contact_text:
      'আপনার মাসিক সরাসরি -স্ট্রিমিং সীমাটি পরিবর্তন করতে দয়া করে যোগাযোগ করুন',
    contact_admin:
      '<0>আপনি যদি নিজের মাসিক লাইভ স্ট্রিমিং সীমাটি পরিবর্তন করতে চান তবে যোগাযোগ করুন</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'সরাসরি স্ট্রিমিং মিনিট বাকি: <0>{{ সীমা }}</0> মিনিট<1/><2/> <3>আপনার মাসিক সরাসরি -স্ট্রিমিং সীমাটি পরিবর্তন করতে দয়া করে যোগাযোগ করুন</3> <4>admin@sharelook.com</4>',
    location: 'অবস্থান',
    lessons: 'পাঠ্যধারা গুলি',
    location_broadcast: 'পরিচালনাকারী সার্ভারের অবস্থান',
    location_broadcast_subtitle:
      'অডিওভিজুয়াল দেরি কমাতে সম্প্রচার পরিচালনাকারীর অবস্থানের নিকটতম এমন একটি অবস্থান যুক্ত করুন',
    media_manager: 'মিডিয়া পরিচালক',
    minutes: 'মিনিট',
    name: ' নাম ',
    online_quiz: 'অনলাইন কুইজ',
    organiser: ' লেখক ',
    organization: 'সংগঠন',
    overall_emotion: 'সার্বিক অভিজ্ঞতা:',
    organizations_list: 'প্রতিষ্ঠানের তালিকা',
    password: 'পাসওয়ার্ড',
    participants: 'অংশগ্রহণকারী',
    picture: 'ছবি (১৬: ৯)',
    phone: 'ফোন',
    photo: 'ছবি',
    poll: 'ভোটগ্রহণ',
    position: 'অবস্থান',
    processing: 'প্রক্রিয়াজাতকরণ',
    privacy_settings: 'নিরাপত্তা নির্দিষ্টকরণ',
    question: 'প্রশ্ন',
    quiz_create: 'নতুন কুইজ তৈরি করুন',
    quiz_name: 'কুইজের নাম',
    quiz_update: 'আপডেট কুইজ',
    select_organization: 'একটি সংস্থা নির্বাচন করুন',
    settings: 'সেটিংস',
    show: 'প্রদর্শন',
    show_graph: 'গ্রাফ ফলাফল দেখান',
    signin: 'সাইন ইন করুন',
    signup: 'নিবন্ধন করুন',
    sort_by: 'ক্রমানুসার',
    start_date: 'শুরুর তারিখ',
    tags: ' ট্যাগ',
    terms: 'আমি সম্মত এই <1> শর্তাবলী এবং শর্ত এর সাথে </ 1>।',
    title: 'শিরোনাম',
    topics: 'বিষয় গুলো ',
    topic: 'বিষয়',
    total_comments: 'মোট মন্তব্য',
    username: 'ব্যবহারকারীর নাম',
    users_list: 'ব্যবহারকারীদের তালিকা',
    users_emails: 'নির্দিষ্ট ব্যবহারকারীদের ইমেল প্রবেশ করান ',
    description_specifiction_email:
      'দয়া করে একাধিক নির্দিষ্ট ব্যবহারকারীর সাথে এটি ভাগ করতে প্রতি লাইনে 1 টি ইমেল ঠিকানা দিন',
    message_specific_email:
      'দয়া করে নির্দিষ্ট ব্যবহারকারীর একটি ইমেল প্রবেশ করান',
    viewers: 'দর্শক',
    edit_course: 'সম্পাদনা',
    edit_assessment: 'সম্পাদনা',
    edit_event: 'সম্পাদনা',
    delete_course: 'মুছে ফেলা',
    delete_event: 'মুছে ফেলা',
    delete_assessment: 'মুছে ফেলা',
    view_course: 'দেখুন',
    view_event: 'দেখুন',
    view_assessment: 'দেখুন',
    date_event: 'লাইভ ইভেন্টের তারিখ',
    date_assessment: 'লাইভ মূল্যায়নের তারিখ',
    clone_of: 'ক্লোন',
    clone_course:
      'এই কোর্সের একটি ক্লোন তৈরি করুন যা আপনি আসলটি থেকে স্বতন্ত্রভাবে সংশোধন করতে পারবেন, এতে সমস্ত পাঠ এবং পৃষ্ঠা অন্তর্ভুক্ত করা রয়েছে',
    make: 'তৈরি',
    available_to: 'যে কোনও শেয়ারলুক ব্যবহারকারীর জন্য উপলব্ধ',
    uploaded_by: 'আপলোড করেছেন:',
    course: 'কোর্স',
    assessment: 'মূল্যায়ন',
    user_not_exist:
      'ব্যবহারকারীর অস্তিত্ব নেই, আপনি কি আমন্ত্রণ প্রেরণ করতে চান?',
    check_user: 'নোটিশ',
    user_not_exist_in_org:
      'এই সংস্থাটিতে ব্যবহারকারীর অস্তিত্ব নেই, আপনি কি একটি আমন্ত্রণ প্রেরণ করতে চান?',
    title_modal_stream: 'সংগঠনের লাইভস্ট্রিম সীমা পরিবর্তন করুন',
    des_warning_stream: 'আপনি পরিবর্তন করতে চলেছেন',
    monthly_stream: 'মাসিক লাইভ-স্ট্রিমিং সীমা:',
    min_per_month: 'মিনিট / মাস',
    broadcast_label: 'আমি করতে চাই:',
    hosts_emails: ` নির্দিষ্ট পরিচালকের ইমেল প্রবেশ করান `,
    attendee_emails: ` নির্দিষ্ট অংশগ্রহণকারীর ইমেল প্রবেশ করান `,
    description_host_specifiction_email:
      'দয়া করে প্রতি লাইনে 1 টি ইমেল ঠিকানা লিখুন।',
    presenter_label: 'উপস্থাপক',
    presenter_label_conference: 'না। মানুষ',
    event_privacy: 'কনফারেন্স ধরণ'
  },

  broadcastOptions: {
    stream_from_phone: 'আমার ফোনের সাথে সরাসরি সম্প্রচার',
    other_webrtc: ' আমার পিসি থেকে ওয়েবিনার ',
    multihost: 'আমার পিসি থেকে মাল্টিকাস্ট ওয়েবিনার',
    peer2peer: 'কোচিং এর কাল',
    conference: 'সরাসরি আলাপ-আলোচনা'
  },

  lessoncreate: {
    title: 'পাঠের বিবরণ যুক্ত করুন',
    subtitle:
      'আপনার পাঠের নাম দিন এবং আপনার শ্রোতাদের এ থেকে কী শিখার আশা করা উচিত তা বলুন',
    input_label_title: 'পাঠের শিরোনাম',
    input_label_topics: 'পাঠের বিষয়',
    input_label_description: 'পাঠের বিবরণ',
    delete_warning: 'আপনি কি নিশ্চিত যে আপনি এই পৃষ্ঠাটি মুছতে চান?'
  },

  lessonoverview: {
    title: 'পাঠ যোগ করুন',
    subtitle: 'বিদ্যমান পাঠ যোগ করুন বা একটি নতুন তৈরি করুন',
    new_lesson: 'একটি নতুন পাঠ তৈরি করুন',
    new_lesson_sub: 'স্ক্র্যাচ থেকে একেবারে নতুন পাঠ তৈরি করুন!',
    existing_lesson: 'বিদ্যমান পাঠ নির্বাচন করুন',
    existing_lesson_sub:
      'বিদ্যমান পাঠের সাথে লিঙ্ক, এই পাঠ্যক্রমের পরিবর্তনগুলি অন্যান্য পাঠ্যক্রমগুলিতেও এই পাঠকে প্রভাবিত করবে।',
    clone_lesson: 'বিদ্যমান পাঠের সদৃশ',
    clone_lesson_sub:
      'এই কোর্সে পাঠের একটি অনন্য অনুলিপি তৈরি করুন, এই পাঠ্যে করা পরিবর্তনগুলি মূল পাঠকে প্রভাবিত করবে না।',
    clone_lesson_modal_sub:
      'আপনি যে পাঠ্যক্রমটিতে যোগ করতে চান দয়া করে নীচের ক্লোন বোতামটি ক্লিক করুন।'
  },

  management: {
    groups_title: 'দল পরিচালনা',
    delete_warning: 'তুমি কি নিশ্চিত?',
    organizations_title: 'আমার সংস্থা',
    organizations_subtitle: 'আপনার তালিকায় সংস্থাগুলি যুক্ত করুন',
    users_title: 'ব্যবহারকারীদের ম্যানেজ করুন',
    users_position: 'প্রবীণ অ্যাকাউন্ট ব্যবস্থাপক',
    user_not_found: 'ব্যবহারকারী খুঁজে পাওয়া যায় না',
    select_org:
      'ব্যবহারকারীদের পরিচালনা করতে দয়া করে একটি সংস্থা খুঁজে নিন এবং চয়ন করুন'
  },

  audio: {
    modal_title: 'অডিও প্রবেশ করান',
    list_view: 'তালিকা দেখুন',
    create_audio_modal_title: 'অডিও তৈরি করুন',
    edit_audio_modal_title: 'অডিও সম্পাদনা করুন',
    public_audio_not_found: 'অডিও পাওয়া যায় নি।',
    private_audio_not_found: 'আপনি এখনও কোনও অডিও আপলোড করেননি',
    are_you_sure_to_delete: 'আপনি কি নিশ্চিত মুছতে চান?',
    type_something: 'কিছু লেখো',
    select_voice: 'নির্বাচন',
    file_name: 'ফাইলের নাম',
    description: 'বিবরণ',
    topic: 'বিষয়',
    key_words_tag: 'মূল শব্দসমূহ ট্যাগ',
    mp3_audio: 'এমপি3 অডিও',
    created: 'তৈরি',
    duration: 'সময়কাল',
    close: 'বন্ধ'
  },

  image: {
    modal_title: 'চিত্র প্রবেশ করান',
    image: 'চিত্র',
    pixel: ' পিক্সেল ',
    dimension: 'মাত্রা',
    public_image_not_found: 'ছবিটি খুঁজে পাওয়া যায়নি.',
    private_image_not_found: 'আপনি এখনও কোনও চিত্র আপলোড করেননি'
  },

  annotation: {
    modal_title: 'টিকা'
  },

  text: {
    modal_title: 'টেক্সট সম্পাদক'
  },

  video: {
    modal_title: 'ভিডিওপ্রবেশ করান',
    image: 'ভিডিও',
    mp4_video: 'এমপি 4 ভিডিও',
    public_video_not_found: 'ভিডিও পাওয়া যায় না.',
    private_video_not_found: 'আপনি এখনও কোনও ভিডিও আপলোড করেননি'
  },

  media: {
    title: 'মিডিয়া লাইব্রেরি',
    subtitle: 'আপনার ফাইলগুলির লাইব্রেরি',
    modal_title: 'আপলোড মিডিয়া',
    delete_warning: 'নিশ্চিত বাতিল',
    delete_message:
      'মুছে ফেলা মিডিয়াগুলি এখনও তাদের যে পৃষ্ঠাগুলি ব্যবহার করা হয়েছিল সেখানে উপস্থিত হবে',
    dropzone_text: 'বা টেনে আনুন এবং ফেলে দিন',
    delete_success: 'মিডিয়া সফলভাবে মুছে ফেলা হয়েছে',
    upload_file: 'ফাইল আপলোড করুন',
    drag_drop: 'বা টেনে আনুন এবং ফেলে দিন',
    import_file: 'আপনার কম্পিউটার থেকে ফাইল (গুলি) আমদানি করুন',
    no_media: 'আপনি এখনও কোনও মিডিয়া আপলোড করেননি',
    media_type: 'মিডিয়া ধরন ',
    video: 'ভিডিও',
    transcribed_text: 'Transcribed Text',
    image: 'চিত্র',
    audio: 'অডিও',
    gif: 'গ্রাফিক্স ইন্টারচেঞ্জ ফরম্যাট',
    media_not_found: 'মিডিয়া খুঁজে পাওয়া যায়নি।',
    of: 'এর',
    disclaimer: ` আমি আশ্বাস দিয়েছি যে আমার মিডিয়া তা করে না:
    - যে কোন তৃতীয় পক্ষের অধিকার লঙ্ঘন
    - মানহানি সহ, অশ্লীল, অশোভন, দুশ্চরিত্র, অশ্লীল রচনা চিত্র, উগ্র, গালিগালাজপূর্ণ, অপমানকর, হুমকি দেওয়া বা বৈষম্যমূলক বিষয়বস্তু সহ এমন কোনও অবৈধতা রয়েছে, এমনকি তারকাচিহ্ন দ্বারা ছদ্মবেশযুক্ত
    - অন্যান্য ব্যক্তির উপর কোনও ব্যক্তিগত আক্রমণ রয়েছে
    - অন্যান্য অংশগ্রহণকারী, জনসাধারণের ব্যক্তিত্ব বা সেলিব্রিটিদের কোনও ছদ্মবেশ ধারণ করে
    - এই জাতীয় ব্যক্তির সম্মতি ব্যতীত যে কোনও ব্যক্তির কোনও রেকর্ডিং বা ব্যক্তিগত তথ্য থাকতে পারে এবং বিশ্বের কোন অংশে কোনও তথ্য সুরক্ষা নিয়ন্ত্রণের লঙ্ঘন করছে না
    - যে কোনও বাণিজ্যিক আবেদন বা কোন রকম "স্প্যাম" ধারণ করে”`,
    my_media: 'আমার মিডিয়া',
    public_library: 'গণ গ্রন্থাগার',
    organization_library: 'সংস্থা লাইব্রেরি',
    upload_from_computer: 'কম্পিউটার থেকে আপলোড',
    create: 'সৃষ্টি',
    all: 'সব',
    male: 'পুরুষ',
    female: 'মহিলা',
    processing_audio: 'অডিও প্রসেসিং ',
    create_annotation: 'টীকা তৈরি করুন',
    popup_over_lesson_text: 'টীকাগুলি ক্লিকের পরে পাঠ পৃষ্ঠাতে পপ আপ হবে',
    edit_detail: 'বিশদটি সম্পাদনা করুন',
    delete: 'মুছে ফেলা',
    go_create_audio: 'অডিও তৈরি করুন',
    show_more_details: 'আরও বিশদ প্রদর্শন করুন',
    show_less_details: 'কম বিশদ দেখান',
    drop_files: 'ফাইলগুলি ড্রপ করুন এবং আপলোড করুন',
    or: 'বা',
    import_files: 'কম্পিউটার থেকে ফাইল আমদানি করুন'
  },

  navigation: {
    account: 'অ্যাকাউন্ট',
    assessments: 'মূল্যায়ন',
    dashboard: 'ড্যাশবোর্ড',
    groups: ' গ্রুপ পরিচালনা ',
    logout: ' প্রস্থান',
    organisations: 'সংস্থা',
    organizations_users: 'সংস্থা ও ব্যবহারকারী',
    reports: 'রিপোর্ট',
    schedule: 'তফসিল',
    nowLive: 'সরাসরি সম্প্রচার',
    training: 'প্রশিক্ষণ',
    users: 'ব্যবহারকারী',
    workshop: 'আমার কর্মশালা'
  },

  onboarding: {
    step1_title: 'পদক্ষেপ ১: নিজের সম্পর্কে আমাদের একটু বলুন',
    step1_subtitle: 'আপনার নাম কি? আপনি কোথা থেকে আসছো? আপনার পদমর্যাদা কি?',
    step2_title:
      'পদক্ষেপ ২: আপনি উন্নত করতে পারেন এমন কিছু দক্ষতা নির্বাচন করুন',
    step2_subtitle:
      'এরপরে, আপনি কী আরও ভালভাবে বুঝতে চান তা আমাদের বলুন।সম্ভবত আপনার এখনও বাছাই কিছু আছে?? পড়াশোনার নতুন ক্ষেত্র? আপনার প্রিয়জন কি করেন?'
  },

  pagebuilder: {
    title: 'পাঠ তৈরি করুন',
    subtitle:
      'আপনার কাছ থেকে শেখার জন্য দর্শকদের জন্য সামগ্রী তৈরি করার সময়, আপনি ছবি, ভিডিও এবং ইনফোগ্রাফিক্স করতে পারেন',
    select_layout: 'একটি পৃষ্ঠা বিন্যাস নির্বাচন করুন',
    template1: 'ফাঁকা',
    template2: 'শিরোনাম & উপশিরোনাম',
    template3: 'শিরোনাম & পাঠ্য',
    template4: 'শিরোনাম, মিডিয়া & পাঠ্য',
    template5: 'শিরোনাম & মিডিয়া',
    template6: 'শিরোনাম & কুইজ'
  },

  pageconstructor: {
    title: 'পাঠ তৈরি করুন এবং ক্লোন করুন',
    subtitle:
      'আপনার কাছ থেকে শেখার জন্য দর্শকদের জন্য সামগ্রী তৈরি করার সময়, আপনি ছবি, ভিডিও এবং ইনফোগ্রাফিকগুলি যুক্ত করতে পারেন'
  },

  passwordreset: {
    success_coded:
      'আপনার প্রদত্ত ঠিকানায় আমরা একটি নিশ্চিতকরণ কোড ইমেল করেছি, দয়া করে একটি নতুন পাসওয়ার্ড সেট করতে নীচের ক্ষেত্রটিতে কোডটি অনুলিপি করুন।',
    success_changed:
      'আপনি সফলভাবে একটি নতুন পাসওয়ার্ড সেট করেছেন। আপনি এখন সাইন ইন করতে পারেন।'
  },

  placeholders: {
    search: 'অনুসন্ধান',
    answer: 'উত্তর',
    chat: 'কিছু বল...',
    code: 'কোড',
    criterion: 'মানদণ্ড',
    date_event: 'তারিখ & সময় নির্বাচন করুন',
    date_start: ' শুরুর তারিখ',
    date_expire: 'সমাপ্তির তারিখ',
    description: 'বিবরণ',
    elements: 'উপাদান বাছাই করুন',
    email: 'ইমেল',
    feedback_correct: 'প্রতিক্রিয়া সঠিক',
    feedback_incorrect: 'প্রতিক্রিয়া ভুল',
    host: ' উপস্থাপক ',
    keywords: 'কীওয়ার্ড (গুলি) অনুসন্ধান',
    lesson_description: 'পাঠের বিবরণ',
    location: 'অবস্থান',
    minutes: 'মিনিট',
    name: 'নাম',
    organiser: 'লেখক',
    organization: 'সংগঠন',
    password: 'পাসওয়ার্ড',
    phone: 'ফোন',
    photo: 'ছবি',
    picture: 'ছবি',
    point: 'পয়েন্ট',
    position: 'অবস্থান',
    question: 'প্রশ্ন',
    quiz: 'কুইজের নাম',
    search_course: 'কোর্স দ্বারা অনুসন্ধান',
    search_media: 'মিডিয়া অনুসন্ধান ',
    search_name: 'নাম দ্বারা অনুসন্ধান',
    search_title: 'শিরোনাম অনুসারে অনুসন্ধান করুন',
    search_training: 'অনুসন্ধান',
    settings: 'সেটিংস',
    tags: 'ট্যাগ',
    title: 'শিরোনাম',
    topics: 'বিষয়',
    username: 'ব্যবহারকারীর নাম',
    keyword: 'কীওয়ার্ডস',
    max_500_characters: 'সর্বোচ্চ ৫০০ টি অক্ষর ',
    no_description: 'এই ফাইলটির কোনও বিবরণ নেই',
    no_keyword: 'এই ফাইলটির কোনও কীওয়ার্ড নেই',
    no_topics: 'এই ফাইলটিতে কোন বিষয় সেট করা নেই',
    feedback: 'বার্তা',
    contact: 'আমরা কীভাবে সাহায্য করতে পারি?'
  },

  publishsettings: {
    title: 'প্রকাশিত সেটিংস',
    event_subtitle:
      'আপনার ইভেন্টে সেটিংস যুক্ত করুন, যারা আপনার ইভেন্টটি দেখতে ও তার সাথে ইন্টারঅ্যাক্ট করতে পারে',
    assessment_subtitile:
      'আপনার মূল্যায়নের নাম দিন এবং আপনার শ্রোতাদের এ থেকে কী শিখার আশা করা উচিত তা বলুন ',
    course_subtitle:
      'আপনার কোর্সে সেটিংস যুক্ত করুন, কে আপনার পাঠ্যক্রমটি দেখতে এবং তার সাথে ইন্টারঅ্যাক্ট করতে পারে',
    disclaimer: `1.	নিবন্ধন

  একজন ব্যবহারকারী হিসাবে নিবন্ধন করে / একটি অ্যাকাউন্ট তৈরি করে আপনি আমাদের [ব্যবহারকারীর চুক্তিতে] সম্মত হন এবং আমাদের [গোপনীয়তা নীতি] পড়ার বিষয়টি স্বীকার করেন


  2.	কোর্স তৈরি করুন

  আমাদের সরঞ্জামগুলি ব্যবহার করে এবং কোর্স সামগ্রী তৈরি করে আপনি আমাদের [ব্যবহারকারীর চুক্তিতে] সম্মত হন এবং আমাদের [গোপনীয়তা নীতি] পড়ার বিষয়টি স্বীকার করেন


  3.	ইভেন্ট তৈরি

  আমাদের সরঞ্জামগুলি ব্যবহার করে এবং একটি ইভেন্ট তৈরি করে আপনি আমাদের [ব্যবহারকারীর চুক্তিতে] সম্মত হন এবং আমাদের [গোপনীয়তা নীতি] পড়ার বিষয়টি স্বীকার করেন

  4.	মূল্যায়ন তৈরি

  আমাদের সরঞ্জামগুলি ব্যবহার করে এবং একটি মূল্যায়ন তৈরি করে আপনি আমাদের [ব্যবহারকারীর চুক্তিতে] সম্মত হন এবং আমাদের [গোপনীয়তা নীতি] পড়ার বিষয়টি স্বীকার করেন`,
    dates_validation_error: 'উভয় তারিখ পূরণ করা উচিত।',
    course_dates_validation_error: 'অনুগ্রহ করে এই কোর্সের শুরু এবং মেয়াদ শেষ হওয়ার তারিখ লিখুন।',
    emails_validation_error: 'ইমেল তালিকাটি অবৈধ।',
    specific_email_validation_error: 'কেবল একটি ইমেল অনুমোদিত।',
    i_agree_to_these: 'আমি এগুলির সাথে একমত ',
    terms_and_conditions: 'শর্তাদি & শর্তাবলী.',
    PublicDescription: `বিনামূল্যে স্বাধীন ব্যবহারকারী: (ব্যক্তিগত এবং পাবলিক বিকল্প) আপনার [কোর্স | ইভেন্ট | মূল্যায়ন] সংরক্ষণ করা হয়েছে এবং এটি ডিফল্টরূপে ব্যক্তিগত হিসাবে বিবেচনা করা হয়। এর অর্থ হ'ল কেবল আপনি এই সামগ্রীটি দেখতে পারবেন। এই সামগ্রীটি প্রকাশ করার জন্য আপনি নীচে সর্বজনীন নির্বাচন করতে পারেন। এর অর্থ হল এই কোর্সটি প্ল্যাটফর্মের সমস্ত ব্যবহারকারীর জন্য উপলব্ধ হবে। `,
    OrganisationsDescription: `প্রতিষ্ঠানের ব্যবহারকারীরা: ((পরিবর্তে"" সমাপ্ত "" ব্যবহার "" প্রকাশ করুন ""এবং এটিকে অন্য ব্যবহারকারীর মতো প্রকাশের পৃষ্ঠায় নিয়ে আসুন তবে প্রকাশের কোনও বিকল্প ছাড়াই।)আপনার [কোর্স | ইভেন্ট | মূল্যায়ন] সংরক্ষণ করা হয়েছে এবং এটি ব্যক্তিগত। এর অর্থ হ'ল কেবলমাত্র আপনি এবং আপনার প্রতিষ্ঠানের প্রশাসকরা এটি দেখতে পারবেন।একজন ব্যবহারকারী হিসাবে, আপনি নিজের সংস্থাগুলির মধ্যেই আপনার সামগ্রী প্রকাশ করতে সক্ষম হবেন না কারণ এর জন্য প্রশাসকের অধিকারের প্রয়োজন হয়। দয়া করে আপনার প্রশাসকের একজনের সাথে যোগাযোগ করুন এবং তাদের আপনার সামগ্রীতে প্রকাশ্যভাবে পুরো সংস্থাতে, আপনার সংস্থার নির্দিষ্ট গ্রুপগুলিতে বা নির্দিষ্ট ব্যবহারকারীদের কাছে প্রকাশ করতে বলুন।`,
    OrganisationGroupsDescription: `সংস্থা প্রশাসন: (প্রতিষ্ঠানের মধ্যে তৈরি সামগ্রীর জন্য: ব্যক্তিগত, পাবলিক, সংস্থা, গ্রুপ, নির্দিষ্ট ব্যবহারকারী):এই [কোর্স | ইভেন্ট | মূল্যায়ন] সংরক্ষণ করা হয়েছে এবং এটি ডিফল্টরূপে ব্যক্তিগত হিসাবে বিবেচনা করা হয়। এর অর্থ হ'ল কেবলমাত্র আপনি (এবং সামগ্রী স্রষ্টা) এই সামগ্রীটি দেখতে পাচ্ছেন। এই সামগ্রী প্রকাশ করার জন্য আপনি নীচের বিকল্পগুলির মধ্যে একটি নির্বাচন করতে পারেন। আপনার পাঠ্যক্রমটি জনসমক্ষে প্রকাশ করার অর্থ এটি আপনার সংস্থার বাইরের অংশগুলি সহ - প্ল্যাটফর্মের সমস্ত ব্যবহারকারীদের কাছে উপলব্ধ। এটি সংস্থায় প্রকাশ করার অর্থ হ'ল সংস্থার মধ্যে থাকা সমস্ত ব্যবহারকারীরা এটি দেখতে সক্ষম হবেন।আপনি এটি ১ বা একাধিক গোষ্ঠীতে প্রকাশ করতে পারেন, যার অর্থ কেবলমাত্র সেই গোষ্ঠীর মধ্যে থাকা ব্যবহারকারীরা এটি দেখতে সক্ষম হবেন। শেষ অবধি, আপনার নিজের প্রতিষ্ঠানের ভিতরে এবং বাইরে নির্দিষ্ট ব্যবহারকারীদের কাছে তাদের শেয়ারলুক অ্যাকাউন্ট ইমেল ঠিকানা ব্যবহার করে প্রকাশ করার বিকল্প রয়েছে।`,
    SpecificUsersDescription: `পরিশোধিত স্বতন্ত্র ব্যবহারকারী: (ব্যক্তিগত, সরকারী এবং নির্দিষ্ট ব্যবহারকারী)আপনার [কোর্স | ইভেন্ট | মূল্যায়ন] সংরক্ষণ করা হয়েছে এবং এটি ডিফল্টরূপে ব্যক্তিগত হিসাবে বিবেচনা করা হয়। এর অর্থ হ'ল কেবল আপনি এই সামগ্রীটি দেখতে পারবেন। এই সামগ্রী প্রকাশ করার জন্য আপনি নীচের বিকল্পগুলির মধ্যে একটি নির্বাচন করতে পারেন।আপনার পাঠ্যক্রমটি সর্বজনীনে প্রকাশ করার অর্থ এটি প্ল্যাটফর্মের সমস্ত ব্যবহারকারীর জন্য উপলব্ধ। নির্দিষ্ট ব্যবহারকারীদের বিকল্প আপনাকে নির্দিষ্ট ব্যবহারকারীদের সাথে তাদের শেয়ারলোক অ্যাকাউন্টের সাথে সম্পর্কিত ইমেল ঠিকানা ব্যবহার করে আপনার কোর্স ভাগ করতে সক্ষম করবে।' }`,

    quiz: {
      quiz_empty: 'আপনি এখনও একটি কুইজ তৈরি করেন নি',
      questions_empty: 'আপনি এখনও একটি প্রশ্ন তৈরি করেন নি'
    },

    regions: {
      asia_pacific_australia: 'অস্ট্রেলিয়া',
      asia_pacific_india: 'ভারত',
      asia_pacific_japan: 'জাপান',
      asia_pacific_s_korea: 'দক্ষিণ কোরিয়া',
      asia_pacific_singapore: ' সিঙ্গাপুর ',
      asia_pacific_taiwan: 'তাইওয়ান',
      eu_belgium: 'বেলজিয়াম',
      eu_germany: 'জার্মানি',
      eu_ireland: 'আয়ারল্যান্ড',
      south_america_brazil: 'ব্রাজিল',
      us_central_iowa: 'আইওয়া',
      us_east_s_carolina: 'দক্ষিণ ক্যারোলিনা',
      us_east_virginia: 'ভার্জিনিয়া',
      us_west_california: 'ক্যালিফোর্নিয়া',
      us_west_oregon: 'ওরেগন'
    },

    reports: {
      title: 'প্রতিবেদন',
      workshop_report: 'কর্মশালা  বিবরণ',
      user_report: ' ব্যবহারকারী বিবরণ',
      organization_workshop: 'প্রতিষ্ঠানের কর্মশালা ',
      course: ' কোর্স ',
      live_event: 'সরাসরি ঘটনা',
      workShop_graph: 'কর্মশালা গ্রাফ',
      organization_account: 'সংস্থার হিসাব',
      all: ' সব ',
      name: 'নাম',
      id_number: 'আইডি নাম্বার',
      email: 'ইমেল',
      search_user_report: 'ব্যবহারকারী প্রতিবেদন অনুসন্ধান করুন',
      participant: 'অংশগ্রহণকারী',
      participants: 'অংশগ্রহণকারীরা',
      host: 'উপস্থাপক',
      username: 'ব্যবহারকারীর নাম',
      event: 'ঘটনা',
      quiz: 'কুইজ',
      assessment: 'মূল্যায়ন',
      time: 'সময়',
      no_recent_activity: 'কোনও সাম্প্রতিক কার্যকলাপ নেই',
      workshops: 'কর্মশালা',
      courses: 'পাঠ্যধারাগুলি',
      live_events: 'সরাসরি অনুষ্ঠান',
      live_assessments: 'সরাসরি মূল্যায়ন',
      quizzes: 'কুইজস',
      overview: 'পরিদর্শন',
      by: 'দ্বারা',
      views: 'দর্শন',
      status: 'স্থিতি',
      poll: 'ভোটগ্রহণ',
      comment: 'মন্তব্য',
      comments: 'মন্তব্য',
      no_comments: 'কোন মন্তব্য নেই',
      no_polls: 'কোনও পোল নেই',
      live_date: 'লাইভ তারিখ',
      score: 'স্কোর',
      question: 'প্রশ্ন',
      submit: 'জমা দিন',
      recent_activity: 'সাম্প্রতিক কার্যকলাপ',
      ago: 'আগে',
      no_data_found: 'কোনও ডেটা পাওয়া যায় নি',
      start_end_live: 'লাইভ শুরু / শেষ করুন',
      join_leave_date: `যোগদান / ছেড়ে দিন'`,
      watched_time: 'প্রহরী সময়',
      complete: 'সম্পূর্ণ',
      in_complete: 'অসম্পূর্ণ',
      today: 'আজ',
      seven_days: '7 দিন',
      last_month: 'গত মাসে',
      one_year: '1 বছর',
      all_time: 'সব সময়',
      report: 'প্রতিবেদন',
      from_date: 'তারিখ হইতে',
      to_date: 'এখন পর্যন্ত',
      all_workshop: 'সমস্ত কর্মশালা',
      all_participants: 'সমস্ত অংশগ্রহণকারী',
      live_assessment: 'সরাসরি মূল্যায়ন',
      users: 'ব্যবহারকারীরা',
      download: 'ডাউনলোড করুন',
      recent: 'সাম্প্রতিক',
      WorkShop: 'কর্মশালা',
      Activity: 'ক্রিয়াকলাপ',
      created_date: 'তৈরীর তারিখ',
      lessons: 'পাঠ',
      lesson: 'পাঠ',
      completed: 'সমাপ্ত',
      report_download: 'রিপোর্ট ডাউনলোড',
      this_month: 'এই মাস',
      search_course: 'কোর্স অনুসন্ধান',
      participants_graph: 'অংশগ্রহণকারীদের গ্রাফ',
      viewed: 'দেখা হয়েছে',
      enrolled: 'তালিকাভুক্ত',
      description: 'বর্ণনা',
      topic: 'বিষয়',
      analytic: 'বিশ্লেষক',
      quiz_list: 'কুইজ তালিকা',
      select_one: 'একটা নির্বাচন করুন',
      group_status: 'গ্রুপের অবস্থা',
      duration_min: 'সময়কাল (মিনিট)',
      submit_poll: ' ভোট জমা দিন',
      download_events: 'ইভেন্টগুলি ডাউনলোড করুন',
      search_event: 'ইভেন্ট অনুসন্ধান',
      duration: 'সময়কাল',
      total_participants: 'মোট অংশগ্রহণকারীরা',
      message: 'বার্তা',
      avg_message: 'গড় বার্তা',
      per_message: 'বার্তা / ইভেন্টের একটি স্থিরতা'
    },

    signup: {
      success_step1:
        'আপনার সরবরাহিত ঠিকানায় আমরা একটি যাচাইকরণ কোড ইমেল করেছি, দয়া করে আপনার নিবন্ধকরণটি নিশ্চিত করতে নীচের ক্ষেত্রের মধ্যে কোডটি অনুলিপি করুন।',
      success_step2: 'ধন্যবাদ আপনি সফলভাবে নিবন্ধিত।',
      privacy: ` আমি সম্মত শেয়ারলুকের <1> শর্তাবলী & শর্ত </1> এবং <3> গোপনীয়তা নীতিতে </3>`
    },

    stream: {
      emotion_impressive: 'চিত্তাকর্ষক',
      emotion_unimpressive: 'আকর্ষণহীন',
      message_not_started: 'শীঘ্রই আসছে',
      message_running: 'সরাসরি',
      message_processing:
        'আমরা বর্তমানে প্লেব্যাকের জন্য লাইভ রেকর্ডিং প্রক্রিয়াজাত করছি। ভিডিওটি দেখতে এবং রেটিং এবং প্রতিক্রিয়া যোগ করে যেতে দয়া করে পরে আবার চেক করুন'
    },

    tabs: {
      audience: 'শ্রোতা',
      course: 'কোর্স পরিদর্শন ',
      details: 'সরাসরি ইভেন্টের বিবরণ',
      description: 'বর্ণনা',
      host: 'উপস্থাপক',
      lesson: 'পাঠ পরিদর্শন',
      lessons: 'পাঠ',
      overview: 'পরিদর্শন',
      page: 'পৃষ্ঠা নির্মাতা',
      publish: 'প্রকাশ',
      settings: 'সেটিং প্রকাশ করুন',
      total_views: ' সব দেখা',
      live_participates: 'সরাসরি অংশগ্রহণকারী',
      live_chats: 'সরাসরি চ্যাট',
      live_quiz: 'সরাসরি ভোটগ্রহণ',
      trainer_rating: 'ট্রেনার রেটিং',
      trainer_times: 'ট্রেনার সময়',
      courses_quizzes: 'কোর্স কুইজ',
      user_list: 'ব্যবহারকারীর তালিকা',
      discussion: 'আলোচনা',
      notes: 'আমার নোট'
    },

    topics: {
      SALES_TRAINING: 'বিক্রির প্রশিক্ষণ',
      NEGOTIATION_TRAINING: 'আলোচনার প্রশিক্ষণ',
      CROSS_CULTURAL_AWARENESS: 'আন্তঃ-সাংস্কৃতিক সচেতনতা',
      NETWORKING_SKILLS: 'নেটওয়ার্কিং দক্ষতা',
      SOFTWARE_ARCHITECTURE: 'সফটওয়্যার আর্কিটেকচার',
      PROJECT_MANAGEMENT: 'প্রকল্প পরিচালনা',
      DIGITAL_TRANSFORMATION: 'ডিজিটাল রূপান্তর',
      IT_CONSULTING: 'আইটি পরামর্শদাতা',
      MANAGEMENT_CONSULTING: 'ব্যবস্থাপনা পরামর্শ',
      HR_CONSULTING: 'এইচআর পরামর্শদাতা',
      INTERNET_OF_THINGS: 'ইন্টারনেট অফ থিংস (আইওটি)',
      CYBERSECURITY: 'সাইবার নিরাপত্তা',
      PRIVACY_AND_GDRP: 'গোপনীয়তা এবং সাধারণ তথ্য সুরক্ষা নিয়ন্ত্রণ'
    },

    training: {
      title: 'প্রশিক্ষণ',
      title_assessment: 'মূল্যায়ন',
      subtitle: 'কোর্স এবং সরাসরি ইভেন্ট',
      enrolled_title: 'তালিকাভুক্ত কোর্স এবং সরাসরি ইভেন্ট',
      enrolled_subtitle: 'আপনার নথিভুক্ত লাইভ ইভেন্টগুলি এবং কোর্স ',
      enrolled_message: 'আপনি বর্তমানে কোনও কোর্স এবং ইভেন্টে ভর্তি নন।',
      past_live_event_title: 'বিগত সরাসরি ইভেন্ট',
      past_live_event_subTitle: 'সমাপ্ত লাইভ ইভেন্ট',
      past_live_event: 'বর্তমানে কোনও বিগত লাইভ ইভেন্ট নেই',
      recomended_title: 'প্রস্তাবিত কোর্স এবং সরাসরি ইভেন্ট',
      now_live_event_title: 'এখন সরাসরি ',
      now_live_event_subTitle: 'ইভেন্টগুলি সরাসরি বা খুব শীঘ্রই হবে',
      now_live_event: 'বর্তমানে কোনও সরাসরি ইভেন্ট নেই',
      webinar_event_title: 'ওয়েবিনার চ্যানেল',
      webinar_event_subTitle: 'সমাপ্ত ওয়েবিনারস',
      webinar_event: 'বর্তমানে কোনও ওয়েবিনার নেই',
      p2p_event_title: 'কোচিং এর সময়কাল',
      p2p_event_subTitle: 'সমাপ্ত কোচিং এর সময়কাল',
      p2p_event: 'বর্তমানে কোনও কোচিং সেশন নেই।',

      now_live_assessment_title: 'এখন সরাসরি',
      now_live_assessment_subTitle: 'মূল্যায়ন যা সরাসরি হয় বা খুব শীঘ্রই হবে',
      now_live_assessment_message: 'বর্তমানে কোনও সরাসরি মূল্যায়ন নেই',

      upcoming_assessment_title: 'আসন্ন সরাসরি মূল্যায়ন',
      upcoming_assessment_subtitle: 'আসন্ন সরাসরি মূল্যায়ন',
      upcoming_assessment_message: 'বর্তমানে কোনও আসন্ন সরাসরি মূল্যায়ন নেই।',

      past_live_assessment_title: 'বিগত সরাসরি মূল্যায়ন',
      past_live_assessment_subTitle: 'সমাপ্ত লাইভ মূল্যায়ন',
      past_live_assessment_message: 'বর্তমানে কোনও অতীত সরাসরি মূল্যায়ন নেই',

      /**
       * <0/> get index 0 of data from Trans component
       * exp -->
       * <Trans i18nKey='training:recomended_subtitle' >
       *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
       *    <h1>{...something}</h1> --> is index 1 of Trans component
       * </Trans>
       */
      recomended_subtitle:
        'আপনার <0><0/> </0> এর উপর ভিত্তি করে আমরা কিউরেটেড কোর্স এবং লাইভ ইভেন্ট করেছি',
      /**
       * and we also can get data from index to replace in recommended_subtitle by like above string.
       * for exp -->
       * at the end of the recomended_subtitle above will get data from index of component to display
       * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
       */
      search: 'প্রশিক্ষণ অনুসন্ধান ',
      search_assessment: 'মূল্যায়ন অনুসন্ধান ',
      recomended_message: 'বর্তমানে কোনও প্রস্তাবিত কোর্স এবং ইভেন্ট নেই।'
    },

    warnings: {
      delete: 'তুমি কি নিশ্চিত?'
    },

    workshop: {
      title: 'আমার কর্মশালা',
      subtitle:
        'একটি কোর্স তৈরি করুন বা আপনার নিজের একটি সরাসরি ইভেন্ট হোস্ট করুন',
      new_course: 'একটি নতুন কোর্স তৈরি করুন',
      new_event: 'একটি নতুন সরাসরি ইভেন্ট তৈরি করুন',
      new_assessment: 'একটি নতুন সরাসরি মূল্যায়ন তৈরি করুন',
      courses_title: 'তৈরি কোর্স & সরাসরি ইভেন্ট',
      courses_subtitle: `সম্পাদনা করুন & আপনার তৈরি কোর্সটি প্রকাশ করুন এবং সরাসরি ইভেন্টগুলির পরিকল্পনা করুন`,
      tags_course: 'কোর্স',
      tags_live: 'সরাসরি ঘটনা',
      tags_assessment: 'সরাসরি মূল্যায়ন'
    },

    help_center: {
      sidebar: {
        title: 'কিভাবে আমরা আপনাকে সাহায্য করতে পারে?',
        back_to: ' ড্যাশবোর্ড '
      },
      menu: {
        help_center: 'সাহায্য কেন্দ্র',
        whats_new: ' কী নতুন ',
        feedback: 'শেয়ারলুকে মতামত পাঠান',
        feedback_title: 'শেয়ারলুকে মতামত পাঠান',
        terms_and_conditions: 'শর্তাবলী & শর্তাদি',
        privacy_policy: 'গোপনীয়তা নীতি',
        contact_us: 'যোগাযোগ করুন'
      },
      get_started: {
        title: 'শেয়ারলুক এর সাথে শুরু করুন',
        description: {
          main: `আমরা সহজেই ব্যবহারের জন্য কোর্স বিল্ডারের সাথে সরাসরি ভিডিওটি সংযুক্ত করেছি`,
          tagline:
            'শেয়ারলুকের পেটেন্টযুক্ত লাইভ ব্রডকাস্ট সিস্টেমের সাহায্যে আপনি বাগদান তৈরি করতে পারেন, শিখনকে স্বয়ংক্রিয় করতে এবং জ্ঞান ভাগাভাগি করতে পারেন।'
        }
      },
      whats_new: {
        title: 'শেয়ারলুক এর সাথে শুরু করুন',
        description: {
          main: `আপনি কি জানেন যে গল্প বলার স্টাইল লার্নিং অল্প সময়ে তৈরি করতে পারে এবং এত ব্যয়বহুল নয়? আপনার শেয়ারলুক কোর্স নির্মাতা এবং সংশ্লিষ্ট প্রতিভা একত্রিত করা উচিত। আপনি আমাদের জিজ্ঞাসা করতে পারেন "কিভাবে"`,
          tagline: ''
        }
      },
      create_workshop: 'কিভাবে একটি ওয়ার্কশপ তৈরি করা যায়',
      create_course: 'একটি কোর্স কিভাবে তৈরি করা যায়',
      create_user: 'কীভাবে একটি ব্যবহারকারী তৈরি করা যায়',
      create_group: 'কীভাবে একটি গ্রুপ তৈরি করা যায়',
      create_webinar: 'কীভাবে ওয়েবিনার তৈরি করা যায়',
      create_live_event: 'সরাসরি ইভেন্ট কীভাবে তৈরি করা যায়',
      create_live_assessment: 'সরাসরি মূল্যায়ন কীভাবে তৈরি করা যায়',
      create_live_on_mobile: 'মোবাইলে লাইভ তৈরি করুন',
      personalize_profile: 'ব্যক্তিগতকৃত একটি প্রোফাইল ',
      manage_group: 'গ্রুপ পরিচালনা',
      report: 'রিপোর্ট',
      add_annotations: 'টিকা / পপআপ কীভাবে যুক্ত করা যায়',
      add_audio: 'কীভাবে অডিও যুক্ত করা যায়',
      add_header_and_footer: 'শিরোনাম & পাদচরণ যুক্ত করা',
      add_image: 'কীভাবে ছবি যুক্ত করা যায়',
      add_quiz_content: 'কুইজ সামগ্রী কীভাবে যুক্ত করা যায়',
      add_text_content: 'পাঠ্য সামগ্রী কীভাবে যুক্ত করা যায়',
      add_user: 'কীভাবে ব্যবহারকারী যুক্ত করা যায়',
      add_video: 'কীভাবে ভিডিও যুক্ত করা যায়',
      clone_course: 'কোর্স ক্লোন কিভাবে',
      find_live_broadcast: 'সরাসরি ব্রডকাস্ট কীভাবে সন্ধান করবেন',
      contact_us: {
        title: 'যোগাযোগ করুন',
        subject_placeholder: 'একটি বিষয় লিখুন *',
        content_placeholder: 'একটি বার্তা লিখুন *',
        subject_required: '* বিষয় প্রয়োজন ',
        content_required: '* বার্তা প্রয়োজন ',
        submit: 'প্রেরণ',
        cancel: 'বাতিল',
        sent: 'প্রেরিত'
      },
      feedback: {
        title: ' মতামত শেয়ার করুন শেয়ারলুকে ',
        attach_title: 'একটি নথি যোগ করুন',
        choose: 'ফাইল পছন্দ করুন',
        detail: 'ফাইলটি সহায়তা দলের সাথে ভাগ করা হবে',
        content_placeholder: 'একটি বার্তা লিখুন *',
        content_required: '* বার্তা প্রয়োজন ',
        submit: 'প্রেরণ',
        cancel: 'বাতিল',
        sent: 'প্রেরিত'
      }
    },
    discussion: {
      join_discussion: 'আলোচনায় যোগ দিন'
    },
    notes: {
      title: 'আমার নোট',
      add_note: 'নতুন নোট যুক্ত করুন'
    }
  }
}
